/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './_routes/__root'
import { Route as PublicRouteImport } from './_routes/_public'
import { Route as PrivateRouteImport } from './_routes/_private'
import { Route as TestRouteRouteImport } from './_routes/test/route'
import { Route as IndexRouteImport } from './_routes/index'
import { Route as AuthIndexRouteImport } from './_routes/auth/index'
import { Route as PrivateTeamMembersTemplateRouteImport } from './_routes/_private.team-members/_template'
import { Route as PrivateInventoryTemplateRouteImport } from './_routes/_private.inventory/_template'
import { Route as PrivateContactsTemplateRouteImport } from './_routes/_private.contacts/_template'
import { Route as PrivateCompetitorsTemplateRouteImport } from './_routes/_private.competitors/_template'
import { Route as PrivateCompaniesTemplateRouteImport } from './_routes/_private.companies/_template'
import { Route as PrivateAgreementsTemplateRouteImport } from './_routes/_private.agreements/_template'
import { Route as PrivateTeamMembersNewRouteRouteImport } from './_routes/_private.team-members/new/route'
import { Route as PrivateSystemUsersIdRouteRouteImport } from './_routes/_private.system-users/$id/route'
import { Route as PrivateSupportTicket_idRouteRouteImport } from './_routes/_private.support/$ticket_id/route'
import { Route as PrivateSettingsViewLogsRouteRouteImport } from './_routes/_private.settings/view-logs/route'
import { Route as PrivateSettingsRevenueAllocationLockdownOverrideLogsRouteRouteImport } from './_routes/_private.settings/revenue-allocation-lockdown-override-logs/route'
import { Route as PrivateRecruitingNewRouteRouteImport } from './_routes/_private.recruiting/new/route'
import { Route as PrivateRecruitingIdRouteRouteImport } from './_routes/_private.recruiting/$id/route'
import { Route as PrivateProductsAndServicesNewRouteRouteImport } from './_routes/_private.products-and-services/new/route'
import { Route as PrivateProductsAndServicesIdRouteRouteImport } from './_routes/_private.products-and-services/$id/route'
import { Route as PrivatePickTicketsNewRouteRouteImport } from './_routes/_private.pick-tickets/new/route'
import { Route as PrivatePickTicketsIdRouteRouteImport } from './_routes/_private.pick-tickets/$id/route'
import { Route as PrivatePendingDepositsIdRouteRouteImport } from './_routes/_private.pending-deposits/$id/route'
import { Route as PrivateMarketingCampaignsNewRouteRouteImport } from './_routes/_private.marketing-campaigns/new/route'
import { Route as PrivateMarketingCampaignsIdRouteRouteImport } from './_routes/_private.marketing-campaigns/$id/route'
import { Route as PrivateInvoicesNewRouteRouteImport } from './_routes/_private.invoices/new/route'
import { Route as PrivateInvoicesIdRouteRouteImport } from './_routes/_private.invoices/$id/route'
import { Route as PrivateInventoryParentNewRouteRouteImport } from './_routes/_private.inventory/parent-new/route'
import { Route as PrivateInventoryNewRouteRouteImport } from './_routes/_private.inventory/new/route'
import { Route as PrivateGovernanceNewRouteRouteImport } from './_routes/_private.governance/new/route'
import { Route as PrivateGovernanceIdRouteRouteImport } from './_routes/_private.governance/$id/route'
import { Route as PrivateFinancialSnapshotsNewRouteRouteImport } from './_routes/_private.financial-snapshots/new/route'
import { Route as PrivateFinancialSnapshotsIdRouteRouteImport } from './_routes/_private.financial-snapshots/$id/route'
import { Route as PrivateDomainsNewRouteRouteImport } from './_routes/_private.domains/new/route'
import { Route as PrivateDomainsIdRouteRouteImport } from './_routes/_private.domains/$id/route'
import { Route as PrivateDepositsNewRouteRouteImport } from './_routes/_private.deposits/new/route'
import { Route as PrivateDepositsIdRouteRouteImport } from './_routes/_private.deposits/$id/route'
import { Route as PrivateContactsNewRouteRouteImport } from './_routes/_private.contacts/new/route'
import { Route as PrivateConnectedAppsNewRouteRouteImport } from './_routes/_private.connected-apps/new/route'
import { Route as PrivateConnectedAppsIdRouteRouteImport } from './_routes/_private.connected-apps/$id/route'
import { Route as PrivateConferencesAndEventsNewRouteRouteImport } from './_routes/_private.conferences-and-events/new/route'
import { Route as PrivateConferencesAndEventsIdRouteRouteImport } from './_routes/_private.conferences-and-events/$id/route'
import { Route as PrivateCompetitorsNewRouteRouteImport } from './_routes/_private.competitors/new/route'
import { Route as PrivateCompaniesNewRouteRouteImport } from './_routes/_private.companies/new/route'
import { Route as PrivateAwardsNewRouteRouteImport } from './_routes/_private.awards/new/route'
import { Route as PrivateAwardsIdRouteRouteImport } from './_routes/_private.awards/$id/route'
import { Route as PrivateAgreementsNewRouteRouteImport } from './_routes/_private.agreements/new/route'
import { Route as PrivateAccountReceivablesNewRouteRouteImport } from './_routes/_private.account-receivables/new/route'
import { Route as PrivateAccountReceivablesIdRouteRouteImport } from './_routes/_private.account-receivables/$id/route'
import { Route as PublicSignupIndexRouteRouteImport } from './_routes/_public.signup/index/route'
import { Route as PublicResetPasswordIndexRouteRouteImport } from './_routes/_public.reset-password/index/route'
import { Route as PublicLoginIndexRouteRouteImport } from './_routes/_public.login/index/route'
import { Route as PublicForgotPasswordIndexRouteRouteImport } from './_routes/_public.forgot-password/index/route'
import { Route as PrivateTeamMembersIndexRouteRouteImport } from './_routes/_private.team-members/index/route'
import { Route as PrivateSystemUsersIndexRouteRouteImport } from './_routes/_private.system-users/index/route'
import { Route as PrivateSupportIndexRouteRouteImport } from './_routes/_private.support/index/route'
import { Route as PrivateSettingsIndexRouteRouteImport } from './_routes/_private.settings/index/route'
import { Route as PrivateRecruitingIndexRouteRouteImport } from './_routes/_private.recruiting/index/route'
import { Route as PrivateProductsAndServicesIndexRouteRouteImport } from './_routes/_private.products-and-services/index/route'
import { Route as PrivatePickTicketsIndexRouteRouteImport } from './_routes/_private.pick-tickets/index/route'
import { Route as PrivateMediaIndexRouteRouteImport } from './_routes/_private.media/index/route'
import { Route as PrivateMarketingCampaignsIndexRouteRouteImport } from './_routes/_private.marketing-campaigns/index/route'
import { Route as PrivateInvoicesIndexRouteRouteImport } from './_routes/_private.invoices/index/route'
import { Route as PrivateInventoryIndexRouteRouteImport } from './_routes/_private.inventory/index/route'
import { Route as PrivateGovernanceIndexRouteRouteImport } from './_routes/_private.governance/index/route'
import { Route as PrivateFinancialSnapshotsIndexRouteRouteImport } from './_routes/_private.financial-snapshots/index/route'
import { Route as PrivateDomainsIndexRouteRouteImport } from './_routes/_private.domains/index/route'
import { Route as PrivateDepositsIndexRouteRouteImport } from './_routes/_private.deposits/index/route'
import { Route as PrivateDashboardIndexRouteRouteImport } from './_routes/_private.dashboard/index/route'
import { Route as PrivateContactsIndexRouteRouteImport } from './_routes/_private.contacts/index/route'
import { Route as PrivateConnectedAppsIndexRouteRouteImport } from './_routes/_private.connected-apps/index/route'
import { Route as PrivateConferencesAndEventsIndexRouteRouteImport } from './_routes/_private.conferences-and-events/index/route'
import { Route as PrivateCompetitorsIndexRouteRouteImport } from './_routes/_private.competitors/index/route'
import { Route as PrivateCompaniesIndexRouteRouteImport } from './_routes/_private.companies/index/route'
import { Route as PrivateAwardsIndexRouteRouteImport } from './_routes/_private.awards/index/route'
import { Route as PrivateAgreementsIndexRouteRouteImport } from './_routes/_private.agreements/index/route'
import { Route as PrivateAccountReceivablesIndexRouteRouteImport } from './_routes/_private.account-receivables/index/route'
import { Route as PrivateSettingsRegistrarsTemplateRouteImport } from './_routes/_private.settings/registrars/_template'
import { Route as PrivateSettingsJobPositionsTemplateRouteImport } from './_routes/_private.settings/job-positions/_template'
import { Route as PrivateSettingsUserRolesNewRouteRouteImport } from './_routes/_private.settings/user-roles/new/route'
import { Route as PrivateSettingsUserRolesIdRouteRouteImport } from './_routes/_private.settings/user-roles/$id/route'
import { Route as PrivateSettingsUnitSellBysNewRouteRouteImport } from './_routes/_private.settings/unit-sell-bys/new/route'
import { Route as PrivateSettingsUnitSellBysIdRouteRouteImport } from './_routes/_private.settings/unit-sell-bys/$id/route'
import { Route as PrivateSettingsTermsTemplatesNewRouteRouteImport } from './_routes/_private.settings/terms-templates/new/route'
import { Route as PrivateSettingsTermsTemplatesIdRouteRouteImport } from './_routes/_private.settings/terms-templates/$id/route'
import { Route as PrivateSettingsTermsConditionsNewRouteRouteImport } from './_routes/_private.settings/terms-conditions/new/route'
import { Route as PrivateSettingsTermsConditionsIdRouteRouteImport } from './_routes/_private.settings/terms-conditions/$id/route'
import { Route as PrivateSettingsTermsCategoriesNewRouteRouteImport } from './_routes/_private.settings/terms-categories/new/route'
import { Route as PrivateSettingsTermsCategoriesIdRouteRouteImport } from './_routes/_private.settings/terms-categories/$id/route'
import { Route as PrivateSettingsSystemFilesNewRouteRouteImport } from './_routes/_private.settings/system-files/new/route'
import { Route as PrivateSettingsSystemFilesIdRouteRouteImport } from './_routes/_private.settings/system-files/$id/route'
import { Route as PrivateSettingsSalaryGradesNewRouteRouteImport } from './_routes/_private.settings/salary-grades/new/route'
import { Route as PrivateSettingsSalaryGradesIdRouteRouteImport } from './_routes/_private.settings/salary-grades/$id/route'
import { Route as PrivateSettingsRevenueLockdownsNewRouteRouteImport } from './_routes/_private.settings/revenue-lockdowns/new/route'
import { Route as PrivateSettingsRevenueLockdownsIdRouteRouteImport } from './_routes/_private.settings/revenue-lockdowns/$id/route'
import { Route as PrivateSettingsRelationshipScoresNewRouteRouteImport } from './_routes/_private.settings/relationship-scores/new/route'
import { Route as PrivateSettingsRelationshipScoresIdRouteRouteImport } from './_routes/_private.settings/relationship-scores/$id/route'
import { Route as PrivateSettingsRegistrarsNewRouteRouteImport } from './_routes/_private.settings/registrars/new/route'
import { Route as PrivateSettingsRecruitingStatusesNewRouteRouteImport } from './_routes/_private.settings/recruiting-statuses/new/route'
import { Route as PrivateSettingsRecruitingStatusesIdRouteRouteImport } from './_routes/_private.settings/recruiting-statuses/$id/route'
import { Route as PrivateSettingsRecruitingJobCategoriesNewRouteRouteImport } from './_routes/_private.settings/recruiting-job-categories/new/route'
import { Route as PrivateSettingsRecruitingJobCategoriesIdRouteRouteImport } from './_routes/_private.settings/recruiting-job-categories/$id/route'
import { Route as PrivateSettingsRecruitingHiringCriteriaCategoriesNewRouteRouteImport } from './_routes/_private.settings/recruiting-hiring-criteria-categories/new/route'
import { Route as PrivateSettingsRecruitingHiringCriteriaCategoriesIdRouteRouteImport } from './_routes/_private.settings/recruiting-hiring-criteria-categories/$id/route'
import { Route as PrivateSettingsProductsAndServicesTemplatesNewRouteRouteImport } from './_routes/_private.settings/products-and-services-templates/new/route'
import { Route as PrivateSettingsProductsAndServicesTemplatesIdRouteRouteImport } from './_routes/_private.settings/products-and-services-templates/$id/route'
import { Route as PrivateSettingsPriceFrequenciesNewRouteRouteImport } from './_routes/_private.settings/price-frequencies/new/route'
import { Route as PrivateSettingsPriceFrequenciesIdRouteRouteImport } from './_routes/_private.settings/price-frequencies/$id/route'
import { Route as PrivateSettingsPreferredRelationshipsNewRouteRouteImport } from './_routes/_private.settings/preferred-relationships/new/route'
import { Route as PrivateSettingsPreferredRelationshipsIdRouteRouteImport } from './_routes/_private.settings/preferred-relationships/$id/route'
import { Route as PrivateSettingsPreferredLocationsNewRouteRouteImport } from './_routes/_private.settings/preferred-locations/new/route'
import { Route as PrivateSettingsPreferredLocationsIdRouteRouteImport } from './_routes/_private.settings/preferred-locations/$id/route'
import { Route as PrivateSettingsPaymentMethodsNewRouteRouteImport } from './_routes/_private.settings/payment-methods/new/route'
import { Route as PrivateSettingsPaymentMethodsIdRouteRouteImport } from './_routes/_private.settings/payment-methods/$id/route'
import { Route as PrivateSettingsPartnersNewRouteRouteImport } from './_routes/_private.settings/partners/new/route'
import { Route as PrivateSettingsPartnersIdRouteRouteImport } from './_routes/_private.settings/partners/$id/route'
import { Route as PrivateSettingsOrganizationTypesNewRouteRouteImport } from './_routes/_private.settings/organization-types/new/route'
import { Route as PrivateSettingsOrganizationTypesIdRouteRouteImport } from './_routes/_private.settings/organization-types/$id/route'
import { Route as PrivateSettingsMileageRatesNewRouteRouteImport } from './_routes/_private.settings/mileage-rates/new/route'
import { Route as PrivateSettingsMileageRatesIdRouteRouteImport } from './_routes/_private.settings/mileage-rates/$id/route'
import { Route as PrivateSettingsManufacturersNewRouteRouteImport } from './_routes/_private.settings/manufacturers/new/route'
import { Route as PrivateSettingsManufacturersIdRouteRouteImport } from './_routes/_private.settings/manufacturers/$id/route'
import { Route as PrivateSettingsMagazinesNewRouteRouteImport } from './_routes/_private.settings/magazines/new/route'
import { Route as PrivateSettingsMagazinesIdRouteRouteImport } from './_routes/_private.settings/magazines/$id/route'
import { Route as PrivateSettingsJobPositionsNewRouteRouteImport } from './_routes/_private.settings/job-positions/new/route'
import { Route as PrivateSettingsInventoryVolumesNewRouteRouteImport } from './_routes/_private.settings/inventory-volumes/new/route'
import { Route as PrivateSettingsInventoryVolumesIdRouteRouteImport } from './_routes/_private.settings/inventory-volumes/$id/route'
import { Route as PrivateSettingsInventoryVendorsNewRouteRouteImport } from './_routes/_private.settings/inventory-vendors/new/route'
import { Route as PrivateSettingsInventoryVendorsIdRouteRouteImport } from './_routes/_private.settings/inventory-vendors/$id/route'
import { Route as PrivateSettingsInventoryStocksNewRouteRouteImport } from './_routes/_private.settings/inventory-stocks/new/route'
import { Route as PrivateSettingsInventoryStocksIdRouteRouteImport } from './_routes/_private.settings/inventory-stocks/$id/route'
import { Route as PrivateSettingsInventoryPurchasesNewRouteRouteImport } from './_routes/_private.settings/inventory-purchases/new/route'
import { Route as PrivateSettingsInventoryPurchasesIdRouteRouteImport } from './_routes/_private.settings/inventory-purchases/$id/route'
import { Route as PrivateSettingsInventoryKitsNewRouteRouteImport } from './_routes/_private.settings/inventory-kits/new/route'
import { Route as PrivateSettingsInventoryKitsIdRouteRouteImport } from './_routes/_private.settings/inventory-kits/$id/route'
import { Route as PrivateSettingsInventoryCategoriesNewRouteRouteImport } from './_routes/_private.settings/inventory-categories/new/route'
import { Route as PrivateSettingsInventoryCategoriesIdRouteRouteImport } from './_routes/_private.settings/inventory-categories/$id/route'
import { Route as PrivateSettingsInventoryBinLocationsNewRouteRouteImport } from './_routes/_private.settings/inventory-bin-locations/new/route'
import { Route as PrivateSettingsInventoryBinLocationsIdRouteRouteImport } from './_routes/_private.settings/inventory-bin-locations/$id/route'
import { Route as PrivateSettingsInfrastructuresNewRouteRouteImport } from './_routes/_private.settings/infrastructures/new/route'
import { Route as PrivateSettingsInfrastructuresIdRouteRouteImport } from './_routes/_private.settings/infrastructures/$id/route'
import { Route as PrivateSettingsIndustriesNewRouteRouteImport } from './_routes/_private.settings/industries/new/route'
import { Route as PrivateSettingsIndustriesIdRouteRouteImport } from './_routes/_private.settings/industries/$id/route'
import { Route as PrivateSettingsEmailTemplatesNewRouteRouteImport } from './_routes/_private.settings/email-templates/new/route'
import { Route as PrivateSettingsEmailTemplatesIdRouteRouteImport } from './_routes/_private.settings/email-templates/$id/route'
import { Route as PrivateSettingsEmailHistoryIdRouteRouteImport } from './_routes/_private.settings/email-history/$id/route'
import { Route as PrivateSettingsDepartmentsNewRouteRouteImport } from './_routes/_private.settings/departments/new/route'
import { Route as PrivateSettingsDepartmentsIdRouteRouteImport } from './_routes/_private.settings/departments/$id/route'
import { Route as PrivateSettingsCountriesNewRouteRouteImport } from './_routes/_private.settings/countries/new/route'
import { Route as PrivateSettingsCountriesIdRouteRouteImport } from './_routes/_private.settings/countries/$id/route'
import { Route as PrivateSettingsCommissionPlansNewRouteRouteImport } from './_routes/_private.settings/commission-plans/new/route'
import { Route as PrivateSettingsCommissionPlansIdRouteRouteImport } from './_routes/_private.settings/commission-plans/$id/route'
import { Route as PrivateSettingsCategoriesNewRouteRouteImport } from './_routes/_private.settings/categories/new/route'
import { Route as PrivateSettingsCategoriesIdRouteRouteImport } from './_routes/_private.settings/categories/$id/route'
import { Route as PrivateSettingsBusinessDisciplinesNewRouteRouteImport } from './_routes/_private.settings/business-disciplines/new/route'
import { Route as PrivateSettingsBusinessDisciplinesIdRouteRouteImport } from './_routes/_private.settings/business-disciplines/$id/route'
import { Route as PrivateSettingsBrandsNewRouteRouteImport } from './_routes/_private.settings/brands/new/route'
import { Route as PrivateSettingsBrandsIdRouteRouteImport } from './_routes/_private.settings/brands/$id/route'
import { Route as PrivateSettingsBillingTermsNewRouteRouteImport } from './_routes/_private.settings/billing-terms/new/route'
import { Route as PrivateSettingsBillingTermsIdRouteRouteImport } from './_routes/_private.settings/billing-terms/$id/route'
import { Route as PrivateSettingsBillingSystemsNewRouteRouteImport } from './_routes/_private.settings/billing-systems/new/route'
import { Route as PrivateSettingsBillingSystemsIdRouteRouteImport } from './_routes/_private.settings/billing-systems/$id/route'
import { Route as PrivateSettingsBankAccountsNewRouteRouteImport } from './_routes/_private.settings/bank-accounts/new/route'
import { Route as PrivateSettingsBankAccountsIdRouteRouteImport } from './_routes/_private.settings/bank-accounts/$id/route'
import { Route as PrivateSettingsAudiencesNewRouteRouteImport } from './_routes/_private.settings/audiences/new/route'
import { Route as PrivateSettingsAudiencesIdRouteRouteImport } from './_routes/_private.settings/audiences/$id/route'
import { Route as PrivateInvoicesInvoiceBatchIdRouteRouteImport } from './_routes/_private.invoices/invoice-batch.$id/route'
import { Route as PrivateInventoryParentIdRouteRouteImport } from './_routes/_private.inventory/parent.$id/route'
import { Route as PrivateSettingsUserRolesIndexRouteRouteImport } from './_routes/_private.settings/user-roles/index/route'
import { Route as PrivateSettingsUnitSellBysIndexRouteRouteImport } from './_routes/_private.settings/unit-sell-bys/index/route'
import { Route as PrivateSettingsTermsTemplatesIndexRouteRouteImport } from './_routes/_private.settings/terms-templates/index/route'
import { Route as PrivateSettingsTermsConditionsIndexRouteRouteImport } from './_routes/_private.settings/terms-conditions/index/route'
import { Route as PrivateSettingsTermsCategoriesIndexRouteRouteImport } from './_routes/_private.settings/terms-categories/index/route'
import { Route as PrivateSettingsSystemFilesIndexRouteRouteImport } from './_routes/_private.settings/system-files/index/route'
import { Route as PrivateSettingsSalaryGradesIndexRouteRouteImport } from './_routes/_private.settings/salary-grades/index/route'
import { Route as PrivateSettingsRevenueLockdownsIndexRouteRouteImport } from './_routes/_private.settings/revenue-lockdowns/index/route'
import { Route as PrivateSettingsRelationshipScoresIndexRouteRouteImport } from './_routes/_private.settings/relationship-scores/index/route'
import { Route as PrivateSettingsRegistrarsIndexRouteRouteImport } from './_routes/_private.settings/registrars/index/route'
import { Route as PrivateSettingsRecruitingStatusesIndexRouteRouteImport } from './_routes/_private.settings/recruiting-statuses/index/route'
import { Route as PrivateSettingsRecruitingJobCategoriesIndexRouteRouteImport } from './_routes/_private.settings/recruiting-job-categories/index/route'
import { Route as PrivateSettingsRecruitingHiringCriteriaCategoriesIndexRouteRouteImport } from './_routes/_private.settings/recruiting-hiring-criteria-categories/index/route'
import { Route as PrivateSettingsProductsAndServicesTemplatesIndexRouteRouteImport } from './_routes/_private.settings/products-and-services-templates/index/route'
import { Route as PrivateSettingsPriceFrequenciesIndexRouteRouteImport } from './_routes/_private.settings/price-frequencies/index/route'
import { Route as PrivateSettingsPreferredRelationshipsIndexRouteRouteImport } from './_routes/_private.settings/preferred-relationships/index/route'
import { Route as PrivateSettingsPreferredLocationsIndexRouteRouteImport } from './_routes/_private.settings/preferred-locations/index/route'
import { Route as PrivateSettingsPaymentMethodsIndexRouteRouteImport } from './_routes/_private.settings/payment-methods/index/route'
import { Route as PrivateSettingsPartnersIndexRouteRouteImport } from './_routes/_private.settings/partners/index/route'
import { Route as PrivateSettingsOrganizationTypesIndexRouteRouteImport } from './_routes/_private.settings/organization-types/index/route'
import { Route as PrivateSettingsMileageRatesIndexRouteRouteImport } from './_routes/_private.settings/mileage-rates/index/route'
import { Route as PrivateSettingsManufacturersIndexRouteRouteImport } from './_routes/_private.settings/manufacturers/index/route'
import { Route as PrivateSettingsMagazinesIndexRouteRouteImport } from './_routes/_private.settings/magazines/index/route'
import { Route as PrivateSettingsJobPositionsIndexRouteRouteImport } from './_routes/_private.settings/job-positions/index/route'
import { Route as PrivateSettingsInventoryVolumesIndexRouteRouteImport } from './_routes/_private.settings/inventory-volumes/index/route'
import { Route as PrivateSettingsInventoryVendorsIndexRouteRouteImport } from './_routes/_private.settings/inventory-vendors/index/route'
import { Route as PrivateSettingsInventoryStocksIndexRouteRouteImport } from './_routes/_private.settings/inventory-stocks/index/route'
import { Route as PrivateSettingsInventoryPurchasesIndexRouteRouteImport } from './_routes/_private.settings/inventory-purchases/index/route'
import { Route as PrivateSettingsInventoryKitsIndexRouteRouteImport } from './_routes/_private.settings/inventory-kits/index/route'
import { Route as PrivateSettingsInventoryCategoriesIndexRouteRouteImport } from './_routes/_private.settings/inventory-categories/index/route'
import { Route as PrivateSettingsInventoryBinLocationsIndexRouteRouteImport } from './_routes/_private.settings/inventory-bin-locations/index/route'
import { Route as PrivateSettingsInfrastructuresIndexRouteRouteImport } from './_routes/_private.settings/infrastructures/index/route'
import { Route as PrivateSettingsIndustriesIndexRouteRouteImport } from './_routes/_private.settings/industries/index/route'
import { Route as PrivateSettingsEmailTemplatesIndexRouteRouteImport } from './_routes/_private.settings/email-templates/index/route'
import { Route as PrivateSettingsEmailTemplateDefaultsIndexRouteRouteImport } from './_routes/_private.settings/email-template-defaults/index/route'
import { Route as PrivateSettingsEmailHistoryIndexRouteRouteImport } from './_routes/_private.settings/email-history/index/route'
import { Route as PrivateSettingsDepartmentsIndexRouteRouteImport } from './_routes/_private.settings/departments/index/route'
import { Route as PrivateSettingsCountriesIndexRouteRouteImport } from './_routes/_private.settings/countries/index/route'
import { Route as PrivateSettingsCommissionPlansIndexRouteRouteImport } from './_routes/_private.settings/commission-plans/index/route'
import { Route as PrivateSettingsCategoriesIndexRouteRouteImport } from './_routes/_private.settings/categories/index/route'
import { Route as PrivateSettingsBusinessDisciplinesIndexRouteRouteImport } from './_routes/_private.settings/business-disciplines/index/route'
import { Route as PrivateSettingsBrandsIndexRouteRouteImport } from './_routes/_private.settings/brands/index/route'
import { Route as PrivateSettingsBillingTermsIndexRouteRouteImport } from './_routes/_private.settings/billing-terms/index/route'
import { Route as PrivateSettingsBillingSystemsIndexRouteRouteImport } from './_routes/_private.settings/billing-systems/index/route'
import { Route as PrivateSettingsBankAccountsIndexRouteRouteImport } from './_routes/_private.settings/bank-accounts/index/route'
import { Route as PrivateSettingsAudiencesIndexRouteRouteImport } from './_routes/_private.settings/audiences/index/route'
import { Route as PrivateTeamMembersTemplateIdPreferenceRouteRouteImport } from './_routes/_private.team-members/_template.$id/preference/route'
import { Route as PrivateTeamMembersTemplateIdPersonalDetailsRouteRouteImport } from './_routes/_private.team-members/_template.$id/personal-details/route'
import { Route as PrivateTeamMembersTemplateIdMarketingRouteRouteImport } from './_routes/_private.team-members/_template.$id/marketing/route'
import { Route as PrivateTeamMembersTemplateIdEmergencyRouteRouteImport } from './_routes/_private.team-members/_template.$id/emergency/route'
import { Route as PrivateTeamMembersTemplateIdCommissionPeriodsRouteRouteImport } from './_routes/_private.team-members/_template.$id/commission-periods/route'
import { Route as PrivateTeamMembersTemplateIdApiIntegrationRouteRouteImport } from './_routes/_private.team-members/_template.$id/api-integration/route'
import { Route as PrivateInventoryTemplateIdVendorsRouteRouteImport } from './_routes/_private.inventory/_template.$id/vendors/route'
import { Route as PrivateContactsTemplateIdNotesRouteRouteImport } from './_routes/_private.contacts/_template.$id/notes/route'
import { Route as PrivateContactsTemplateIdMarketingCampaignsRouteRouteImport } from './_routes/_private.contacts/_template.$id/marketing-campaigns/route'
import { Route as PrivateContactsTemplateIdApiIntegrationRouteRouteImport } from './_routes/_private.contacts/_template.$id/api-integration/route'
import { Route as PrivateContactsTemplateIdAgreementsRouteRouteImport } from './_routes/_private.contacts/_template.$id/agreements/route'
import { Route as PrivateCompetitorsTemplateIdNotesRouteRouteImport } from './_routes/_private.competitors/_template.$id/notes/route'
import { Route as PrivateCompetitorsTemplateIdContactsRouteRouteImport } from './_routes/_private.competitors/_template.$id/contacts/route'
import { Route as PrivateCompetitorsTemplateIdAssociatedCompaniesRouteRouteImport } from './_routes/_private.competitors/_template.$id/associated-companies/route'
import { Route as PrivateCompaniesTemplateIdSubscriptionsRouteRouteImport } from './_routes/_private.companies/_template.$id/subscriptions/route'
import { Route as PrivateCompaniesTemplateIdNotesRouteRouteImport } from './_routes/_private.companies/_template.$id/notes/route'
import { Route as PrivateCompaniesTemplateIdMarketingCampaignsRouteRouteImport } from './_routes/_private.companies/_template.$id/marketing-campaigns/route'
import { Route as PrivateCompaniesTemplateIdInvoiceHistoryRouteRouteImport } from './_routes/_private.companies/_template.$id/invoice-history/route'
import { Route as PrivateCompaniesTemplateIdFinancialsRouteRouteImport } from './_routes/_private.companies/_template.$id/financials/route'
import { Route as PrivateCompaniesTemplateIdDomainsRouteRouteImport } from './_routes/_private.companies/_template.$id/domains/route'
import { Route as PrivateCompaniesTemplateIdContactsRouteRouteImport } from './_routes/_private.companies/_template.$id/contacts/route'
import { Route as PrivateCompaniesTemplateIdApiIntegrationRouteRouteImport } from './_routes/_private.companies/_template.$id/api-integration/route'
import { Route as PrivateCompaniesTemplateIdAgreementsRouteRouteImport } from './_routes/_private.companies/_template.$id/agreements/route'
import { Route as PrivateAgreementsTemplateIdSubsidiesRouteRouteImport } from './_routes/_private.agreements/_template.$id/subsidies/route'
import { Route as PrivateAgreementsTemplateIdPaperworkRouteRouteImport } from './_routes/_private.agreements/_template.$id/paperwork/route'
import { Route as PrivateAgreementsTemplateIdFinancialOverrideRouteRouteImport } from './_routes/_private.agreements/_template.$id/financial-override/route'
import { Route as PrivateAgreementsTemplateIdExecutionRouteRouteImport } from './_routes/_private.agreements/_template.$id/execution/route'
import { Route as PrivateAgreementsTemplateIdDeliverablesRouteRouteImport } from './_routes/_private.agreements/_template.$id/deliverables/route'
import { Route as PrivateAgreementsTemplateIdCommissionRouteRouteImport } from './_routes/_private.agreements/_template.$id/commission/route'
import { Route as PrivateAgreementsTemplateIdApiIntegrationRouteRouteImport } from './_routes/_private.agreements/_template.$id/api-integration/route'
import { Route as PrivateAgreementsTemplateIdAddendumRouteRouteImport } from './_routes/_private.agreements/_template.$id/addendum/route'
import { Route as PrivateTeamMembersTemplateIdIndexRouteRouteImport } from './_routes/_private.team-members/_template.$id/index/route'
import { Route as PrivateInventoryTemplateIdIndexRouteRouteImport } from './_routes/_private.inventory/_template.$id/index/route'
import { Route as PrivateContactsTemplateIdIndexRouteRouteImport } from './_routes/_private.contacts/_template.$id/index/route'
import { Route as PrivateCompetitorsTemplateIdIndexRouteRouteImport } from './_routes/_private.competitors/_template.$id/index/route'
import { Route as PrivateCompaniesTemplateIdIndexRouteRouteImport } from './_routes/_private.companies/_template.$id/index/route'
import { Route as PrivateAgreementsTemplateIdIndexRouteRouteImport } from './_routes/_private.agreements/_template.$id/index/route'
import { Route as PrivateSettingsRegistrarsTemplateIdDomainsRouteRouteImport } from './_routes/_private.settings/registrars/_template.$id/domains/route'
import { Route as PrivateSettingsJobPositionsTemplateIdHiringRouteRouteImport } from './_routes/_private.settings/job-positions/_template.$id/hiring/route'
import { Route as PrivateSettingsJobPositionsTemplateIdAgreementRouteRouteImport } from './_routes/_private.settings/job-positions/_template.$id/agreement/route'
import { Route as PrivateSettingsJobPositionsTemplateIdAdvertisementRouteRouteImport } from './_routes/_private.settings/job-positions/_template.$id/advertisement/route'
import { Route as PrivateContactsTemplateIdSupportTicket_idRouteRouteImport } from './_routes/_private.contacts/_template.$id/support/$ticket_id/route'
import { Route as PrivateCompaniesTemplateIdSupportTicket_idRouteRouteImport } from './_routes/_private.companies/_template.$id/support/$ticket_id/route'
import { Route as PrivateSettingsRegistrarsTemplateIdIndexRouteRouteImport } from './_routes/_private.settings/registrars/_template.$id/index/route'
import { Route as PrivateSettingsJobPositionsTemplateIdIndexRouteRouteImport } from './_routes/_private.settings/job-positions/_template.$id/index/route'
import { Route as PrivateContactsTemplateIdSupportIndexRouteRouteImport } from './_routes/_private.contacts/_template.$id/support/index/route'
import { Route as PrivateCompaniesTemplateIdSupportIndexRouteRouteImport } from './_routes/_private.companies/_template.$id/support/index/route'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateRoute = PrivateRouteImport.update({
  id: '/_private',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./_routes/_private.lazy').then((d) => d.Route))
const TestRouteRoute = TestRouteRouteImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./_routes/test/route.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateTeamMembersTemplateRoute =
  PrivateTeamMembersTemplateRouteImport.update({
    id: '/team-members/_template',
    path: '/team-members',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.team-members/_template.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateInventoryTemplateRoute =
  PrivateInventoryTemplateRouteImport.update({
    id: '/inventory/_template',
    path: '/inventory',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.inventory/_template.lazy').then((d) => d.Route),
  )
const PrivateContactsTemplateRoute = PrivateContactsTemplateRouteImport.update({
  id: '/contacts/_template',
  path: '/contacts',
  getParentRoute: () => PrivateRoute,
} as any).lazy(() =>
  import('./_routes/_private.contacts/_template.lazy').then((d) => d.Route),
)
const PrivateCompetitorsTemplateRoute =
  PrivateCompetitorsTemplateRouteImport.update({
    id: '/competitors/_template',
    path: '/competitors',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.competitors/_template.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompaniesTemplateRoute =
  PrivateCompaniesTemplateRouteImport.update({
    id: '/companies/_template',
    path: '/companies',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.companies/_template.lazy').then((d) => d.Route),
  )
const PrivateAgreementsTemplateRoute =
  PrivateAgreementsTemplateRouteImport.update({
    id: '/agreements/_template',
    path: '/agreements',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.agreements/_template.lazy').then((d) => d.Route),
  )
const PrivateTeamMembersNewRouteRoute =
  PrivateTeamMembersNewRouteRouteImport.update({
    id: '/team-members/new',
    path: '/team-members/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.team-members/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSystemUsersIdRouteRoute =
  PrivateSystemUsersIdRouteRouteImport.update({
    id: '/system-users/$id',
    path: '/system-users/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.system-users/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSupportTicket_idRouteRoute =
  PrivateSupportTicket_idRouteRouteImport.update({
    id: '/support/$ticket_id',
    path: '/support/$ticket_id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.support/$ticket_id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsViewLogsRouteRoute =
  PrivateSettingsViewLogsRouteRouteImport.update({
    id: '/settings/view-logs',
    path: '/settings/view-logs',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/view-logs/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRevenueAllocationLockdownOverrideLogsRouteRoute =
  PrivateSettingsRevenueAllocationLockdownOverrideLogsRouteRouteImport.update({
    id: '/settings/revenue-allocation-lockdown-override-logs',
    path: '/settings/revenue-allocation-lockdown-override-logs',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/revenue-allocation-lockdown-override-logs/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateRecruitingNewRouteRoute =
  PrivateRecruitingNewRouteRouteImport.update({
    id: '/recruiting/new',
    path: '/recruiting/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.recruiting/new/route.lazy').then((d) => d.Route),
  )
const PrivateRecruitingIdRouteRoute =
  PrivateRecruitingIdRouteRouteImport.update({
    id: '/recruiting/$id',
    path: '/recruiting/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.recruiting/$id/route.lazy').then((d) => d.Route),
  )
const PrivateProductsAndServicesNewRouteRoute =
  PrivateProductsAndServicesNewRouteRouteImport.update({
    id: '/products-and-services/new',
    path: '/products-and-services/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.products-and-services/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateProductsAndServicesIdRouteRoute =
  PrivateProductsAndServicesIdRouteRouteImport.update({
    id: '/products-and-services/$id',
    path: '/products-and-services/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.products-and-services/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivatePickTicketsNewRouteRoute =
  PrivatePickTicketsNewRouteRouteImport.update({
    id: '/pick-tickets/new',
    path: '/pick-tickets/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.pick-tickets/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivatePickTicketsIdRouteRoute =
  PrivatePickTicketsIdRouteRouteImport.update({
    id: '/pick-tickets/$id',
    path: '/pick-tickets/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.pick-tickets/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivatePendingDepositsIdRouteRoute =
  PrivatePendingDepositsIdRouteRouteImport.update({
    id: '/pending-deposits/$id',
    path: '/pending-deposits/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.pending-deposits/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateMarketingCampaignsNewRouteRoute =
  PrivateMarketingCampaignsNewRouteRouteImport.update({
    id: '/marketing-campaigns/new',
    path: '/marketing-campaigns/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.marketing-campaigns/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateMarketingCampaignsIdRouteRoute =
  PrivateMarketingCampaignsIdRouteRouteImport.update({
    id: '/marketing-campaigns/$id',
    path: '/marketing-campaigns/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.marketing-campaigns/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateInvoicesNewRouteRoute = PrivateInvoicesNewRouteRouteImport.update({
  id: '/invoices/new',
  path: '/invoices/new',
  getParentRoute: () => PrivateRoute,
} as any).lazy(() =>
  import('./_routes/_private.invoices/new/route.lazy').then((d) => d.Route),
)
const PrivateInvoicesIdRouteRoute = PrivateInvoicesIdRouteRouteImport.update({
  id: '/invoices/$id',
  path: '/invoices/$id',
  getParentRoute: () => PrivateRoute,
} as any).lazy(() =>
  import('./_routes/_private.invoices/$id/route.lazy').then((d) => d.Route),
)
const PrivateInventoryParentNewRouteRoute =
  PrivateInventoryParentNewRouteRouteImport.update({
    id: '/inventory/parent-new',
    path: '/inventory/parent-new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.inventory/parent-new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateInventoryNewRouteRoute =
  PrivateInventoryNewRouteRouteImport.update({
    id: '/inventory/new',
    path: '/inventory/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.inventory/new/route.lazy').then((d) => d.Route),
  )
const PrivateGovernanceNewRouteRoute =
  PrivateGovernanceNewRouteRouteImport.update({
    id: '/governance/new',
    path: '/governance/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.governance/new/route.lazy').then((d) => d.Route),
  )
const PrivateGovernanceIdRouteRoute =
  PrivateGovernanceIdRouteRouteImport.update({
    id: '/governance/$id',
    path: '/governance/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.governance/$id/route.lazy').then((d) => d.Route),
  )
const PrivateFinancialSnapshotsNewRouteRoute =
  PrivateFinancialSnapshotsNewRouteRouteImport.update({
    id: '/financial-snapshots/new',
    path: '/financial-snapshots/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.financial-snapshots/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateFinancialSnapshotsIdRouteRoute =
  PrivateFinancialSnapshotsIdRouteRouteImport.update({
    id: '/financial-snapshots/$id',
    path: '/financial-snapshots/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.financial-snapshots/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateDomainsNewRouteRoute = PrivateDomainsNewRouteRouteImport.update({
  id: '/domains/new',
  path: '/domains/new',
  getParentRoute: () => PrivateRoute,
} as any).lazy(() =>
  import('./_routes/_private.domains/new/route.lazy').then((d) => d.Route),
)
const PrivateDomainsIdRouteRoute = PrivateDomainsIdRouteRouteImport.update({
  id: '/domains/$id',
  path: '/domains/$id',
  getParentRoute: () => PrivateRoute,
} as any).lazy(() =>
  import('./_routes/_private.domains/$id/route.lazy').then((d) => d.Route),
)
const PrivateDepositsNewRouteRoute = PrivateDepositsNewRouteRouteImport.update({
  id: '/deposits/new',
  path: '/deposits/new',
  getParentRoute: () => PrivateRoute,
} as any).lazy(() =>
  import('./_routes/_private.deposits/new/route.lazy').then((d) => d.Route),
)
const PrivateDepositsIdRouteRoute = PrivateDepositsIdRouteRouteImport.update({
  id: '/deposits/$id',
  path: '/deposits/$id',
  getParentRoute: () => PrivateRoute,
} as any).lazy(() =>
  import('./_routes/_private.deposits/$id/route.lazy').then((d) => d.Route),
)
const PrivateContactsNewRouteRoute = PrivateContactsNewRouteRouteImport.update({
  id: '/contacts/new',
  path: '/contacts/new',
  getParentRoute: () => PrivateRoute,
} as any).lazy(() =>
  import('./_routes/_private.contacts/new/route.lazy').then((d) => d.Route),
)
const PrivateConnectedAppsNewRouteRoute =
  PrivateConnectedAppsNewRouteRouteImport.update({
    id: '/connected-apps/new',
    path: '/connected-apps/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.connected-apps/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateConnectedAppsIdRouteRoute =
  PrivateConnectedAppsIdRouteRouteImport.update({
    id: '/connected-apps/$id',
    path: '/connected-apps/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.connected-apps/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateConferencesAndEventsNewRouteRoute =
  PrivateConferencesAndEventsNewRouteRouteImport.update({
    id: '/conferences-and-events/new',
    path: '/conferences-and-events/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.conferences-and-events/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateConferencesAndEventsIdRouteRoute =
  PrivateConferencesAndEventsIdRouteRouteImport.update({
    id: '/conferences-and-events/$id',
    path: '/conferences-and-events/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.conferences-and-events/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompetitorsNewRouteRoute =
  PrivateCompetitorsNewRouteRouteImport.update({
    id: '/competitors/new',
    path: '/competitors/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.competitors/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompaniesNewRouteRoute =
  PrivateCompaniesNewRouteRouteImport.update({
    id: '/companies/new',
    path: '/companies/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.companies/new/route.lazy').then((d) => d.Route),
  )
const PrivateAwardsNewRouteRoute = PrivateAwardsNewRouteRouteImport.update({
  id: '/awards/new',
  path: '/awards/new',
  getParentRoute: () => PrivateRoute,
} as any).lazy(() =>
  import('./_routes/_private.awards/new/route.lazy').then((d) => d.Route),
)
const PrivateAwardsIdRouteRoute = PrivateAwardsIdRouteRouteImport.update({
  id: '/awards/$id',
  path: '/awards/$id',
  getParentRoute: () => PrivateRoute,
} as any).lazy(() =>
  import('./_routes/_private.awards/$id/route.lazy').then((d) => d.Route),
)
const PrivateAgreementsNewRouteRoute =
  PrivateAgreementsNewRouteRouteImport.update({
    id: '/agreements/new',
    path: '/agreements/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.agreements/new/route.lazy').then((d) => d.Route),
  )
const PrivateAccountReceivablesNewRouteRoute =
  PrivateAccountReceivablesNewRouteRouteImport.update({
    id: '/account-receivables/new',
    path: '/account-receivables/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.account-receivables/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateAccountReceivablesIdRouteRoute =
  PrivateAccountReceivablesIdRouteRouteImport.update({
    id: '/account-receivables/$id',
    path: '/account-receivables/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.account-receivables/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PublicSignupIndexRouteRoute = PublicSignupIndexRouteRouteImport.update({
  id: '/signup/',
  path: '/signup',
  getParentRoute: () => PublicRoute,
} as any).lazy(() =>
  import('./_routes/_public.signup/index/route.lazy').then((d) => d.Route),
)
const PublicResetPasswordIndexRouteRoute =
  PublicResetPasswordIndexRouteRouteImport.update({
    id: '/reset-password/',
    path: '/reset-password',
    getParentRoute: () => PublicRoute,
  } as any).lazy(() =>
    import('./_routes/_public.reset-password/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PublicLoginIndexRouteRoute = PublicLoginIndexRouteRouteImport.update({
  id: '/login/',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any).lazy(() =>
  import('./_routes/_public.login/index/route.lazy').then((d) => d.Route),
)
const PublicForgotPasswordIndexRouteRoute =
  PublicForgotPasswordIndexRouteRouteImport.update({
    id: '/forgot-password/',
    path: '/forgot-password',
    getParentRoute: () => PublicRoute,
  } as any).lazy(() =>
    import('./_routes/_public.forgot-password/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateTeamMembersIndexRouteRoute =
  PrivateTeamMembersIndexRouteRouteImport.update({
    id: '/team-members/',
    path: '/team-members',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.team-members/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSystemUsersIndexRouteRoute =
  PrivateSystemUsersIndexRouteRouteImport.update({
    id: '/system-users/',
    path: '/system-users',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.system-users/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSupportIndexRouteRoute =
  PrivateSupportIndexRouteRouteImport.update({
    id: '/support/',
    path: '/support',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.support/index/route.lazy').then((d) => d.Route),
  )
const PrivateSettingsIndexRouteRoute =
  PrivateSettingsIndexRouteRouteImport.update({
    id: '/settings/',
    path: '/settings',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/index/route.lazy').then((d) => d.Route),
  )
const PrivateRecruitingIndexRouteRoute =
  PrivateRecruitingIndexRouteRouteImport.update({
    id: '/recruiting/',
    path: '/recruiting',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.recruiting/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateProductsAndServicesIndexRouteRoute =
  PrivateProductsAndServicesIndexRouteRouteImport.update({
    id: '/products-and-services/',
    path: '/products-and-services',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.products-and-services/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivatePickTicketsIndexRouteRoute =
  PrivatePickTicketsIndexRouteRouteImport.update({
    id: '/pick-tickets/',
    path: '/pick-tickets',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.pick-tickets/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateMediaIndexRouteRoute = PrivateMediaIndexRouteRouteImport.update({
  id: '/media/',
  path: '/media',
  getParentRoute: () => PrivateRoute,
} as any).lazy(() =>
  import('./_routes/_private.media/index/route.lazy').then((d) => d.Route),
)
const PrivateMarketingCampaignsIndexRouteRoute =
  PrivateMarketingCampaignsIndexRouteRouteImport.update({
    id: '/marketing-campaigns/',
    path: '/marketing-campaigns',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.marketing-campaigns/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateInvoicesIndexRouteRoute =
  PrivateInvoicesIndexRouteRouteImport.update({
    id: '/invoices/',
    path: '/invoices',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.invoices/index/route.lazy').then((d) => d.Route),
  )
const PrivateInventoryIndexRouteRoute =
  PrivateInventoryIndexRouteRouteImport.update({
    id: '/inventory/',
    path: '/inventory',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.inventory/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateGovernanceIndexRouteRoute =
  PrivateGovernanceIndexRouteRouteImport.update({
    id: '/governance/',
    path: '/governance',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.governance/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateFinancialSnapshotsIndexRouteRoute =
  PrivateFinancialSnapshotsIndexRouteRouteImport.update({
    id: '/financial-snapshots/',
    path: '/financial-snapshots',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.financial-snapshots/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateDomainsIndexRouteRoute =
  PrivateDomainsIndexRouteRouteImport.update({
    id: '/domains/',
    path: '/domains',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.domains/index/route.lazy').then((d) => d.Route),
  )
const PrivateDepositsIndexRouteRoute =
  PrivateDepositsIndexRouteRouteImport.update({
    id: '/deposits/',
    path: '/deposits',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.deposits/index/route.lazy').then((d) => d.Route),
  )
const PrivateDashboardIndexRouteRoute =
  PrivateDashboardIndexRouteRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.dashboard/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateContactsIndexRouteRoute =
  PrivateContactsIndexRouteRouteImport.update({
    id: '/contacts/',
    path: '/contacts',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.contacts/index/route.lazy').then((d) => d.Route),
  )
const PrivateConnectedAppsIndexRouteRoute =
  PrivateConnectedAppsIndexRouteRouteImport.update({
    id: '/connected-apps/',
    path: '/connected-apps',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.connected-apps/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateConferencesAndEventsIndexRouteRoute =
  PrivateConferencesAndEventsIndexRouteRouteImport.update({
    id: '/conferences-and-events/',
    path: '/conferences-and-events',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.conferences-and-events/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompetitorsIndexRouteRoute =
  PrivateCompetitorsIndexRouteRouteImport.update({
    id: '/competitors/',
    path: '/competitors',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.competitors/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompaniesIndexRouteRoute =
  PrivateCompaniesIndexRouteRouteImport.update({
    id: '/companies/',
    path: '/companies',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.companies/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateAwardsIndexRouteRoute = PrivateAwardsIndexRouteRouteImport.update({
  id: '/awards/',
  path: '/awards',
  getParentRoute: () => PrivateRoute,
} as any).lazy(() =>
  import('./_routes/_private.awards/index/route.lazy').then((d) => d.Route),
)
const PrivateAgreementsIndexRouteRoute =
  PrivateAgreementsIndexRouteRouteImport.update({
    id: '/agreements/',
    path: '/agreements',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.agreements/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateAccountReceivablesIndexRouteRoute =
  PrivateAccountReceivablesIndexRouteRouteImport.update({
    id: '/account-receivables/',
    path: '/account-receivables',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.account-receivables/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRegistrarsTemplateRoute =
  PrivateSettingsRegistrarsTemplateRouteImport.update({
    id: '/settings/registrars/_template',
    path: '/settings/registrars',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/registrars/_template.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsJobPositionsTemplateRoute =
  PrivateSettingsJobPositionsTemplateRouteImport.update({
    id: '/settings/job-positions/_template',
    path: '/settings/job-positions',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/job-positions/_template.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsUserRolesNewRouteRoute =
  PrivateSettingsUserRolesNewRouteRouteImport.update({
    id: '/settings/user-roles/new',
    path: '/settings/user-roles/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/user-roles/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsUserRolesIdRouteRoute =
  PrivateSettingsUserRolesIdRouteRouteImport.update({
    id: '/settings/user-roles/$id',
    path: '/settings/user-roles/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/user-roles/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsUnitSellBysNewRouteRoute =
  PrivateSettingsUnitSellBysNewRouteRouteImport.update({
    id: '/settings/unit-sell-bys/new',
    path: '/settings/unit-sell-bys/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/unit-sell-bys/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsUnitSellBysIdRouteRoute =
  PrivateSettingsUnitSellBysIdRouteRouteImport.update({
    id: '/settings/unit-sell-bys/$id',
    path: '/settings/unit-sell-bys/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/unit-sell-bys/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsTermsTemplatesNewRouteRoute =
  PrivateSettingsTermsTemplatesNewRouteRouteImport.update({
    id: '/settings/terms-templates/new',
    path: '/settings/terms-templates/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/terms-templates/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsTermsTemplatesIdRouteRoute =
  PrivateSettingsTermsTemplatesIdRouteRouteImport.update({
    id: '/settings/terms-templates/$id',
    path: '/settings/terms-templates/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/terms-templates/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsTermsConditionsNewRouteRoute =
  PrivateSettingsTermsConditionsNewRouteRouteImport.update({
    id: '/settings/terms-conditions/new',
    path: '/settings/terms-conditions/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/terms-conditions/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsTermsConditionsIdRouteRoute =
  PrivateSettingsTermsConditionsIdRouteRouteImport.update({
    id: '/settings/terms-conditions/$id',
    path: '/settings/terms-conditions/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/terms-conditions/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsTermsCategoriesNewRouteRoute =
  PrivateSettingsTermsCategoriesNewRouteRouteImport.update({
    id: '/settings/terms-categories/new',
    path: '/settings/terms-categories/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/terms-categories/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsTermsCategoriesIdRouteRoute =
  PrivateSettingsTermsCategoriesIdRouteRouteImport.update({
    id: '/settings/terms-categories/$id',
    path: '/settings/terms-categories/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/terms-categories/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsSystemFilesNewRouteRoute =
  PrivateSettingsSystemFilesNewRouteRouteImport.update({
    id: '/settings/system-files/new',
    path: '/settings/system-files/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/system-files/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsSystemFilesIdRouteRoute =
  PrivateSettingsSystemFilesIdRouteRouteImport.update({
    id: '/settings/system-files/$id',
    path: '/settings/system-files/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/system-files/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsSalaryGradesNewRouteRoute =
  PrivateSettingsSalaryGradesNewRouteRouteImport.update({
    id: '/settings/salary-grades/new',
    path: '/settings/salary-grades/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/salary-grades/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsSalaryGradesIdRouteRoute =
  PrivateSettingsSalaryGradesIdRouteRouteImport.update({
    id: '/settings/salary-grades/$id',
    path: '/settings/salary-grades/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/salary-grades/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRevenueLockdownsNewRouteRoute =
  PrivateSettingsRevenueLockdownsNewRouteRouteImport.update({
    id: '/settings/revenue-lockdowns/new',
    path: '/settings/revenue-lockdowns/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/revenue-lockdowns/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRevenueLockdownsIdRouteRoute =
  PrivateSettingsRevenueLockdownsIdRouteRouteImport.update({
    id: '/settings/revenue-lockdowns/$id',
    path: '/settings/revenue-lockdowns/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/revenue-lockdowns/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRelationshipScoresNewRouteRoute =
  PrivateSettingsRelationshipScoresNewRouteRouteImport.update({
    id: '/settings/relationship-scores/new',
    path: '/settings/relationship-scores/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/relationship-scores/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRelationshipScoresIdRouteRoute =
  PrivateSettingsRelationshipScoresIdRouteRouteImport.update({
    id: '/settings/relationship-scores/$id',
    path: '/settings/relationship-scores/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/relationship-scores/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRegistrarsNewRouteRoute =
  PrivateSettingsRegistrarsNewRouteRouteImport.update({
    id: '/settings/registrars/new',
    path: '/settings/registrars/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/registrars/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRecruitingStatusesNewRouteRoute =
  PrivateSettingsRecruitingStatusesNewRouteRouteImport.update({
    id: '/settings/recruiting-statuses/new',
    path: '/settings/recruiting-statuses/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/recruiting-statuses/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRecruitingStatusesIdRouteRoute =
  PrivateSettingsRecruitingStatusesIdRouteRouteImport.update({
    id: '/settings/recruiting-statuses/$id',
    path: '/settings/recruiting-statuses/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/recruiting-statuses/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRecruitingJobCategoriesNewRouteRoute =
  PrivateSettingsRecruitingJobCategoriesNewRouteRouteImport.update({
    id: '/settings/recruiting-job-categories/new',
    path: '/settings/recruiting-job-categories/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/recruiting-job-categories/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRecruitingJobCategoriesIdRouteRoute =
  PrivateSettingsRecruitingJobCategoriesIdRouteRouteImport.update({
    id: '/settings/recruiting-job-categories/$id',
    path: '/settings/recruiting-job-categories/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/recruiting-job-categories/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRecruitingHiringCriteriaCategoriesNewRouteRoute =
  PrivateSettingsRecruitingHiringCriteriaCategoriesNewRouteRouteImport.update({
    id: '/settings/recruiting-hiring-criteria-categories/new',
    path: '/settings/recruiting-hiring-criteria-categories/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/recruiting-hiring-criteria-categories/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRecruitingHiringCriteriaCategoriesIdRouteRoute =
  PrivateSettingsRecruitingHiringCriteriaCategoriesIdRouteRouteImport.update({
    id: '/settings/recruiting-hiring-criteria-categories/$id',
    path: '/settings/recruiting-hiring-criteria-categories/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/recruiting-hiring-criteria-categories/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsProductsAndServicesTemplatesNewRouteRoute =
  PrivateSettingsProductsAndServicesTemplatesNewRouteRouteImport.update({
    id: '/settings/products-and-services-templates/new',
    path: '/settings/products-and-services-templates/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/products-and-services-templates/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsProductsAndServicesTemplatesIdRouteRoute =
  PrivateSettingsProductsAndServicesTemplatesIdRouteRouteImport.update({
    id: '/settings/products-and-services-templates/$id',
    path: '/settings/products-and-services-templates/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/products-and-services-templates/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsPriceFrequenciesNewRouteRoute =
  PrivateSettingsPriceFrequenciesNewRouteRouteImport.update({
    id: '/settings/price-frequencies/new',
    path: '/settings/price-frequencies/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/price-frequencies/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsPriceFrequenciesIdRouteRoute =
  PrivateSettingsPriceFrequenciesIdRouteRouteImport.update({
    id: '/settings/price-frequencies/$id',
    path: '/settings/price-frequencies/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/price-frequencies/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsPreferredRelationshipsNewRouteRoute =
  PrivateSettingsPreferredRelationshipsNewRouteRouteImport.update({
    id: '/settings/preferred-relationships/new',
    path: '/settings/preferred-relationships/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/preferred-relationships/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsPreferredRelationshipsIdRouteRoute =
  PrivateSettingsPreferredRelationshipsIdRouteRouteImport.update({
    id: '/settings/preferred-relationships/$id',
    path: '/settings/preferred-relationships/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/preferred-relationships/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsPreferredLocationsNewRouteRoute =
  PrivateSettingsPreferredLocationsNewRouteRouteImport.update({
    id: '/settings/preferred-locations/new',
    path: '/settings/preferred-locations/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/preferred-locations/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsPreferredLocationsIdRouteRoute =
  PrivateSettingsPreferredLocationsIdRouteRouteImport.update({
    id: '/settings/preferred-locations/$id',
    path: '/settings/preferred-locations/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/preferred-locations/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsPaymentMethodsNewRouteRoute =
  PrivateSettingsPaymentMethodsNewRouteRouteImport.update({
    id: '/settings/payment-methods/new',
    path: '/settings/payment-methods/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/payment-methods/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsPaymentMethodsIdRouteRoute =
  PrivateSettingsPaymentMethodsIdRouteRouteImport.update({
    id: '/settings/payment-methods/$id',
    path: '/settings/payment-methods/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/payment-methods/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsPartnersNewRouteRoute =
  PrivateSettingsPartnersNewRouteRouteImport.update({
    id: '/settings/partners/new',
    path: '/settings/partners/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/partners/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsPartnersIdRouteRoute =
  PrivateSettingsPartnersIdRouteRouteImport.update({
    id: '/settings/partners/$id',
    path: '/settings/partners/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/partners/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsOrganizationTypesNewRouteRoute =
  PrivateSettingsOrganizationTypesNewRouteRouteImport.update({
    id: '/settings/organization-types/new',
    path: '/settings/organization-types/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/organization-types/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsOrganizationTypesIdRouteRoute =
  PrivateSettingsOrganizationTypesIdRouteRouteImport.update({
    id: '/settings/organization-types/$id',
    path: '/settings/organization-types/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/organization-types/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsMileageRatesNewRouteRoute =
  PrivateSettingsMileageRatesNewRouteRouteImport.update({
    id: '/settings/mileage-rates/new',
    path: '/settings/mileage-rates/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/mileage-rates/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsMileageRatesIdRouteRoute =
  PrivateSettingsMileageRatesIdRouteRouteImport.update({
    id: '/settings/mileage-rates/$id',
    path: '/settings/mileage-rates/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/mileage-rates/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsManufacturersNewRouteRoute =
  PrivateSettingsManufacturersNewRouteRouteImport.update({
    id: '/settings/manufacturers/new',
    path: '/settings/manufacturers/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/manufacturers/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsManufacturersIdRouteRoute =
  PrivateSettingsManufacturersIdRouteRouteImport.update({
    id: '/settings/manufacturers/$id',
    path: '/settings/manufacturers/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/manufacturers/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsMagazinesNewRouteRoute =
  PrivateSettingsMagazinesNewRouteRouteImport.update({
    id: '/settings/magazines/new',
    path: '/settings/magazines/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/magazines/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsMagazinesIdRouteRoute =
  PrivateSettingsMagazinesIdRouteRouteImport.update({
    id: '/settings/magazines/$id',
    path: '/settings/magazines/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/magazines/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsJobPositionsNewRouteRoute =
  PrivateSettingsJobPositionsNewRouteRouteImport.update({
    id: '/settings/job-positions/new',
    path: '/settings/job-positions/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/job-positions/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryVolumesNewRouteRoute =
  PrivateSettingsInventoryVolumesNewRouteRouteImport.update({
    id: '/settings/inventory-volumes/new',
    path: '/settings/inventory-volumes/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-volumes/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryVolumesIdRouteRoute =
  PrivateSettingsInventoryVolumesIdRouteRouteImport.update({
    id: '/settings/inventory-volumes/$id',
    path: '/settings/inventory-volumes/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-volumes/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryVendorsNewRouteRoute =
  PrivateSettingsInventoryVendorsNewRouteRouteImport.update({
    id: '/settings/inventory-vendors/new',
    path: '/settings/inventory-vendors/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-vendors/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryVendorsIdRouteRoute =
  PrivateSettingsInventoryVendorsIdRouteRouteImport.update({
    id: '/settings/inventory-vendors/$id',
    path: '/settings/inventory-vendors/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-vendors/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryStocksNewRouteRoute =
  PrivateSettingsInventoryStocksNewRouteRouteImport.update({
    id: '/settings/inventory-stocks/new',
    path: '/settings/inventory-stocks/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-stocks/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryStocksIdRouteRoute =
  PrivateSettingsInventoryStocksIdRouteRouteImport.update({
    id: '/settings/inventory-stocks/$id',
    path: '/settings/inventory-stocks/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-stocks/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryPurchasesNewRouteRoute =
  PrivateSettingsInventoryPurchasesNewRouteRouteImport.update({
    id: '/settings/inventory-purchases/new',
    path: '/settings/inventory-purchases/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-purchases/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryPurchasesIdRouteRoute =
  PrivateSettingsInventoryPurchasesIdRouteRouteImport.update({
    id: '/settings/inventory-purchases/$id',
    path: '/settings/inventory-purchases/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-purchases/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryKitsNewRouteRoute =
  PrivateSettingsInventoryKitsNewRouteRouteImport.update({
    id: '/settings/inventory-kits/new',
    path: '/settings/inventory-kits/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-kits/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryKitsIdRouteRoute =
  PrivateSettingsInventoryKitsIdRouteRouteImport.update({
    id: '/settings/inventory-kits/$id',
    path: '/settings/inventory-kits/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-kits/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryCategoriesNewRouteRoute =
  PrivateSettingsInventoryCategoriesNewRouteRouteImport.update({
    id: '/settings/inventory-categories/new',
    path: '/settings/inventory-categories/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-categories/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryCategoriesIdRouteRoute =
  PrivateSettingsInventoryCategoriesIdRouteRouteImport.update({
    id: '/settings/inventory-categories/$id',
    path: '/settings/inventory-categories/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-categories/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryBinLocationsNewRouteRoute =
  PrivateSettingsInventoryBinLocationsNewRouteRouteImport.update({
    id: '/settings/inventory-bin-locations/new',
    path: '/settings/inventory-bin-locations/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-bin-locations/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryBinLocationsIdRouteRoute =
  PrivateSettingsInventoryBinLocationsIdRouteRouteImport.update({
    id: '/settings/inventory-bin-locations/$id',
    path: '/settings/inventory-bin-locations/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-bin-locations/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInfrastructuresNewRouteRoute =
  PrivateSettingsInfrastructuresNewRouteRouteImport.update({
    id: '/settings/infrastructures/new',
    path: '/settings/infrastructures/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/infrastructures/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInfrastructuresIdRouteRoute =
  PrivateSettingsInfrastructuresIdRouteRouteImport.update({
    id: '/settings/infrastructures/$id',
    path: '/settings/infrastructures/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/infrastructures/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsIndustriesNewRouteRoute =
  PrivateSettingsIndustriesNewRouteRouteImport.update({
    id: '/settings/industries/new',
    path: '/settings/industries/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/industries/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsIndustriesIdRouteRoute =
  PrivateSettingsIndustriesIdRouteRouteImport.update({
    id: '/settings/industries/$id',
    path: '/settings/industries/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/industries/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsEmailTemplatesNewRouteRoute =
  PrivateSettingsEmailTemplatesNewRouteRouteImport.update({
    id: '/settings/email-templates/new',
    path: '/settings/email-templates/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/email-templates/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsEmailTemplatesIdRouteRoute =
  PrivateSettingsEmailTemplatesIdRouteRouteImport.update({
    id: '/settings/email-templates/$id',
    path: '/settings/email-templates/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/email-templates/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsEmailHistoryIdRouteRoute =
  PrivateSettingsEmailHistoryIdRouteRouteImport.update({
    id: '/settings/email-history/$id',
    path: '/settings/email-history/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/email-history/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsDepartmentsNewRouteRoute =
  PrivateSettingsDepartmentsNewRouteRouteImport.update({
    id: '/settings/departments/new',
    path: '/settings/departments/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/departments/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsDepartmentsIdRouteRoute =
  PrivateSettingsDepartmentsIdRouteRouteImport.update({
    id: '/settings/departments/$id',
    path: '/settings/departments/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/departments/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsCountriesNewRouteRoute =
  PrivateSettingsCountriesNewRouteRouteImport.update({
    id: '/settings/countries/new',
    path: '/settings/countries/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/countries/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsCountriesIdRouteRoute =
  PrivateSettingsCountriesIdRouteRouteImport.update({
    id: '/settings/countries/$id',
    path: '/settings/countries/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/countries/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsCommissionPlansNewRouteRoute =
  PrivateSettingsCommissionPlansNewRouteRouteImport.update({
    id: '/settings/commission-plans/new',
    path: '/settings/commission-plans/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/commission-plans/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsCommissionPlansIdRouteRoute =
  PrivateSettingsCommissionPlansIdRouteRouteImport.update({
    id: '/settings/commission-plans/$id',
    path: '/settings/commission-plans/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/commission-plans/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsCategoriesNewRouteRoute =
  PrivateSettingsCategoriesNewRouteRouteImport.update({
    id: '/settings/categories/new',
    path: '/settings/categories/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/categories/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsCategoriesIdRouteRoute =
  PrivateSettingsCategoriesIdRouteRouteImport.update({
    id: '/settings/categories/$id',
    path: '/settings/categories/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/categories/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsBusinessDisciplinesNewRouteRoute =
  PrivateSettingsBusinessDisciplinesNewRouteRouteImport.update({
    id: '/settings/business-disciplines/new',
    path: '/settings/business-disciplines/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/business-disciplines/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsBusinessDisciplinesIdRouteRoute =
  PrivateSettingsBusinessDisciplinesIdRouteRouteImport.update({
    id: '/settings/business-disciplines/$id',
    path: '/settings/business-disciplines/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/business-disciplines/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsBrandsNewRouteRoute =
  PrivateSettingsBrandsNewRouteRouteImport.update({
    id: '/settings/brands/new',
    path: '/settings/brands/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/brands/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsBrandsIdRouteRoute =
  PrivateSettingsBrandsIdRouteRouteImport.update({
    id: '/settings/brands/$id',
    path: '/settings/brands/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/brands/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsBillingTermsNewRouteRoute =
  PrivateSettingsBillingTermsNewRouteRouteImport.update({
    id: '/settings/billing-terms/new',
    path: '/settings/billing-terms/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/billing-terms/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsBillingTermsIdRouteRoute =
  PrivateSettingsBillingTermsIdRouteRouteImport.update({
    id: '/settings/billing-terms/$id',
    path: '/settings/billing-terms/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/billing-terms/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsBillingSystemsNewRouteRoute =
  PrivateSettingsBillingSystemsNewRouteRouteImport.update({
    id: '/settings/billing-systems/new',
    path: '/settings/billing-systems/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/billing-systems/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsBillingSystemsIdRouteRoute =
  PrivateSettingsBillingSystemsIdRouteRouteImport.update({
    id: '/settings/billing-systems/$id',
    path: '/settings/billing-systems/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/billing-systems/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsBankAccountsNewRouteRoute =
  PrivateSettingsBankAccountsNewRouteRouteImport.update({
    id: '/settings/bank-accounts/new',
    path: '/settings/bank-accounts/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/bank-accounts/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsBankAccountsIdRouteRoute =
  PrivateSettingsBankAccountsIdRouteRouteImport.update({
    id: '/settings/bank-accounts/$id',
    path: '/settings/bank-accounts/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/bank-accounts/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsAudiencesNewRouteRoute =
  PrivateSettingsAudiencesNewRouteRouteImport.update({
    id: '/settings/audiences/new',
    path: '/settings/audiences/new',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/audiences/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsAudiencesIdRouteRoute =
  PrivateSettingsAudiencesIdRouteRouteImport.update({
    id: '/settings/audiences/$id',
    path: '/settings/audiences/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/audiences/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateInvoicesInvoiceBatchIdRouteRoute =
  PrivateInvoicesInvoiceBatchIdRouteRouteImport.update({
    id: '/invoices/invoice-batch/$id',
    path: '/invoices/invoice-batch/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.invoices/invoice-batch.$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateInventoryParentIdRouteRoute =
  PrivateInventoryParentIdRouteRouteImport.update({
    id: '/inventory/parent/$id',
    path: '/inventory/parent/$id',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.inventory/parent.$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsUserRolesIndexRouteRoute =
  PrivateSettingsUserRolesIndexRouteRouteImport.update({
    id: '/settings/user-roles/',
    path: '/settings/user-roles',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/user-roles/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsUnitSellBysIndexRouteRoute =
  PrivateSettingsUnitSellBysIndexRouteRouteImport.update({
    id: '/settings/unit-sell-bys/',
    path: '/settings/unit-sell-bys',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/unit-sell-bys/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsTermsTemplatesIndexRouteRoute =
  PrivateSettingsTermsTemplatesIndexRouteRouteImport.update({
    id: '/settings/terms-templates/',
    path: '/settings/terms-templates',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/terms-templates/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsTermsConditionsIndexRouteRoute =
  PrivateSettingsTermsConditionsIndexRouteRouteImport.update({
    id: '/settings/terms-conditions/',
    path: '/settings/terms-conditions',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/terms-conditions/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsTermsCategoriesIndexRouteRoute =
  PrivateSettingsTermsCategoriesIndexRouteRouteImport.update({
    id: '/settings/terms-categories/',
    path: '/settings/terms-categories',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/terms-categories/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsSystemFilesIndexRouteRoute =
  PrivateSettingsSystemFilesIndexRouteRouteImport.update({
    id: '/settings/system-files/',
    path: '/settings/system-files',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/system-files/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsSalaryGradesIndexRouteRoute =
  PrivateSettingsSalaryGradesIndexRouteRouteImport.update({
    id: '/settings/salary-grades/',
    path: '/settings/salary-grades',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/salary-grades/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRevenueLockdownsIndexRouteRoute =
  PrivateSettingsRevenueLockdownsIndexRouteRouteImport.update({
    id: '/settings/revenue-lockdowns/',
    path: '/settings/revenue-lockdowns',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/revenue-lockdowns/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRelationshipScoresIndexRouteRoute =
  PrivateSettingsRelationshipScoresIndexRouteRouteImport.update({
    id: '/settings/relationship-scores/',
    path: '/settings/relationship-scores',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/relationship-scores/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRegistrarsIndexRouteRoute =
  PrivateSettingsRegistrarsIndexRouteRouteImport.update({
    id: '/settings/registrars/',
    path: '/settings/registrars',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/registrars/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRecruitingStatusesIndexRouteRoute =
  PrivateSettingsRecruitingStatusesIndexRouteRouteImport.update({
    id: '/settings/recruiting-statuses/',
    path: '/settings/recruiting-statuses',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/recruiting-statuses/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRecruitingJobCategoriesIndexRouteRoute =
  PrivateSettingsRecruitingJobCategoriesIndexRouteRouteImport.update({
    id: '/settings/recruiting-job-categories/',
    path: '/settings/recruiting-job-categories',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/recruiting-job-categories/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRecruitingHiringCriteriaCategoriesIndexRouteRoute =
  PrivateSettingsRecruitingHiringCriteriaCategoriesIndexRouteRouteImport.update(
    {
      id: '/settings/recruiting-hiring-criteria-categories/',
      path: '/settings/recruiting-hiring-criteria-categories',
      getParentRoute: () => PrivateRoute,
    } as any,
  ).lazy(() =>
    import('./_routes/_private.settings/recruiting-hiring-criteria-categories/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsProductsAndServicesTemplatesIndexRouteRoute =
  PrivateSettingsProductsAndServicesTemplatesIndexRouteRouteImport.update({
    id: '/settings/products-and-services-templates/',
    path: '/settings/products-and-services-templates',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/products-and-services-templates/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsPriceFrequenciesIndexRouteRoute =
  PrivateSettingsPriceFrequenciesIndexRouteRouteImport.update({
    id: '/settings/price-frequencies/',
    path: '/settings/price-frequencies',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/price-frequencies/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsPreferredRelationshipsIndexRouteRoute =
  PrivateSettingsPreferredRelationshipsIndexRouteRouteImport.update({
    id: '/settings/preferred-relationships/',
    path: '/settings/preferred-relationships',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/preferred-relationships/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsPreferredLocationsIndexRouteRoute =
  PrivateSettingsPreferredLocationsIndexRouteRouteImport.update({
    id: '/settings/preferred-locations/',
    path: '/settings/preferred-locations',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/preferred-locations/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsPaymentMethodsIndexRouteRoute =
  PrivateSettingsPaymentMethodsIndexRouteRouteImport.update({
    id: '/settings/payment-methods/',
    path: '/settings/payment-methods',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/payment-methods/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsPartnersIndexRouteRoute =
  PrivateSettingsPartnersIndexRouteRouteImport.update({
    id: '/settings/partners/',
    path: '/settings/partners',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/partners/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsOrganizationTypesIndexRouteRoute =
  PrivateSettingsOrganizationTypesIndexRouteRouteImport.update({
    id: '/settings/organization-types/',
    path: '/settings/organization-types',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/organization-types/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsMileageRatesIndexRouteRoute =
  PrivateSettingsMileageRatesIndexRouteRouteImport.update({
    id: '/settings/mileage-rates/',
    path: '/settings/mileage-rates',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/mileage-rates/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsManufacturersIndexRouteRoute =
  PrivateSettingsManufacturersIndexRouteRouteImport.update({
    id: '/settings/manufacturers/',
    path: '/settings/manufacturers',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/manufacturers/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsMagazinesIndexRouteRoute =
  PrivateSettingsMagazinesIndexRouteRouteImport.update({
    id: '/settings/magazines/',
    path: '/settings/magazines',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/magazines/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsJobPositionsIndexRouteRoute =
  PrivateSettingsJobPositionsIndexRouteRouteImport.update({
    id: '/settings/job-positions/',
    path: '/settings/job-positions',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/job-positions/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryVolumesIndexRouteRoute =
  PrivateSettingsInventoryVolumesIndexRouteRouteImport.update({
    id: '/settings/inventory-volumes/',
    path: '/settings/inventory-volumes',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-volumes/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryVendorsIndexRouteRoute =
  PrivateSettingsInventoryVendorsIndexRouteRouteImport.update({
    id: '/settings/inventory-vendors/',
    path: '/settings/inventory-vendors',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-vendors/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryStocksIndexRouteRoute =
  PrivateSettingsInventoryStocksIndexRouteRouteImport.update({
    id: '/settings/inventory-stocks/',
    path: '/settings/inventory-stocks',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-stocks/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryPurchasesIndexRouteRoute =
  PrivateSettingsInventoryPurchasesIndexRouteRouteImport.update({
    id: '/settings/inventory-purchases/',
    path: '/settings/inventory-purchases',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-purchases/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryKitsIndexRouteRoute =
  PrivateSettingsInventoryKitsIndexRouteRouteImport.update({
    id: '/settings/inventory-kits/',
    path: '/settings/inventory-kits',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-kits/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryCategoriesIndexRouteRoute =
  PrivateSettingsInventoryCategoriesIndexRouteRouteImport.update({
    id: '/settings/inventory-categories/',
    path: '/settings/inventory-categories',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-categories/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInventoryBinLocationsIndexRouteRoute =
  PrivateSettingsInventoryBinLocationsIndexRouteRouteImport.update({
    id: '/settings/inventory-bin-locations/',
    path: '/settings/inventory-bin-locations',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/inventory-bin-locations/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsInfrastructuresIndexRouteRoute =
  PrivateSettingsInfrastructuresIndexRouteRouteImport.update({
    id: '/settings/infrastructures/',
    path: '/settings/infrastructures',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/infrastructures/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsIndustriesIndexRouteRoute =
  PrivateSettingsIndustriesIndexRouteRouteImport.update({
    id: '/settings/industries/',
    path: '/settings/industries',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/industries/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsEmailTemplatesIndexRouteRoute =
  PrivateSettingsEmailTemplatesIndexRouteRouteImport.update({
    id: '/settings/email-templates/',
    path: '/settings/email-templates',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/email-templates/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsEmailTemplateDefaultsIndexRouteRoute =
  PrivateSettingsEmailTemplateDefaultsIndexRouteRouteImport.update({
    id: '/settings/email-template-defaults/',
    path: '/settings/email-template-defaults',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/email-template-defaults/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsEmailHistoryIndexRouteRoute =
  PrivateSettingsEmailHistoryIndexRouteRouteImport.update({
    id: '/settings/email-history/',
    path: '/settings/email-history',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/email-history/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsDepartmentsIndexRouteRoute =
  PrivateSettingsDepartmentsIndexRouteRouteImport.update({
    id: '/settings/departments/',
    path: '/settings/departments',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/departments/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsCountriesIndexRouteRoute =
  PrivateSettingsCountriesIndexRouteRouteImport.update({
    id: '/settings/countries/',
    path: '/settings/countries',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/countries/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsCommissionPlansIndexRouteRoute =
  PrivateSettingsCommissionPlansIndexRouteRouteImport.update({
    id: '/settings/commission-plans/',
    path: '/settings/commission-plans',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/commission-plans/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsCategoriesIndexRouteRoute =
  PrivateSettingsCategoriesIndexRouteRouteImport.update({
    id: '/settings/categories/',
    path: '/settings/categories',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/categories/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsBusinessDisciplinesIndexRouteRoute =
  PrivateSettingsBusinessDisciplinesIndexRouteRouteImport.update({
    id: '/settings/business-disciplines/',
    path: '/settings/business-disciplines',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/business-disciplines/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsBrandsIndexRouteRoute =
  PrivateSettingsBrandsIndexRouteRouteImport.update({
    id: '/settings/brands/',
    path: '/settings/brands',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/brands/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsBillingTermsIndexRouteRoute =
  PrivateSettingsBillingTermsIndexRouteRouteImport.update({
    id: '/settings/billing-terms/',
    path: '/settings/billing-terms',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/billing-terms/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsBillingSystemsIndexRouteRoute =
  PrivateSettingsBillingSystemsIndexRouteRouteImport.update({
    id: '/settings/billing-systems/',
    path: '/settings/billing-systems',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/billing-systems/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsBankAccountsIndexRouteRoute =
  PrivateSettingsBankAccountsIndexRouteRouteImport.update({
    id: '/settings/bank-accounts/',
    path: '/settings/bank-accounts',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/bank-accounts/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsAudiencesIndexRouteRoute =
  PrivateSettingsAudiencesIndexRouteRouteImport.update({
    id: '/settings/audiences/',
    path: '/settings/audiences',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/audiences/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateTeamMembersTemplateIdPreferenceRouteRoute =
  PrivateTeamMembersTemplateIdPreferenceRouteRouteImport.update({
    id: '/$id/preference',
    path: '/$id/preference',
    getParentRoute: () => PrivateTeamMembersTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.team-members/_template.$id/preference/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateTeamMembersTemplateIdPersonalDetailsRouteRoute =
  PrivateTeamMembersTemplateIdPersonalDetailsRouteRouteImport.update({
    id: '/$id/personal-details',
    path: '/$id/personal-details',
    getParentRoute: () => PrivateTeamMembersTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.team-members/_template.$id/personal-details/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateTeamMembersTemplateIdMarketingRouteRoute =
  PrivateTeamMembersTemplateIdMarketingRouteRouteImport.update({
    id: '/$id/marketing',
    path: '/$id/marketing',
    getParentRoute: () => PrivateTeamMembersTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.team-members/_template.$id/marketing/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateTeamMembersTemplateIdEmergencyRouteRoute =
  PrivateTeamMembersTemplateIdEmergencyRouteRouteImport.update({
    id: '/$id/emergency',
    path: '/$id/emergency',
    getParentRoute: () => PrivateTeamMembersTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.team-members/_template.$id/emergency/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateTeamMembersTemplateIdCommissionPeriodsRouteRoute =
  PrivateTeamMembersTemplateIdCommissionPeriodsRouteRouteImport.update({
    id: '/$id/commission-periods',
    path: '/$id/commission-periods',
    getParentRoute: () => PrivateTeamMembersTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.team-members/_template.$id/commission-periods/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateTeamMembersTemplateIdApiIntegrationRouteRoute =
  PrivateTeamMembersTemplateIdApiIntegrationRouteRouteImport.update({
    id: '/$id/api-integration',
    path: '/$id/api-integration',
    getParentRoute: () => PrivateTeamMembersTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.team-members/_template.$id/api-integration/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateInventoryTemplateIdVendorsRouteRoute =
  PrivateInventoryTemplateIdVendorsRouteRouteImport.update({
    id: '/$id/vendors',
    path: '/$id/vendors',
    getParentRoute: () => PrivateInventoryTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.inventory/_template.$id/vendors/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateContactsTemplateIdNotesRouteRoute =
  PrivateContactsTemplateIdNotesRouteRouteImport.update({
    id: '/$id/notes',
    path: '/$id/notes',
    getParentRoute: () => PrivateContactsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.contacts/_template.$id/notes/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateContactsTemplateIdMarketingCampaignsRouteRoute =
  PrivateContactsTemplateIdMarketingCampaignsRouteRouteImport.update({
    id: '/$id/marketing-campaigns',
    path: '/$id/marketing-campaigns',
    getParentRoute: () => PrivateContactsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.contacts/_template.$id/marketing-campaigns/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateContactsTemplateIdApiIntegrationRouteRoute =
  PrivateContactsTemplateIdApiIntegrationRouteRouteImport.update({
    id: '/$id/api-integration',
    path: '/$id/api-integration',
    getParentRoute: () => PrivateContactsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.contacts/_template.$id/api-integration/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateContactsTemplateIdAgreementsRouteRoute =
  PrivateContactsTemplateIdAgreementsRouteRouteImport.update({
    id: '/$id/agreements',
    path: '/$id/agreements',
    getParentRoute: () => PrivateContactsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.contacts/_template.$id/agreements/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompetitorsTemplateIdNotesRouteRoute =
  PrivateCompetitorsTemplateIdNotesRouteRouteImport.update({
    id: '/$id/notes',
    path: '/$id/notes',
    getParentRoute: () => PrivateCompetitorsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.competitors/_template.$id/notes/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompetitorsTemplateIdContactsRouteRoute =
  PrivateCompetitorsTemplateIdContactsRouteRouteImport.update({
    id: '/$id/contacts',
    path: '/$id/contacts',
    getParentRoute: () => PrivateCompetitorsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.competitors/_template.$id/contacts/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompetitorsTemplateIdAssociatedCompaniesRouteRoute =
  PrivateCompetitorsTemplateIdAssociatedCompaniesRouteRouteImport.update({
    id: '/$id/associated-companies',
    path: '/$id/associated-companies',
    getParentRoute: () => PrivateCompetitorsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.competitors/_template.$id/associated-companies/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompaniesTemplateIdSubscriptionsRouteRoute =
  PrivateCompaniesTemplateIdSubscriptionsRouteRouteImport.update({
    id: '/$id/subscriptions',
    path: '/$id/subscriptions',
    getParentRoute: () => PrivateCompaniesTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.companies/_template.$id/subscriptions/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompaniesTemplateIdNotesRouteRoute =
  PrivateCompaniesTemplateIdNotesRouteRouteImport.update({
    id: '/$id/notes',
    path: '/$id/notes',
    getParentRoute: () => PrivateCompaniesTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.companies/_template.$id/notes/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompaniesTemplateIdMarketingCampaignsRouteRoute =
  PrivateCompaniesTemplateIdMarketingCampaignsRouteRouteImport.update({
    id: '/$id/marketing-campaigns',
    path: '/$id/marketing-campaigns',
    getParentRoute: () => PrivateCompaniesTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.companies/_template.$id/marketing-campaigns/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompaniesTemplateIdInvoiceHistoryRouteRoute =
  PrivateCompaniesTemplateIdInvoiceHistoryRouteRouteImport.update({
    id: '/$id/invoice-history',
    path: '/$id/invoice-history',
    getParentRoute: () => PrivateCompaniesTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.companies/_template.$id/invoice-history/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompaniesTemplateIdFinancialsRouteRoute =
  PrivateCompaniesTemplateIdFinancialsRouteRouteImport.update({
    id: '/$id/financials',
    path: '/$id/financials',
    getParentRoute: () => PrivateCompaniesTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.companies/_template.$id/financials/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompaniesTemplateIdDomainsRouteRoute =
  PrivateCompaniesTemplateIdDomainsRouteRouteImport.update({
    id: '/$id/domains',
    path: '/$id/domains',
    getParentRoute: () => PrivateCompaniesTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.companies/_template.$id/domains/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompaniesTemplateIdContactsRouteRoute =
  PrivateCompaniesTemplateIdContactsRouteRouteImport.update({
    id: '/$id/contacts',
    path: '/$id/contacts',
    getParentRoute: () => PrivateCompaniesTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.companies/_template.$id/contacts/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompaniesTemplateIdApiIntegrationRouteRoute =
  PrivateCompaniesTemplateIdApiIntegrationRouteRouteImport.update({
    id: '/$id/api-integration',
    path: '/$id/api-integration',
    getParentRoute: () => PrivateCompaniesTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.companies/_template.$id/api-integration/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompaniesTemplateIdAgreementsRouteRoute =
  PrivateCompaniesTemplateIdAgreementsRouteRouteImport.update({
    id: '/$id/agreements',
    path: '/$id/agreements',
    getParentRoute: () => PrivateCompaniesTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.companies/_template.$id/agreements/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateAgreementsTemplateIdSubsidiesRouteRoute =
  PrivateAgreementsTemplateIdSubsidiesRouteRouteImport.update({
    id: '/$id/subsidies',
    path: '/$id/subsidies',
    getParentRoute: () => PrivateAgreementsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.agreements/_template.$id/subsidies/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateAgreementsTemplateIdPaperworkRouteRoute =
  PrivateAgreementsTemplateIdPaperworkRouteRouteImport.update({
    id: '/$id/paperwork',
    path: '/$id/paperwork',
    getParentRoute: () => PrivateAgreementsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.agreements/_template.$id/paperwork/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateAgreementsTemplateIdFinancialOverrideRouteRoute =
  PrivateAgreementsTemplateIdFinancialOverrideRouteRouteImport.update({
    id: '/$id/financial-override',
    path: '/$id/financial-override',
    getParentRoute: () => PrivateAgreementsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.agreements/_template.$id/financial-override/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateAgreementsTemplateIdExecutionRouteRoute =
  PrivateAgreementsTemplateIdExecutionRouteRouteImport.update({
    id: '/$id/execution',
    path: '/$id/execution',
    getParentRoute: () => PrivateAgreementsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.agreements/_template.$id/execution/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateAgreementsTemplateIdDeliverablesRouteRoute =
  PrivateAgreementsTemplateIdDeliverablesRouteRouteImport.update({
    id: '/$id/deliverables',
    path: '/$id/deliverables',
    getParentRoute: () => PrivateAgreementsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.agreements/_template.$id/deliverables/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateAgreementsTemplateIdCommissionRouteRoute =
  PrivateAgreementsTemplateIdCommissionRouteRouteImport.update({
    id: '/$id/commission',
    path: '/$id/commission',
    getParentRoute: () => PrivateAgreementsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.agreements/_template.$id/commission/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateAgreementsTemplateIdApiIntegrationRouteRoute =
  PrivateAgreementsTemplateIdApiIntegrationRouteRouteImport.update({
    id: '/$id/api-integration',
    path: '/$id/api-integration',
    getParentRoute: () => PrivateAgreementsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.agreements/_template.$id/api-integration/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateAgreementsTemplateIdAddendumRouteRoute =
  PrivateAgreementsTemplateIdAddendumRouteRouteImport.update({
    id: '/$id/addendum',
    path: '/$id/addendum',
    getParentRoute: () => PrivateAgreementsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.agreements/_template.$id/addendum/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateTeamMembersTemplateIdIndexRouteRoute =
  PrivateTeamMembersTemplateIdIndexRouteRouteImport.update({
    id: '/$id/',
    path: '/$id',
    getParentRoute: () => PrivateTeamMembersTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.team-members/_template.$id/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateInventoryTemplateIdIndexRouteRoute =
  PrivateInventoryTemplateIdIndexRouteRouteImport.update({
    id: '/$id/',
    path: '/$id',
    getParentRoute: () => PrivateInventoryTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.inventory/_template.$id/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateContactsTemplateIdIndexRouteRoute =
  PrivateContactsTemplateIdIndexRouteRouteImport.update({
    id: '/$id/',
    path: '/$id',
    getParentRoute: () => PrivateContactsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.contacts/_template.$id/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompetitorsTemplateIdIndexRouteRoute =
  PrivateCompetitorsTemplateIdIndexRouteRouteImport.update({
    id: '/$id/',
    path: '/$id',
    getParentRoute: () => PrivateCompetitorsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.competitors/_template.$id/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompaniesTemplateIdIndexRouteRoute =
  PrivateCompaniesTemplateIdIndexRouteRouteImport.update({
    id: '/$id/',
    path: '/$id',
    getParentRoute: () => PrivateCompaniesTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.companies/_template.$id/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateAgreementsTemplateIdIndexRouteRoute =
  PrivateAgreementsTemplateIdIndexRouteRouteImport.update({
    id: '/$id/',
    path: '/$id',
    getParentRoute: () => PrivateAgreementsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.agreements/_template.$id/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRegistrarsTemplateIdDomainsRouteRoute =
  PrivateSettingsRegistrarsTemplateIdDomainsRouteRouteImport.update({
    id: '/$id/domains',
    path: '/$id/domains',
    getParentRoute: () => PrivateSettingsRegistrarsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/registrars/_template.$id/domains/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsJobPositionsTemplateIdHiringRouteRoute =
  PrivateSettingsJobPositionsTemplateIdHiringRouteRouteImport.update({
    id: '/$id/hiring',
    path: '/$id/hiring',
    getParentRoute: () => PrivateSettingsJobPositionsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/job-positions/_template.$id/hiring/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsJobPositionsTemplateIdAgreementRouteRoute =
  PrivateSettingsJobPositionsTemplateIdAgreementRouteRouteImport.update({
    id: '/$id/agreement',
    path: '/$id/agreement',
    getParentRoute: () => PrivateSettingsJobPositionsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/job-positions/_template.$id/agreement/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsJobPositionsTemplateIdAdvertisementRouteRoute =
  PrivateSettingsJobPositionsTemplateIdAdvertisementRouteRouteImport.update({
    id: '/$id/advertisement',
    path: '/$id/advertisement',
    getParentRoute: () => PrivateSettingsJobPositionsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/job-positions/_template.$id/advertisement/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateContactsTemplateIdSupportTicket_idRouteRoute =
  PrivateContactsTemplateIdSupportTicket_idRouteRouteImport.update({
    id: '/$id/support/$ticket_id',
    path: '/$id/support/$ticket_id',
    getParentRoute: () => PrivateContactsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.contacts/_template.$id/support/$ticket_id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompaniesTemplateIdSupportTicket_idRouteRoute =
  PrivateCompaniesTemplateIdSupportTicket_idRouteRouteImport.update({
    id: '/$id/support/$ticket_id',
    path: '/$id/support/$ticket_id',
    getParentRoute: () => PrivateCompaniesTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.companies/_template.$id/support/$ticket_id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsRegistrarsTemplateIdIndexRouteRoute =
  PrivateSettingsRegistrarsTemplateIdIndexRouteRouteImport.update({
    id: '/$id/',
    path: '/$id',
    getParentRoute: () => PrivateSettingsRegistrarsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/registrars/_template.$id/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateSettingsJobPositionsTemplateIdIndexRouteRoute =
  PrivateSettingsJobPositionsTemplateIdIndexRouteRouteImport.update({
    id: '/$id/',
    path: '/$id',
    getParentRoute: () => PrivateSettingsJobPositionsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.settings/job-positions/_template.$id/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateContactsTemplateIdSupportIndexRouteRoute =
  PrivateContactsTemplateIdSupportIndexRouteRouteImport.update({
    id: '/$id/support/',
    path: '/$id/support',
    getParentRoute: () => PrivateContactsTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.contacts/_template.$id/support/index/route.lazy').then(
      (d) => d.Route,
    ),
  )
const PrivateCompaniesTemplateIdSupportIndexRouteRoute =
  PrivateCompaniesTemplateIdSupportIndexRouteRouteImport.update({
    id: '/$id/support/',
    path: '/$id/support',
    getParentRoute: () => PrivateCompaniesTemplateRoute,
  } as any).lazy(() =>
    import('./_routes/_private.companies/_template.$id/support/index/route.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/test': typeof TestRouteRoute
  '/auth/': typeof AuthIndexRoute
  '/account-receivables/': typeof PrivateAccountReceivablesIndexRouteRoute
  '/agreements/': typeof PrivateAgreementsIndexRouteRoute
  '/awards/': typeof PrivateAwardsIndexRouteRoute
  '/companies/': typeof PrivateCompaniesIndexRouteRoute
  '/competitors/': typeof PrivateCompetitorsIndexRouteRoute
  '/conferences-and-events/': typeof PrivateConferencesAndEventsIndexRouteRoute
  '/connected-apps/': typeof PrivateConnectedAppsIndexRouteRoute
  '/contacts/': typeof PrivateContactsIndexRouteRoute
  '/dashboard/': typeof PrivateDashboardIndexRouteRoute
  '/deposits/': typeof PrivateDepositsIndexRouteRoute
  '/domains/': typeof PrivateDomainsIndexRouteRoute
  '/financial-snapshots/': typeof PrivateFinancialSnapshotsIndexRouteRoute
  '/governance/': typeof PrivateGovernanceIndexRouteRoute
  '/inventory/': typeof PrivateInventoryIndexRouteRoute
  '/invoices/': typeof PrivateInvoicesIndexRouteRoute
  '/marketing-campaigns/': typeof PrivateMarketingCampaignsIndexRouteRoute
  '/media/': typeof PrivateMediaIndexRouteRoute
  '/pick-tickets/': typeof PrivatePickTicketsIndexRouteRoute
  '/products-and-services/': typeof PrivateProductsAndServicesIndexRouteRoute
  '/recruiting/': typeof PrivateRecruitingIndexRouteRoute
  '/settings/': typeof PrivateSettingsIndexRouteRoute
  '/support/': typeof PrivateSupportIndexRouteRoute
  '/system-users/': typeof PrivateSystemUsersIndexRouteRoute
  '/team-members/': typeof PrivateTeamMembersIndexRouteRoute
  '/forgot-password/': typeof PublicForgotPasswordIndexRouteRoute
  '/login/': typeof PublicLoginIndexRouteRoute
  '/reset-password/': typeof PublicResetPasswordIndexRouteRoute
  '/signup/': typeof PublicSignupIndexRouteRoute
  '/account-receivables/$id': typeof PrivateAccountReceivablesIdRouteRoute
  '/account-receivables/new': typeof PrivateAccountReceivablesNewRouteRoute
  '/agreements/new': typeof PrivateAgreementsNewRouteRoute
  '/awards/$id': typeof PrivateAwardsIdRouteRoute
  '/awards/new': typeof PrivateAwardsNewRouteRoute
  '/companies/new': typeof PrivateCompaniesNewRouteRoute
  '/competitors/new': typeof PrivateCompetitorsNewRouteRoute
  '/conferences-and-events/$id': typeof PrivateConferencesAndEventsIdRouteRoute
  '/conferences-and-events/new': typeof PrivateConferencesAndEventsNewRouteRoute
  '/connected-apps/$id': typeof PrivateConnectedAppsIdRouteRoute
  '/connected-apps/new': typeof PrivateConnectedAppsNewRouteRoute
  '/contacts/new': typeof PrivateContactsNewRouteRoute
  '/deposits/$id': typeof PrivateDepositsIdRouteRoute
  '/deposits/new': typeof PrivateDepositsNewRouteRoute
  '/domains/$id': typeof PrivateDomainsIdRouteRoute
  '/domains/new': typeof PrivateDomainsNewRouteRoute
  '/financial-snapshots/$id': typeof PrivateFinancialSnapshotsIdRouteRoute
  '/financial-snapshots/new': typeof PrivateFinancialSnapshotsNewRouteRoute
  '/governance/$id': typeof PrivateGovernanceIdRouteRoute
  '/governance/new': typeof PrivateGovernanceNewRouteRoute
  '/inventory/new': typeof PrivateInventoryNewRouteRoute
  '/inventory/parent-new': typeof PrivateInventoryParentNewRouteRoute
  '/invoices/$id': typeof PrivateInvoicesIdRouteRoute
  '/invoices/new': typeof PrivateInvoicesNewRouteRoute
  '/marketing-campaigns/$id': typeof PrivateMarketingCampaignsIdRouteRoute
  '/marketing-campaigns/new': typeof PrivateMarketingCampaignsNewRouteRoute
  '/pending-deposits/$id': typeof PrivatePendingDepositsIdRouteRoute
  '/pick-tickets/$id': typeof PrivatePickTicketsIdRouteRoute
  '/pick-tickets/new': typeof PrivatePickTicketsNewRouteRoute
  '/products-and-services/$id': typeof PrivateProductsAndServicesIdRouteRoute
  '/products-and-services/new': typeof PrivateProductsAndServicesNewRouteRoute
  '/recruiting/$id': typeof PrivateRecruitingIdRouteRoute
  '/recruiting/new': typeof PrivateRecruitingNewRouteRoute
  '/settings/revenue-allocation-lockdown-override-logs': typeof PrivateSettingsRevenueAllocationLockdownOverrideLogsRouteRoute
  '/settings/view-logs': typeof PrivateSettingsViewLogsRouteRoute
  '/support/$ticket_id': typeof PrivateSupportTicket_idRouteRoute
  '/system-users/$id': typeof PrivateSystemUsersIdRouteRoute
  '/team-members/new': typeof PrivateTeamMembersNewRouteRoute
  '/agreements': typeof PrivateAgreementsTemplateRouteWithChildren
  '/companies': typeof PrivateCompaniesTemplateRouteWithChildren
  '/competitors': typeof PrivateCompetitorsTemplateRouteWithChildren
  '/contacts': typeof PrivateContactsTemplateRouteWithChildren
  '/inventory': typeof PrivateInventoryTemplateRouteWithChildren
  '/team-members': typeof PrivateTeamMembersTemplateRouteWithChildren
  '/settings/audiences/': typeof PrivateSettingsAudiencesIndexRouteRoute
  '/settings/bank-accounts/': typeof PrivateSettingsBankAccountsIndexRouteRoute
  '/settings/billing-systems/': typeof PrivateSettingsBillingSystemsIndexRouteRoute
  '/settings/billing-terms/': typeof PrivateSettingsBillingTermsIndexRouteRoute
  '/settings/brands/': typeof PrivateSettingsBrandsIndexRouteRoute
  '/settings/business-disciplines/': typeof PrivateSettingsBusinessDisciplinesIndexRouteRoute
  '/settings/categories/': typeof PrivateSettingsCategoriesIndexRouteRoute
  '/settings/commission-plans/': typeof PrivateSettingsCommissionPlansIndexRouteRoute
  '/settings/countries/': typeof PrivateSettingsCountriesIndexRouteRoute
  '/settings/departments/': typeof PrivateSettingsDepartmentsIndexRouteRoute
  '/settings/email-history/': typeof PrivateSettingsEmailHistoryIndexRouteRoute
  '/settings/email-template-defaults/': typeof PrivateSettingsEmailTemplateDefaultsIndexRouteRoute
  '/settings/email-templates/': typeof PrivateSettingsEmailTemplatesIndexRouteRoute
  '/settings/industries/': typeof PrivateSettingsIndustriesIndexRouteRoute
  '/settings/infrastructures/': typeof PrivateSettingsInfrastructuresIndexRouteRoute
  '/settings/inventory-bin-locations/': typeof PrivateSettingsInventoryBinLocationsIndexRouteRoute
  '/settings/inventory-categories/': typeof PrivateSettingsInventoryCategoriesIndexRouteRoute
  '/settings/inventory-kits/': typeof PrivateSettingsInventoryKitsIndexRouteRoute
  '/settings/inventory-purchases/': typeof PrivateSettingsInventoryPurchasesIndexRouteRoute
  '/settings/inventory-stocks/': typeof PrivateSettingsInventoryStocksIndexRouteRoute
  '/settings/inventory-vendors/': typeof PrivateSettingsInventoryVendorsIndexRouteRoute
  '/settings/inventory-volumes/': typeof PrivateSettingsInventoryVolumesIndexRouteRoute
  '/settings/job-positions/': typeof PrivateSettingsJobPositionsIndexRouteRoute
  '/settings/magazines/': typeof PrivateSettingsMagazinesIndexRouteRoute
  '/settings/manufacturers/': typeof PrivateSettingsManufacturersIndexRouteRoute
  '/settings/mileage-rates/': typeof PrivateSettingsMileageRatesIndexRouteRoute
  '/settings/organization-types/': typeof PrivateSettingsOrganizationTypesIndexRouteRoute
  '/settings/partners/': typeof PrivateSettingsPartnersIndexRouteRoute
  '/settings/payment-methods/': typeof PrivateSettingsPaymentMethodsIndexRouteRoute
  '/settings/preferred-locations/': typeof PrivateSettingsPreferredLocationsIndexRouteRoute
  '/settings/preferred-relationships/': typeof PrivateSettingsPreferredRelationshipsIndexRouteRoute
  '/settings/price-frequencies/': typeof PrivateSettingsPriceFrequenciesIndexRouteRoute
  '/settings/products-and-services-templates/': typeof PrivateSettingsProductsAndServicesTemplatesIndexRouteRoute
  '/settings/recruiting-hiring-criteria-categories/': typeof PrivateSettingsRecruitingHiringCriteriaCategoriesIndexRouteRoute
  '/settings/recruiting-job-categories/': typeof PrivateSettingsRecruitingJobCategoriesIndexRouteRoute
  '/settings/recruiting-statuses/': typeof PrivateSettingsRecruitingStatusesIndexRouteRoute
  '/settings/registrars/': typeof PrivateSettingsRegistrarsIndexRouteRoute
  '/settings/relationship-scores/': typeof PrivateSettingsRelationshipScoresIndexRouteRoute
  '/settings/revenue-lockdowns/': typeof PrivateSettingsRevenueLockdownsIndexRouteRoute
  '/settings/salary-grades/': typeof PrivateSettingsSalaryGradesIndexRouteRoute
  '/settings/system-files/': typeof PrivateSettingsSystemFilesIndexRouteRoute
  '/settings/terms-categories/': typeof PrivateSettingsTermsCategoriesIndexRouteRoute
  '/settings/terms-conditions/': typeof PrivateSettingsTermsConditionsIndexRouteRoute
  '/settings/terms-templates/': typeof PrivateSettingsTermsTemplatesIndexRouteRoute
  '/settings/unit-sell-bys/': typeof PrivateSettingsUnitSellBysIndexRouteRoute
  '/settings/user-roles/': typeof PrivateSettingsUserRolesIndexRouteRoute
  '/inventory/parent/$id': typeof PrivateInventoryParentIdRouteRoute
  '/invoices/invoice-batch/$id': typeof PrivateInvoicesInvoiceBatchIdRouteRoute
  '/settings/audiences/$id': typeof PrivateSettingsAudiencesIdRouteRoute
  '/settings/audiences/new': typeof PrivateSettingsAudiencesNewRouteRoute
  '/settings/bank-accounts/$id': typeof PrivateSettingsBankAccountsIdRouteRoute
  '/settings/bank-accounts/new': typeof PrivateSettingsBankAccountsNewRouteRoute
  '/settings/billing-systems/$id': typeof PrivateSettingsBillingSystemsIdRouteRoute
  '/settings/billing-systems/new': typeof PrivateSettingsBillingSystemsNewRouteRoute
  '/settings/billing-terms/$id': typeof PrivateSettingsBillingTermsIdRouteRoute
  '/settings/billing-terms/new': typeof PrivateSettingsBillingTermsNewRouteRoute
  '/settings/brands/$id': typeof PrivateSettingsBrandsIdRouteRoute
  '/settings/brands/new': typeof PrivateSettingsBrandsNewRouteRoute
  '/settings/business-disciplines/$id': typeof PrivateSettingsBusinessDisciplinesIdRouteRoute
  '/settings/business-disciplines/new': typeof PrivateSettingsBusinessDisciplinesNewRouteRoute
  '/settings/categories/$id': typeof PrivateSettingsCategoriesIdRouteRoute
  '/settings/categories/new': typeof PrivateSettingsCategoriesNewRouteRoute
  '/settings/commission-plans/$id': typeof PrivateSettingsCommissionPlansIdRouteRoute
  '/settings/commission-plans/new': typeof PrivateSettingsCommissionPlansNewRouteRoute
  '/settings/countries/$id': typeof PrivateSettingsCountriesIdRouteRoute
  '/settings/countries/new': typeof PrivateSettingsCountriesNewRouteRoute
  '/settings/departments/$id': typeof PrivateSettingsDepartmentsIdRouteRoute
  '/settings/departments/new': typeof PrivateSettingsDepartmentsNewRouteRoute
  '/settings/email-history/$id': typeof PrivateSettingsEmailHistoryIdRouteRoute
  '/settings/email-templates/$id': typeof PrivateSettingsEmailTemplatesIdRouteRoute
  '/settings/email-templates/new': typeof PrivateSettingsEmailTemplatesNewRouteRoute
  '/settings/industries/$id': typeof PrivateSettingsIndustriesIdRouteRoute
  '/settings/industries/new': typeof PrivateSettingsIndustriesNewRouteRoute
  '/settings/infrastructures/$id': typeof PrivateSettingsInfrastructuresIdRouteRoute
  '/settings/infrastructures/new': typeof PrivateSettingsInfrastructuresNewRouteRoute
  '/settings/inventory-bin-locations/$id': typeof PrivateSettingsInventoryBinLocationsIdRouteRoute
  '/settings/inventory-bin-locations/new': typeof PrivateSettingsInventoryBinLocationsNewRouteRoute
  '/settings/inventory-categories/$id': typeof PrivateSettingsInventoryCategoriesIdRouteRoute
  '/settings/inventory-categories/new': typeof PrivateSettingsInventoryCategoriesNewRouteRoute
  '/settings/inventory-kits/$id': typeof PrivateSettingsInventoryKitsIdRouteRoute
  '/settings/inventory-kits/new': typeof PrivateSettingsInventoryKitsNewRouteRoute
  '/settings/inventory-purchases/$id': typeof PrivateSettingsInventoryPurchasesIdRouteRoute
  '/settings/inventory-purchases/new': typeof PrivateSettingsInventoryPurchasesNewRouteRoute
  '/settings/inventory-stocks/$id': typeof PrivateSettingsInventoryStocksIdRouteRoute
  '/settings/inventory-stocks/new': typeof PrivateSettingsInventoryStocksNewRouteRoute
  '/settings/inventory-vendors/$id': typeof PrivateSettingsInventoryVendorsIdRouteRoute
  '/settings/inventory-vendors/new': typeof PrivateSettingsInventoryVendorsNewRouteRoute
  '/settings/inventory-volumes/$id': typeof PrivateSettingsInventoryVolumesIdRouteRoute
  '/settings/inventory-volumes/new': typeof PrivateSettingsInventoryVolumesNewRouteRoute
  '/settings/job-positions/new': typeof PrivateSettingsJobPositionsNewRouteRoute
  '/settings/magazines/$id': typeof PrivateSettingsMagazinesIdRouteRoute
  '/settings/magazines/new': typeof PrivateSettingsMagazinesNewRouteRoute
  '/settings/manufacturers/$id': typeof PrivateSettingsManufacturersIdRouteRoute
  '/settings/manufacturers/new': typeof PrivateSettingsManufacturersNewRouteRoute
  '/settings/mileage-rates/$id': typeof PrivateSettingsMileageRatesIdRouteRoute
  '/settings/mileage-rates/new': typeof PrivateSettingsMileageRatesNewRouteRoute
  '/settings/organization-types/$id': typeof PrivateSettingsOrganizationTypesIdRouteRoute
  '/settings/organization-types/new': typeof PrivateSettingsOrganizationTypesNewRouteRoute
  '/settings/partners/$id': typeof PrivateSettingsPartnersIdRouteRoute
  '/settings/partners/new': typeof PrivateSettingsPartnersNewRouteRoute
  '/settings/payment-methods/$id': typeof PrivateSettingsPaymentMethodsIdRouteRoute
  '/settings/payment-methods/new': typeof PrivateSettingsPaymentMethodsNewRouteRoute
  '/settings/preferred-locations/$id': typeof PrivateSettingsPreferredLocationsIdRouteRoute
  '/settings/preferred-locations/new': typeof PrivateSettingsPreferredLocationsNewRouteRoute
  '/settings/preferred-relationships/$id': typeof PrivateSettingsPreferredRelationshipsIdRouteRoute
  '/settings/preferred-relationships/new': typeof PrivateSettingsPreferredRelationshipsNewRouteRoute
  '/settings/price-frequencies/$id': typeof PrivateSettingsPriceFrequenciesIdRouteRoute
  '/settings/price-frequencies/new': typeof PrivateSettingsPriceFrequenciesNewRouteRoute
  '/settings/products-and-services-templates/$id': typeof PrivateSettingsProductsAndServicesTemplatesIdRouteRoute
  '/settings/products-and-services-templates/new': typeof PrivateSettingsProductsAndServicesTemplatesNewRouteRoute
  '/settings/recruiting-hiring-criteria-categories/$id': typeof PrivateSettingsRecruitingHiringCriteriaCategoriesIdRouteRoute
  '/settings/recruiting-hiring-criteria-categories/new': typeof PrivateSettingsRecruitingHiringCriteriaCategoriesNewRouteRoute
  '/settings/recruiting-job-categories/$id': typeof PrivateSettingsRecruitingJobCategoriesIdRouteRoute
  '/settings/recruiting-job-categories/new': typeof PrivateSettingsRecruitingJobCategoriesNewRouteRoute
  '/settings/recruiting-statuses/$id': typeof PrivateSettingsRecruitingStatusesIdRouteRoute
  '/settings/recruiting-statuses/new': typeof PrivateSettingsRecruitingStatusesNewRouteRoute
  '/settings/registrars/new': typeof PrivateSettingsRegistrarsNewRouteRoute
  '/settings/relationship-scores/$id': typeof PrivateSettingsRelationshipScoresIdRouteRoute
  '/settings/relationship-scores/new': typeof PrivateSettingsRelationshipScoresNewRouteRoute
  '/settings/revenue-lockdowns/$id': typeof PrivateSettingsRevenueLockdownsIdRouteRoute
  '/settings/revenue-lockdowns/new': typeof PrivateSettingsRevenueLockdownsNewRouteRoute
  '/settings/salary-grades/$id': typeof PrivateSettingsSalaryGradesIdRouteRoute
  '/settings/salary-grades/new': typeof PrivateSettingsSalaryGradesNewRouteRoute
  '/settings/system-files/$id': typeof PrivateSettingsSystemFilesIdRouteRoute
  '/settings/system-files/new': typeof PrivateSettingsSystemFilesNewRouteRoute
  '/settings/terms-categories/$id': typeof PrivateSettingsTermsCategoriesIdRouteRoute
  '/settings/terms-categories/new': typeof PrivateSettingsTermsCategoriesNewRouteRoute
  '/settings/terms-conditions/$id': typeof PrivateSettingsTermsConditionsIdRouteRoute
  '/settings/terms-conditions/new': typeof PrivateSettingsTermsConditionsNewRouteRoute
  '/settings/terms-templates/$id': typeof PrivateSettingsTermsTemplatesIdRouteRoute
  '/settings/terms-templates/new': typeof PrivateSettingsTermsTemplatesNewRouteRoute
  '/settings/unit-sell-bys/$id': typeof PrivateSettingsUnitSellBysIdRouteRoute
  '/settings/unit-sell-bys/new': typeof PrivateSettingsUnitSellBysNewRouteRoute
  '/settings/user-roles/$id': typeof PrivateSettingsUserRolesIdRouteRoute
  '/settings/user-roles/new': typeof PrivateSettingsUserRolesNewRouteRoute
  '/settings/job-positions': typeof PrivateSettingsJobPositionsTemplateRouteWithChildren
  '/settings/registrars': typeof PrivateSettingsRegistrarsTemplateRouteWithChildren
  '/agreements/$id/': typeof PrivateAgreementsTemplateIdIndexRouteRoute
  '/companies/$id/': typeof PrivateCompaniesTemplateIdIndexRouteRoute
  '/competitors/$id/': typeof PrivateCompetitorsTemplateIdIndexRouteRoute
  '/contacts/$id/': typeof PrivateContactsTemplateIdIndexRouteRoute
  '/inventory/$id/': typeof PrivateInventoryTemplateIdIndexRouteRoute
  '/team-members/$id/': typeof PrivateTeamMembersTemplateIdIndexRouteRoute
  '/agreements/$id/addendum': typeof PrivateAgreementsTemplateIdAddendumRouteRoute
  '/agreements/$id/api-integration': typeof PrivateAgreementsTemplateIdApiIntegrationRouteRoute
  '/agreements/$id/commission': typeof PrivateAgreementsTemplateIdCommissionRouteRoute
  '/agreements/$id/deliverables': typeof PrivateAgreementsTemplateIdDeliverablesRouteRoute
  '/agreements/$id/execution': typeof PrivateAgreementsTemplateIdExecutionRouteRoute
  '/agreements/$id/financial-override': typeof PrivateAgreementsTemplateIdFinancialOverrideRouteRoute
  '/agreements/$id/paperwork': typeof PrivateAgreementsTemplateIdPaperworkRouteRoute
  '/agreements/$id/subsidies': typeof PrivateAgreementsTemplateIdSubsidiesRouteRoute
  '/companies/$id/agreements': typeof PrivateCompaniesTemplateIdAgreementsRouteRoute
  '/companies/$id/api-integration': typeof PrivateCompaniesTemplateIdApiIntegrationRouteRoute
  '/companies/$id/contacts': typeof PrivateCompaniesTemplateIdContactsRouteRoute
  '/companies/$id/domains': typeof PrivateCompaniesTemplateIdDomainsRouteRoute
  '/companies/$id/financials': typeof PrivateCompaniesTemplateIdFinancialsRouteRoute
  '/companies/$id/invoice-history': typeof PrivateCompaniesTemplateIdInvoiceHistoryRouteRoute
  '/companies/$id/marketing-campaigns': typeof PrivateCompaniesTemplateIdMarketingCampaignsRouteRoute
  '/companies/$id/notes': typeof PrivateCompaniesTemplateIdNotesRouteRoute
  '/companies/$id/subscriptions': typeof PrivateCompaniesTemplateIdSubscriptionsRouteRoute
  '/competitors/$id/associated-companies': typeof PrivateCompetitorsTemplateIdAssociatedCompaniesRouteRoute
  '/competitors/$id/contacts': typeof PrivateCompetitorsTemplateIdContactsRouteRoute
  '/competitors/$id/notes': typeof PrivateCompetitorsTemplateIdNotesRouteRoute
  '/contacts/$id/agreements': typeof PrivateContactsTemplateIdAgreementsRouteRoute
  '/contacts/$id/api-integration': typeof PrivateContactsTemplateIdApiIntegrationRouteRoute
  '/contacts/$id/marketing-campaigns': typeof PrivateContactsTemplateIdMarketingCampaignsRouteRoute
  '/contacts/$id/notes': typeof PrivateContactsTemplateIdNotesRouteRoute
  '/inventory/$id/vendors': typeof PrivateInventoryTemplateIdVendorsRouteRoute
  '/team-members/$id/api-integration': typeof PrivateTeamMembersTemplateIdApiIntegrationRouteRoute
  '/team-members/$id/commission-periods': typeof PrivateTeamMembersTemplateIdCommissionPeriodsRouteRoute
  '/team-members/$id/emergency': typeof PrivateTeamMembersTemplateIdEmergencyRouteRoute
  '/team-members/$id/marketing': typeof PrivateTeamMembersTemplateIdMarketingRouteRoute
  '/team-members/$id/personal-details': typeof PrivateTeamMembersTemplateIdPersonalDetailsRouteRoute
  '/team-members/$id/preference': typeof PrivateTeamMembersTemplateIdPreferenceRouteRoute
  '/companies/$id/support/': typeof PrivateCompaniesTemplateIdSupportIndexRouteRoute
  '/contacts/$id/support/': typeof PrivateContactsTemplateIdSupportIndexRouteRoute
  '/settings/job-positions/$id/': typeof PrivateSettingsJobPositionsTemplateIdIndexRouteRoute
  '/settings/registrars/$id/': typeof PrivateSettingsRegistrarsTemplateIdIndexRouteRoute
  '/companies/$id/support/$ticket_id': typeof PrivateCompaniesTemplateIdSupportTicket_idRouteRoute
  '/contacts/$id/support/$ticket_id': typeof PrivateContactsTemplateIdSupportTicket_idRouteRoute
  '/settings/job-positions/$id/advertisement': typeof PrivateSettingsJobPositionsTemplateIdAdvertisementRouteRoute
  '/settings/job-positions/$id/agreement': typeof PrivateSettingsJobPositionsTemplateIdAgreementRouteRoute
  '/settings/job-positions/$id/hiring': typeof PrivateSettingsJobPositionsTemplateIdHiringRouteRoute
  '/settings/registrars/$id/domains': typeof PrivateSettingsRegistrarsTemplateIdDomainsRouteRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/test': typeof TestRouteRoute
  '/auth': typeof AuthIndexRoute
  '/account-receivables': typeof PrivateAccountReceivablesIndexRouteRoute
  '/agreements': typeof PrivateAgreementsIndexRouteRoute
  '/awards': typeof PrivateAwardsIndexRouteRoute
  '/companies': typeof PrivateCompaniesIndexRouteRoute
  '/competitors': typeof PrivateCompetitorsIndexRouteRoute
  '/conferences-and-events': typeof PrivateConferencesAndEventsIndexRouteRoute
  '/connected-apps': typeof PrivateConnectedAppsIndexRouteRoute
  '/contacts': typeof PrivateContactsIndexRouteRoute
  '/dashboard': typeof PrivateDashboardIndexRouteRoute
  '/deposits': typeof PrivateDepositsIndexRouteRoute
  '/domains': typeof PrivateDomainsIndexRouteRoute
  '/financial-snapshots': typeof PrivateFinancialSnapshotsIndexRouteRoute
  '/governance': typeof PrivateGovernanceIndexRouteRoute
  '/inventory': typeof PrivateInventoryIndexRouteRoute
  '/invoices': typeof PrivateInvoicesIndexRouteRoute
  '/marketing-campaigns': typeof PrivateMarketingCampaignsIndexRouteRoute
  '/media': typeof PrivateMediaIndexRouteRoute
  '/pick-tickets': typeof PrivatePickTicketsIndexRouteRoute
  '/products-and-services': typeof PrivateProductsAndServicesIndexRouteRoute
  '/recruiting': typeof PrivateRecruitingIndexRouteRoute
  '/settings': typeof PrivateSettingsIndexRouteRoute
  '/support': typeof PrivateSupportIndexRouteRoute
  '/system-users': typeof PrivateSystemUsersIndexRouteRoute
  '/team-members': typeof PrivateTeamMembersIndexRouteRoute
  '/forgot-password': typeof PublicForgotPasswordIndexRouteRoute
  '/login': typeof PublicLoginIndexRouteRoute
  '/reset-password': typeof PublicResetPasswordIndexRouteRoute
  '/signup': typeof PublicSignupIndexRouteRoute
  '/account-receivables/$id': typeof PrivateAccountReceivablesIdRouteRoute
  '/account-receivables/new': typeof PrivateAccountReceivablesNewRouteRoute
  '/agreements/new': typeof PrivateAgreementsNewRouteRoute
  '/awards/$id': typeof PrivateAwardsIdRouteRoute
  '/awards/new': typeof PrivateAwardsNewRouteRoute
  '/companies/new': typeof PrivateCompaniesNewRouteRoute
  '/competitors/new': typeof PrivateCompetitorsNewRouteRoute
  '/conferences-and-events/$id': typeof PrivateConferencesAndEventsIdRouteRoute
  '/conferences-and-events/new': typeof PrivateConferencesAndEventsNewRouteRoute
  '/connected-apps/$id': typeof PrivateConnectedAppsIdRouteRoute
  '/connected-apps/new': typeof PrivateConnectedAppsNewRouteRoute
  '/contacts/new': typeof PrivateContactsNewRouteRoute
  '/deposits/$id': typeof PrivateDepositsIdRouteRoute
  '/deposits/new': typeof PrivateDepositsNewRouteRoute
  '/domains/$id': typeof PrivateDomainsIdRouteRoute
  '/domains/new': typeof PrivateDomainsNewRouteRoute
  '/financial-snapshots/$id': typeof PrivateFinancialSnapshotsIdRouteRoute
  '/financial-snapshots/new': typeof PrivateFinancialSnapshotsNewRouteRoute
  '/governance/$id': typeof PrivateGovernanceIdRouteRoute
  '/governance/new': typeof PrivateGovernanceNewRouteRoute
  '/inventory/new': typeof PrivateInventoryNewRouteRoute
  '/inventory/parent-new': typeof PrivateInventoryParentNewRouteRoute
  '/invoices/$id': typeof PrivateInvoicesIdRouteRoute
  '/invoices/new': typeof PrivateInvoicesNewRouteRoute
  '/marketing-campaigns/$id': typeof PrivateMarketingCampaignsIdRouteRoute
  '/marketing-campaigns/new': typeof PrivateMarketingCampaignsNewRouteRoute
  '/pending-deposits/$id': typeof PrivatePendingDepositsIdRouteRoute
  '/pick-tickets/$id': typeof PrivatePickTicketsIdRouteRoute
  '/pick-tickets/new': typeof PrivatePickTicketsNewRouteRoute
  '/products-and-services/$id': typeof PrivateProductsAndServicesIdRouteRoute
  '/products-and-services/new': typeof PrivateProductsAndServicesNewRouteRoute
  '/recruiting/$id': typeof PrivateRecruitingIdRouteRoute
  '/recruiting/new': typeof PrivateRecruitingNewRouteRoute
  '/settings/revenue-allocation-lockdown-override-logs': typeof PrivateSettingsRevenueAllocationLockdownOverrideLogsRouteRoute
  '/settings/view-logs': typeof PrivateSettingsViewLogsRouteRoute
  '/support/$ticket_id': typeof PrivateSupportTicket_idRouteRoute
  '/system-users/$id': typeof PrivateSystemUsersIdRouteRoute
  '/team-members/new': typeof PrivateTeamMembersNewRouteRoute
  '/settings/audiences': typeof PrivateSettingsAudiencesIndexRouteRoute
  '/settings/bank-accounts': typeof PrivateSettingsBankAccountsIndexRouteRoute
  '/settings/billing-systems': typeof PrivateSettingsBillingSystemsIndexRouteRoute
  '/settings/billing-terms': typeof PrivateSettingsBillingTermsIndexRouteRoute
  '/settings/brands': typeof PrivateSettingsBrandsIndexRouteRoute
  '/settings/business-disciplines': typeof PrivateSettingsBusinessDisciplinesIndexRouteRoute
  '/settings/categories': typeof PrivateSettingsCategoriesIndexRouteRoute
  '/settings/commission-plans': typeof PrivateSettingsCommissionPlansIndexRouteRoute
  '/settings/countries': typeof PrivateSettingsCountriesIndexRouteRoute
  '/settings/departments': typeof PrivateSettingsDepartmentsIndexRouteRoute
  '/settings/email-history': typeof PrivateSettingsEmailHistoryIndexRouteRoute
  '/settings/email-template-defaults': typeof PrivateSettingsEmailTemplateDefaultsIndexRouteRoute
  '/settings/email-templates': typeof PrivateSettingsEmailTemplatesIndexRouteRoute
  '/settings/industries': typeof PrivateSettingsIndustriesIndexRouteRoute
  '/settings/infrastructures': typeof PrivateSettingsInfrastructuresIndexRouteRoute
  '/settings/inventory-bin-locations': typeof PrivateSettingsInventoryBinLocationsIndexRouteRoute
  '/settings/inventory-categories': typeof PrivateSettingsInventoryCategoriesIndexRouteRoute
  '/settings/inventory-kits': typeof PrivateSettingsInventoryKitsIndexRouteRoute
  '/settings/inventory-purchases': typeof PrivateSettingsInventoryPurchasesIndexRouteRoute
  '/settings/inventory-stocks': typeof PrivateSettingsInventoryStocksIndexRouteRoute
  '/settings/inventory-vendors': typeof PrivateSettingsInventoryVendorsIndexRouteRoute
  '/settings/inventory-volumes': typeof PrivateSettingsInventoryVolumesIndexRouteRoute
  '/settings/job-positions': typeof PrivateSettingsJobPositionsIndexRouteRoute
  '/settings/magazines': typeof PrivateSettingsMagazinesIndexRouteRoute
  '/settings/manufacturers': typeof PrivateSettingsManufacturersIndexRouteRoute
  '/settings/mileage-rates': typeof PrivateSettingsMileageRatesIndexRouteRoute
  '/settings/organization-types': typeof PrivateSettingsOrganizationTypesIndexRouteRoute
  '/settings/partners': typeof PrivateSettingsPartnersIndexRouteRoute
  '/settings/payment-methods': typeof PrivateSettingsPaymentMethodsIndexRouteRoute
  '/settings/preferred-locations': typeof PrivateSettingsPreferredLocationsIndexRouteRoute
  '/settings/preferred-relationships': typeof PrivateSettingsPreferredRelationshipsIndexRouteRoute
  '/settings/price-frequencies': typeof PrivateSettingsPriceFrequenciesIndexRouteRoute
  '/settings/products-and-services-templates': typeof PrivateSettingsProductsAndServicesTemplatesIndexRouteRoute
  '/settings/recruiting-hiring-criteria-categories': typeof PrivateSettingsRecruitingHiringCriteriaCategoriesIndexRouteRoute
  '/settings/recruiting-job-categories': typeof PrivateSettingsRecruitingJobCategoriesIndexRouteRoute
  '/settings/recruiting-statuses': typeof PrivateSettingsRecruitingStatusesIndexRouteRoute
  '/settings/registrars': typeof PrivateSettingsRegistrarsIndexRouteRoute
  '/settings/relationship-scores': typeof PrivateSettingsRelationshipScoresIndexRouteRoute
  '/settings/revenue-lockdowns': typeof PrivateSettingsRevenueLockdownsIndexRouteRoute
  '/settings/salary-grades': typeof PrivateSettingsSalaryGradesIndexRouteRoute
  '/settings/system-files': typeof PrivateSettingsSystemFilesIndexRouteRoute
  '/settings/terms-categories': typeof PrivateSettingsTermsCategoriesIndexRouteRoute
  '/settings/terms-conditions': typeof PrivateSettingsTermsConditionsIndexRouteRoute
  '/settings/terms-templates': typeof PrivateSettingsTermsTemplatesIndexRouteRoute
  '/settings/unit-sell-bys': typeof PrivateSettingsUnitSellBysIndexRouteRoute
  '/settings/user-roles': typeof PrivateSettingsUserRolesIndexRouteRoute
  '/inventory/parent/$id': typeof PrivateInventoryParentIdRouteRoute
  '/invoices/invoice-batch/$id': typeof PrivateInvoicesInvoiceBatchIdRouteRoute
  '/settings/audiences/$id': typeof PrivateSettingsAudiencesIdRouteRoute
  '/settings/audiences/new': typeof PrivateSettingsAudiencesNewRouteRoute
  '/settings/bank-accounts/$id': typeof PrivateSettingsBankAccountsIdRouteRoute
  '/settings/bank-accounts/new': typeof PrivateSettingsBankAccountsNewRouteRoute
  '/settings/billing-systems/$id': typeof PrivateSettingsBillingSystemsIdRouteRoute
  '/settings/billing-systems/new': typeof PrivateSettingsBillingSystemsNewRouteRoute
  '/settings/billing-terms/$id': typeof PrivateSettingsBillingTermsIdRouteRoute
  '/settings/billing-terms/new': typeof PrivateSettingsBillingTermsNewRouteRoute
  '/settings/brands/$id': typeof PrivateSettingsBrandsIdRouteRoute
  '/settings/brands/new': typeof PrivateSettingsBrandsNewRouteRoute
  '/settings/business-disciplines/$id': typeof PrivateSettingsBusinessDisciplinesIdRouteRoute
  '/settings/business-disciplines/new': typeof PrivateSettingsBusinessDisciplinesNewRouteRoute
  '/settings/categories/$id': typeof PrivateSettingsCategoriesIdRouteRoute
  '/settings/categories/new': typeof PrivateSettingsCategoriesNewRouteRoute
  '/settings/commission-plans/$id': typeof PrivateSettingsCommissionPlansIdRouteRoute
  '/settings/commission-plans/new': typeof PrivateSettingsCommissionPlansNewRouteRoute
  '/settings/countries/$id': typeof PrivateSettingsCountriesIdRouteRoute
  '/settings/countries/new': typeof PrivateSettingsCountriesNewRouteRoute
  '/settings/departments/$id': typeof PrivateSettingsDepartmentsIdRouteRoute
  '/settings/departments/new': typeof PrivateSettingsDepartmentsNewRouteRoute
  '/settings/email-history/$id': typeof PrivateSettingsEmailHistoryIdRouteRoute
  '/settings/email-templates/$id': typeof PrivateSettingsEmailTemplatesIdRouteRoute
  '/settings/email-templates/new': typeof PrivateSettingsEmailTemplatesNewRouteRoute
  '/settings/industries/$id': typeof PrivateSettingsIndustriesIdRouteRoute
  '/settings/industries/new': typeof PrivateSettingsIndustriesNewRouteRoute
  '/settings/infrastructures/$id': typeof PrivateSettingsInfrastructuresIdRouteRoute
  '/settings/infrastructures/new': typeof PrivateSettingsInfrastructuresNewRouteRoute
  '/settings/inventory-bin-locations/$id': typeof PrivateSettingsInventoryBinLocationsIdRouteRoute
  '/settings/inventory-bin-locations/new': typeof PrivateSettingsInventoryBinLocationsNewRouteRoute
  '/settings/inventory-categories/$id': typeof PrivateSettingsInventoryCategoriesIdRouteRoute
  '/settings/inventory-categories/new': typeof PrivateSettingsInventoryCategoriesNewRouteRoute
  '/settings/inventory-kits/$id': typeof PrivateSettingsInventoryKitsIdRouteRoute
  '/settings/inventory-kits/new': typeof PrivateSettingsInventoryKitsNewRouteRoute
  '/settings/inventory-purchases/$id': typeof PrivateSettingsInventoryPurchasesIdRouteRoute
  '/settings/inventory-purchases/new': typeof PrivateSettingsInventoryPurchasesNewRouteRoute
  '/settings/inventory-stocks/$id': typeof PrivateSettingsInventoryStocksIdRouteRoute
  '/settings/inventory-stocks/new': typeof PrivateSettingsInventoryStocksNewRouteRoute
  '/settings/inventory-vendors/$id': typeof PrivateSettingsInventoryVendorsIdRouteRoute
  '/settings/inventory-vendors/new': typeof PrivateSettingsInventoryVendorsNewRouteRoute
  '/settings/inventory-volumes/$id': typeof PrivateSettingsInventoryVolumesIdRouteRoute
  '/settings/inventory-volumes/new': typeof PrivateSettingsInventoryVolumesNewRouteRoute
  '/settings/job-positions/new': typeof PrivateSettingsJobPositionsNewRouteRoute
  '/settings/magazines/$id': typeof PrivateSettingsMagazinesIdRouteRoute
  '/settings/magazines/new': typeof PrivateSettingsMagazinesNewRouteRoute
  '/settings/manufacturers/$id': typeof PrivateSettingsManufacturersIdRouteRoute
  '/settings/manufacturers/new': typeof PrivateSettingsManufacturersNewRouteRoute
  '/settings/mileage-rates/$id': typeof PrivateSettingsMileageRatesIdRouteRoute
  '/settings/mileage-rates/new': typeof PrivateSettingsMileageRatesNewRouteRoute
  '/settings/organization-types/$id': typeof PrivateSettingsOrganizationTypesIdRouteRoute
  '/settings/organization-types/new': typeof PrivateSettingsOrganizationTypesNewRouteRoute
  '/settings/partners/$id': typeof PrivateSettingsPartnersIdRouteRoute
  '/settings/partners/new': typeof PrivateSettingsPartnersNewRouteRoute
  '/settings/payment-methods/$id': typeof PrivateSettingsPaymentMethodsIdRouteRoute
  '/settings/payment-methods/new': typeof PrivateSettingsPaymentMethodsNewRouteRoute
  '/settings/preferred-locations/$id': typeof PrivateSettingsPreferredLocationsIdRouteRoute
  '/settings/preferred-locations/new': typeof PrivateSettingsPreferredLocationsNewRouteRoute
  '/settings/preferred-relationships/$id': typeof PrivateSettingsPreferredRelationshipsIdRouteRoute
  '/settings/preferred-relationships/new': typeof PrivateSettingsPreferredRelationshipsNewRouteRoute
  '/settings/price-frequencies/$id': typeof PrivateSettingsPriceFrequenciesIdRouteRoute
  '/settings/price-frequencies/new': typeof PrivateSettingsPriceFrequenciesNewRouteRoute
  '/settings/products-and-services-templates/$id': typeof PrivateSettingsProductsAndServicesTemplatesIdRouteRoute
  '/settings/products-and-services-templates/new': typeof PrivateSettingsProductsAndServicesTemplatesNewRouteRoute
  '/settings/recruiting-hiring-criteria-categories/$id': typeof PrivateSettingsRecruitingHiringCriteriaCategoriesIdRouteRoute
  '/settings/recruiting-hiring-criteria-categories/new': typeof PrivateSettingsRecruitingHiringCriteriaCategoriesNewRouteRoute
  '/settings/recruiting-job-categories/$id': typeof PrivateSettingsRecruitingJobCategoriesIdRouteRoute
  '/settings/recruiting-job-categories/new': typeof PrivateSettingsRecruitingJobCategoriesNewRouteRoute
  '/settings/recruiting-statuses/$id': typeof PrivateSettingsRecruitingStatusesIdRouteRoute
  '/settings/recruiting-statuses/new': typeof PrivateSettingsRecruitingStatusesNewRouteRoute
  '/settings/registrars/new': typeof PrivateSettingsRegistrarsNewRouteRoute
  '/settings/relationship-scores/$id': typeof PrivateSettingsRelationshipScoresIdRouteRoute
  '/settings/relationship-scores/new': typeof PrivateSettingsRelationshipScoresNewRouteRoute
  '/settings/revenue-lockdowns/$id': typeof PrivateSettingsRevenueLockdownsIdRouteRoute
  '/settings/revenue-lockdowns/new': typeof PrivateSettingsRevenueLockdownsNewRouteRoute
  '/settings/salary-grades/$id': typeof PrivateSettingsSalaryGradesIdRouteRoute
  '/settings/salary-grades/new': typeof PrivateSettingsSalaryGradesNewRouteRoute
  '/settings/system-files/$id': typeof PrivateSettingsSystemFilesIdRouteRoute
  '/settings/system-files/new': typeof PrivateSettingsSystemFilesNewRouteRoute
  '/settings/terms-categories/$id': typeof PrivateSettingsTermsCategoriesIdRouteRoute
  '/settings/terms-categories/new': typeof PrivateSettingsTermsCategoriesNewRouteRoute
  '/settings/terms-conditions/$id': typeof PrivateSettingsTermsConditionsIdRouteRoute
  '/settings/terms-conditions/new': typeof PrivateSettingsTermsConditionsNewRouteRoute
  '/settings/terms-templates/$id': typeof PrivateSettingsTermsTemplatesIdRouteRoute
  '/settings/terms-templates/new': typeof PrivateSettingsTermsTemplatesNewRouteRoute
  '/settings/unit-sell-bys/$id': typeof PrivateSettingsUnitSellBysIdRouteRoute
  '/settings/unit-sell-bys/new': typeof PrivateSettingsUnitSellBysNewRouteRoute
  '/settings/user-roles/$id': typeof PrivateSettingsUserRolesIdRouteRoute
  '/settings/user-roles/new': typeof PrivateSettingsUserRolesNewRouteRoute
  '/agreements/$id': typeof PrivateAgreementsTemplateIdIndexRouteRoute
  '/companies/$id': typeof PrivateCompaniesTemplateIdIndexRouteRoute
  '/competitors/$id': typeof PrivateCompetitorsTemplateIdIndexRouteRoute
  '/contacts/$id': typeof PrivateContactsTemplateIdIndexRouteRoute
  '/inventory/$id': typeof PrivateInventoryTemplateIdIndexRouteRoute
  '/team-members/$id': typeof PrivateTeamMembersTemplateIdIndexRouteRoute
  '/agreements/$id/addendum': typeof PrivateAgreementsTemplateIdAddendumRouteRoute
  '/agreements/$id/api-integration': typeof PrivateAgreementsTemplateIdApiIntegrationRouteRoute
  '/agreements/$id/commission': typeof PrivateAgreementsTemplateIdCommissionRouteRoute
  '/agreements/$id/deliverables': typeof PrivateAgreementsTemplateIdDeliverablesRouteRoute
  '/agreements/$id/execution': typeof PrivateAgreementsTemplateIdExecutionRouteRoute
  '/agreements/$id/financial-override': typeof PrivateAgreementsTemplateIdFinancialOverrideRouteRoute
  '/agreements/$id/paperwork': typeof PrivateAgreementsTemplateIdPaperworkRouteRoute
  '/agreements/$id/subsidies': typeof PrivateAgreementsTemplateIdSubsidiesRouteRoute
  '/companies/$id/agreements': typeof PrivateCompaniesTemplateIdAgreementsRouteRoute
  '/companies/$id/api-integration': typeof PrivateCompaniesTemplateIdApiIntegrationRouteRoute
  '/companies/$id/contacts': typeof PrivateCompaniesTemplateIdContactsRouteRoute
  '/companies/$id/domains': typeof PrivateCompaniesTemplateIdDomainsRouteRoute
  '/companies/$id/financials': typeof PrivateCompaniesTemplateIdFinancialsRouteRoute
  '/companies/$id/invoice-history': typeof PrivateCompaniesTemplateIdInvoiceHistoryRouteRoute
  '/companies/$id/marketing-campaigns': typeof PrivateCompaniesTemplateIdMarketingCampaignsRouteRoute
  '/companies/$id/notes': typeof PrivateCompaniesTemplateIdNotesRouteRoute
  '/companies/$id/subscriptions': typeof PrivateCompaniesTemplateIdSubscriptionsRouteRoute
  '/competitors/$id/associated-companies': typeof PrivateCompetitorsTemplateIdAssociatedCompaniesRouteRoute
  '/competitors/$id/contacts': typeof PrivateCompetitorsTemplateIdContactsRouteRoute
  '/competitors/$id/notes': typeof PrivateCompetitorsTemplateIdNotesRouteRoute
  '/contacts/$id/agreements': typeof PrivateContactsTemplateIdAgreementsRouteRoute
  '/contacts/$id/api-integration': typeof PrivateContactsTemplateIdApiIntegrationRouteRoute
  '/contacts/$id/marketing-campaigns': typeof PrivateContactsTemplateIdMarketingCampaignsRouteRoute
  '/contacts/$id/notes': typeof PrivateContactsTemplateIdNotesRouteRoute
  '/inventory/$id/vendors': typeof PrivateInventoryTemplateIdVendorsRouteRoute
  '/team-members/$id/api-integration': typeof PrivateTeamMembersTemplateIdApiIntegrationRouteRoute
  '/team-members/$id/commission-periods': typeof PrivateTeamMembersTemplateIdCommissionPeriodsRouteRoute
  '/team-members/$id/emergency': typeof PrivateTeamMembersTemplateIdEmergencyRouteRoute
  '/team-members/$id/marketing': typeof PrivateTeamMembersTemplateIdMarketingRouteRoute
  '/team-members/$id/personal-details': typeof PrivateTeamMembersTemplateIdPersonalDetailsRouteRoute
  '/team-members/$id/preference': typeof PrivateTeamMembersTemplateIdPreferenceRouteRoute
  '/companies/$id/support': typeof PrivateCompaniesTemplateIdSupportIndexRouteRoute
  '/contacts/$id/support': typeof PrivateContactsTemplateIdSupportIndexRouteRoute
  '/settings/job-positions/$id': typeof PrivateSettingsJobPositionsTemplateIdIndexRouteRoute
  '/settings/registrars/$id': typeof PrivateSettingsRegistrarsTemplateIdIndexRouteRoute
  '/companies/$id/support/$ticket_id': typeof PrivateCompaniesTemplateIdSupportTicket_idRouteRoute
  '/contacts/$id/support/$ticket_id': typeof PrivateContactsTemplateIdSupportTicket_idRouteRoute
  '/settings/job-positions/$id/advertisement': typeof PrivateSettingsJobPositionsTemplateIdAdvertisementRouteRoute
  '/settings/job-positions/$id/agreement': typeof PrivateSettingsJobPositionsTemplateIdAgreementRouteRoute
  '/settings/job-positions/$id/hiring': typeof PrivateSettingsJobPositionsTemplateIdHiringRouteRoute
  '/settings/registrars/$id/domains': typeof PrivateSettingsRegistrarsTemplateIdDomainsRouteRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/test': typeof TestRouteRoute
  '/_private': typeof PrivateRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/auth/': typeof AuthIndexRoute
  '/_private/account-receivables/': typeof PrivateAccountReceivablesIndexRouteRoute
  '/_private/agreements/': typeof PrivateAgreementsIndexRouteRoute
  '/_private/awards/': typeof PrivateAwardsIndexRouteRoute
  '/_private/companies/': typeof PrivateCompaniesIndexRouteRoute
  '/_private/competitors/': typeof PrivateCompetitorsIndexRouteRoute
  '/_private/conferences-and-events/': typeof PrivateConferencesAndEventsIndexRouteRoute
  '/_private/connected-apps/': typeof PrivateConnectedAppsIndexRouteRoute
  '/_private/contacts/': typeof PrivateContactsIndexRouteRoute
  '/_private/dashboard/': typeof PrivateDashboardIndexRouteRoute
  '/_private/deposits/': typeof PrivateDepositsIndexRouteRoute
  '/_private/domains/': typeof PrivateDomainsIndexRouteRoute
  '/_private/financial-snapshots/': typeof PrivateFinancialSnapshotsIndexRouteRoute
  '/_private/governance/': typeof PrivateGovernanceIndexRouteRoute
  '/_private/inventory/': typeof PrivateInventoryIndexRouteRoute
  '/_private/invoices/': typeof PrivateInvoicesIndexRouteRoute
  '/_private/marketing-campaigns/': typeof PrivateMarketingCampaignsIndexRouteRoute
  '/_private/media/': typeof PrivateMediaIndexRouteRoute
  '/_private/pick-tickets/': typeof PrivatePickTicketsIndexRouteRoute
  '/_private/products-and-services/': typeof PrivateProductsAndServicesIndexRouteRoute
  '/_private/recruiting/': typeof PrivateRecruitingIndexRouteRoute
  '/_private/settings/': typeof PrivateSettingsIndexRouteRoute
  '/_private/support/': typeof PrivateSupportIndexRouteRoute
  '/_private/system-users/': typeof PrivateSystemUsersIndexRouteRoute
  '/_private/team-members/': typeof PrivateTeamMembersIndexRouteRoute
  '/_public/forgot-password/': typeof PublicForgotPasswordIndexRouteRoute
  '/_public/login/': typeof PublicLoginIndexRouteRoute
  '/_public/reset-password/': typeof PublicResetPasswordIndexRouteRoute
  '/_public/signup/': typeof PublicSignupIndexRouteRoute
  '/_private/account-receivables/$id': typeof PrivateAccountReceivablesIdRouteRoute
  '/_private/account-receivables/new': typeof PrivateAccountReceivablesNewRouteRoute
  '/_private/agreements/new': typeof PrivateAgreementsNewRouteRoute
  '/_private/awards/$id': typeof PrivateAwardsIdRouteRoute
  '/_private/awards/new': typeof PrivateAwardsNewRouteRoute
  '/_private/companies/new': typeof PrivateCompaniesNewRouteRoute
  '/_private/competitors/new': typeof PrivateCompetitorsNewRouteRoute
  '/_private/conferences-and-events/$id': typeof PrivateConferencesAndEventsIdRouteRoute
  '/_private/conferences-and-events/new': typeof PrivateConferencesAndEventsNewRouteRoute
  '/_private/connected-apps/$id': typeof PrivateConnectedAppsIdRouteRoute
  '/_private/connected-apps/new': typeof PrivateConnectedAppsNewRouteRoute
  '/_private/contacts/new': typeof PrivateContactsNewRouteRoute
  '/_private/deposits/$id': typeof PrivateDepositsIdRouteRoute
  '/_private/deposits/new': typeof PrivateDepositsNewRouteRoute
  '/_private/domains/$id': typeof PrivateDomainsIdRouteRoute
  '/_private/domains/new': typeof PrivateDomainsNewRouteRoute
  '/_private/financial-snapshots/$id': typeof PrivateFinancialSnapshotsIdRouteRoute
  '/_private/financial-snapshots/new': typeof PrivateFinancialSnapshotsNewRouteRoute
  '/_private/governance/$id': typeof PrivateGovernanceIdRouteRoute
  '/_private/governance/new': typeof PrivateGovernanceNewRouteRoute
  '/_private/inventory/new': typeof PrivateInventoryNewRouteRoute
  '/_private/inventory/parent-new': typeof PrivateInventoryParentNewRouteRoute
  '/_private/invoices/$id': typeof PrivateInvoicesIdRouteRoute
  '/_private/invoices/new': typeof PrivateInvoicesNewRouteRoute
  '/_private/marketing-campaigns/$id': typeof PrivateMarketingCampaignsIdRouteRoute
  '/_private/marketing-campaigns/new': typeof PrivateMarketingCampaignsNewRouteRoute
  '/_private/pending-deposits/$id': typeof PrivatePendingDepositsIdRouteRoute
  '/_private/pick-tickets/$id': typeof PrivatePickTicketsIdRouteRoute
  '/_private/pick-tickets/new': typeof PrivatePickTicketsNewRouteRoute
  '/_private/products-and-services/$id': typeof PrivateProductsAndServicesIdRouteRoute
  '/_private/products-and-services/new': typeof PrivateProductsAndServicesNewRouteRoute
  '/_private/recruiting/$id': typeof PrivateRecruitingIdRouteRoute
  '/_private/recruiting/new': typeof PrivateRecruitingNewRouteRoute
  '/_private/settings/revenue-allocation-lockdown-override-logs': typeof PrivateSettingsRevenueAllocationLockdownOverrideLogsRouteRoute
  '/_private/settings/view-logs': typeof PrivateSettingsViewLogsRouteRoute
  '/_private/support/$ticket_id': typeof PrivateSupportTicket_idRouteRoute
  '/_private/system-users/$id': typeof PrivateSystemUsersIdRouteRoute
  '/_private/team-members/new': typeof PrivateTeamMembersNewRouteRoute
  '/_private/agreements/_template': typeof PrivateAgreementsTemplateRouteWithChildren
  '/_private/companies/_template': typeof PrivateCompaniesTemplateRouteWithChildren
  '/_private/competitors/_template': typeof PrivateCompetitorsTemplateRouteWithChildren
  '/_private/contacts/_template': typeof PrivateContactsTemplateRouteWithChildren
  '/_private/inventory/_template': typeof PrivateInventoryTemplateRouteWithChildren
  '/_private/team-members/_template': typeof PrivateTeamMembersTemplateRouteWithChildren
  '/_private/settings/audiences/': typeof PrivateSettingsAudiencesIndexRouteRoute
  '/_private/settings/bank-accounts/': typeof PrivateSettingsBankAccountsIndexRouteRoute
  '/_private/settings/billing-systems/': typeof PrivateSettingsBillingSystemsIndexRouteRoute
  '/_private/settings/billing-terms/': typeof PrivateSettingsBillingTermsIndexRouteRoute
  '/_private/settings/brands/': typeof PrivateSettingsBrandsIndexRouteRoute
  '/_private/settings/business-disciplines/': typeof PrivateSettingsBusinessDisciplinesIndexRouteRoute
  '/_private/settings/categories/': typeof PrivateSettingsCategoriesIndexRouteRoute
  '/_private/settings/commission-plans/': typeof PrivateSettingsCommissionPlansIndexRouteRoute
  '/_private/settings/countries/': typeof PrivateSettingsCountriesIndexRouteRoute
  '/_private/settings/departments/': typeof PrivateSettingsDepartmentsIndexRouteRoute
  '/_private/settings/email-history/': typeof PrivateSettingsEmailHistoryIndexRouteRoute
  '/_private/settings/email-template-defaults/': typeof PrivateSettingsEmailTemplateDefaultsIndexRouteRoute
  '/_private/settings/email-templates/': typeof PrivateSettingsEmailTemplatesIndexRouteRoute
  '/_private/settings/industries/': typeof PrivateSettingsIndustriesIndexRouteRoute
  '/_private/settings/infrastructures/': typeof PrivateSettingsInfrastructuresIndexRouteRoute
  '/_private/settings/inventory-bin-locations/': typeof PrivateSettingsInventoryBinLocationsIndexRouteRoute
  '/_private/settings/inventory-categories/': typeof PrivateSettingsInventoryCategoriesIndexRouteRoute
  '/_private/settings/inventory-kits/': typeof PrivateSettingsInventoryKitsIndexRouteRoute
  '/_private/settings/inventory-purchases/': typeof PrivateSettingsInventoryPurchasesIndexRouteRoute
  '/_private/settings/inventory-stocks/': typeof PrivateSettingsInventoryStocksIndexRouteRoute
  '/_private/settings/inventory-vendors/': typeof PrivateSettingsInventoryVendorsIndexRouteRoute
  '/_private/settings/inventory-volumes/': typeof PrivateSettingsInventoryVolumesIndexRouteRoute
  '/_private/settings/job-positions/': typeof PrivateSettingsJobPositionsIndexRouteRoute
  '/_private/settings/magazines/': typeof PrivateSettingsMagazinesIndexRouteRoute
  '/_private/settings/manufacturers/': typeof PrivateSettingsManufacturersIndexRouteRoute
  '/_private/settings/mileage-rates/': typeof PrivateSettingsMileageRatesIndexRouteRoute
  '/_private/settings/organization-types/': typeof PrivateSettingsOrganizationTypesIndexRouteRoute
  '/_private/settings/partners/': typeof PrivateSettingsPartnersIndexRouteRoute
  '/_private/settings/payment-methods/': typeof PrivateSettingsPaymentMethodsIndexRouteRoute
  '/_private/settings/preferred-locations/': typeof PrivateSettingsPreferredLocationsIndexRouteRoute
  '/_private/settings/preferred-relationships/': typeof PrivateSettingsPreferredRelationshipsIndexRouteRoute
  '/_private/settings/price-frequencies/': typeof PrivateSettingsPriceFrequenciesIndexRouteRoute
  '/_private/settings/products-and-services-templates/': typeof PrivateSettingsProductsAndServicesTemplatesIndexRouteRoute
  '/_private/settings/recruiting-hiring-criteria-categories/': typeof PrivateSettingsRecruitingHiringCriteriaCategoriesIndexRouteRoute
  '/_private/settings/recruiting-job-categories/': typeof PrivateSettingsRecruitingJobCategoriesIndexRouteRoute
  '/_private/settings/recruiting-statuses/': typeof PrivateSettingsRecruitingStatusesIndexRouteRoute
  '/_private/settings/registrars/': typeof PrivateSettingsRegistrarsIndexRouteRoute
  '/_private/settings/relationship-scores/': typeof PrivateSettingsRelationshipScoresIndexRouteRoute
  '/_private/settings/revenue-lockdowns/': typeof PrivateSettingsRevenueLockdownsIndexRouteRoute
  '/_private/settings/salary-grades/': typeof PrivateSettingsSalaryGradesIndexRouteRoute
  '/_private/settings/system-files/': typeof PrivateSettingsSystemFilesIndexRouteRoute
  '/_private/settings/terms-categories/': typeof PrivateSettingsTermsCategoriesIndexRouteRoute
  '/_private/settings/terms-conditions/': typeof PrivateSettingsTermsConditionsIndexRouteRoute
  '/_private/settings/terms-templates/': typeof PrivateSettingsTermsTemplatesIndexRouteRoute
  '/_private/settings/unit-sell-bys/': typeof PrivateSettingsUnitSellBysIndexRouteRoute
  '/_private/settings/user-roles/': typeof PrivateSettingsUserRolesIndexRouteRoute
  '/_private/inventory/parent/$id': typeof PrivateInventoryParentIdRouteRoute
  '/_private/invoices/invoice-batch/$id': typeof PrivateInvoicesInvoiceBatchIdRouteRoute
  '/_private/settings/audiences/$id': typeof PrivateSettingsAudiencesIdRouteRoute
  '/_private/settings/audiences/new': typeof PrivateSettingsAudiencesNewRouteRoute
  '/_private/settings/bank-accounts/$id': typeof PrivateSettingsBankAccountsIdRouteRoute
  '/_private/settings/bank-accounts/new': typeof PrivateSettingsBankAccountsNewRouteRoute
  '/_private/settings/billing-systems/$id': typeof PrivateSettingsBillingSystemsIdRouteRoute
  '/_private/settings/billing-systems/new': typeof PrivateSettingsBillingSystemsNewRouteRoute
  '/_private/settings/billing-terms/$id': typeof PrivateSettingsBillingTermsIdRouteRoute
  '/_private/settings/billing-terms/new': typeof PrivateSettingsBillingTermsNewRouteRoute
  '/_private/settings/brands/$id': typeof PrivateSettingsBrandsIdRouteRoute
  '/_private/settings/brands/new': typeof PrivateSettingsBrandsNewRouteRoute
  '/_private/settings/business-disciplines/$id': typeof PrivateSettingsBusinessDisciplinesIdRouteRoute
  '/_private/settings/business-disciplines/new': typeof PrivateSettingsBusinessDisciplinesNewRouteRoute
  '/_private/settings/categories/$id': typeof PrivateSettingsCategoriesIdRouteRoute
  '/_private/settings/categories/new': typeof PrivateSettingsCategoriesNewRouteRoute
  '/_private/settings/commission-plans/$id': typeof PrivateSettingsCommissionPlansIdRouteRoute
  '/_private/settings/commission-plans/new': typeof PrivateSettingsCommissionPlansNewRouteRoute
  '/_private/settings/countries/$id': typeof PrivateSettingsCountriesIdRouteRoute
  '/_private/settings/countries/new': typeof PrivateSettingsCountriesNewRouteRoute
  '/_private/settings/departments/$id': typeof PrivateSettingsDepartmentsIdRouteRoute
  '/_private/settings/departments/new': typeof PrivateSettingsDepartmentsNewRouteRoute
  '/_private/settings/email-history/$id': typeof PrivateSettingsEmailHistoryIdRouteRoute
  '/_private/settings/email-templates/$id': typeof PrivateSettingsEmailTemplatesIdRouteRoute
  '/_private/settings/email-templates/new': typeof PrivateSettingsEmailTemplatesNewRouteRoute
  '/_private/settings/industries/$id': typeof PrivateSettingsIndustriesIdRouteRoute
  '/_private/settings/industries/new': typeof PrivateSettingsIndustriesNewRouteRoute
  '/_private/settings/infrastructures/$id': typeof PrivateSettingsInfrastructuresIdRouteRoute
  '/_private/settings/infrastructures/new': typeof PrivateSettingsInfrastructuresNewRouteRoute
  '/_private/settings/inventory-bin-locations/$id': typeof PrivateSettingsInventoryBinLocationsIdRouteRoute
  '/_private/settings/inventory-bin-locations/new': typeof PrivateSettingsInventoryBinLocationsNewRouteRoute
  '/_private/settings/inventory-categories/$id': typeof PrivateSettingsInventoryCategoriesIdRouteRoute
  '/_private/settings/inventory-categories/new': typeof PrivateSettingsInventoryCategoriesNewRouteRoute
  '/_private/settings/inventory-kits/$id': typeof PrivateSettingsInventoryKitsIdRouteRoute
  '/_private/settings/inventory-kits/new': typeof PrivateSettingsInventoryKitsNewRouteRoute
  '/_private/settings/inventory-purchases/$id': typeof PrivateSettingsInventoryPurchasesIdRouteRoute
  '/_private/settings/inventory-purchases/new': typeof PrivateSettingsInventoryPurchasesNewRouteRoute
  '/_private/settings/inventory-stocks/$id': typeof PrivateSettingsInventoryStocksIdRouteRoute
  '/_private/settings/inventory-stocks/new': typeof PrivateSettingsInventoryStocksNewRouteRoute
  '/_private/settings/inventory-vendors/$id': typeof PrivateSettingsInventoryVendorsIdRouteRoute
  '/_private/settings/inventory-vendors/new': typeof PrivateSettingsInventoryVendorsNewRouteRoute
  '/_private/settings/inventory-volumes/$id': typeof PrivateSettingsInventoryVolumesIdRouteRoute
  '/_private/settings/inventory-volumes/new': typeof PrivateSettingsInventoryVolumesNewRouteRoute
  '/_private/settings/job-positions/new': typeof PrivateSettingsJobPositionsNewRouteRoute
  '/_private/settings/magazines/$id': typeof PrivateSettingsMagazinesIdRouteRoute
  '/_private/settings/magazines/new': typeof PrivateSettingsMagazinesNewRouteRoute
  '/_private/settings/manufacturers/$id': typeof PrivateSettingsManufacturersIdRouteRoute
  '/_private/settings/manufacturers/new': typeof PrivateSettingsManufacturersNewRouteRoute
  '/_private/settings/mileage-rates/$id': typeof PrivateSettingsMileageRatesIdRouteRoute
  '/_private/settings/mileage-rates/new': typeof PrivateSettingsMileageRatesNewRouteRoute
  '/_private/settings/organization-types/$id': typeof PrivateSettingsOrganizationTypesIdRouteRoute
  '/_private/settings/organization-types/new': typeof PrivateSettingsOrganizationTypesNewRouteRoute
  '/_private/settings/partners/$id': typeof PrivateSettingsPartnersIdRouteRoute
  '/_private/settings/partners/new': typeof PrivateSettingsPartnersNewRouteRoute
  '/_private/settings/payment-methods/$id': typeof PrivateSettingsPaymentMethodsIdRouteRoute
  '/_private/settings/payment-methods/new': typeof PrivateSettingsPaymentMethodsNewRouteRoute
  '/_private/settings/preferred-locations/$id': typeof PrivateSettingsPreferredLocationsIdRouteRoute
  '/_private/settings/preferred-locations/new': typeof PrivateSettingsPreferredLocationsNewRouteRoute
  '/_private/settings/preferred-relationships/$id': typeof PrivateSettingsPreferredRelationshipsIdRouteRoute
  '/_private/settings/preferred-relationships/new': typeof PrivateSettingsPreferredRelationshipsNewRouteRoute
  '/_private/settings/price-frequencies/$id': typeof PrivateSettingsPriceFrequenciesIdRouteRoute
  '/_private/settings/price-frequencies/new': typeof PrivateSettingsPriceFrequenciesNewRouteRoute
  '/_private/settings/products-and-services-templates/$id': typeof PrivateSettingsProductsAndServicesTemplatesIdRouteRoute
  '/_private/settings/products-and-services-templates/new': typeof PrivateSettingsProductsAndServicesTemplatesNewRouteRoute
  '/_private/settings/recruiting-hiring-criteria-categories/$id': typeof PrivateSettingsRecruitingHiringCriteriaCategoriesIdRouteRoute
  '/_private/settings/recruiting-hiring-criteria-categories/new': typeof PrivateSettingsRecruitingHiringCriteriaCategoriesNewRouteRoute
  '/_private/settings/recruiting-job-categories/$id': typeof PrivateSettingsRecruitingJobCategoriesIdRouteRoute
  '/_private/settings/recruiting-job-categories/new': typeof PrivateSettingsRecruitingJobCategoriesNewRouteRoute
  '/_private/settings/recruiting-statuses/$id': typeof PrivateSettingsRecruitingStatusesIdRouteRoute
  '/_private/settings/recruiting-statuses/new': typeof PrivateSettingsRecruitingStatusesNewRouteRoute
  '/_private/settings/registrars/new': typeof PrivateSettingsRegistrarsNewRouteRoute
  '/_private/settings/relationship-scores/$id': typeof PrivateSettingsRelationshipScoresIdRouteRoute
  '/_private/settings/relationship-scores/new': typeof PrivateSettingsRelationshipScoresNewRouteRoute
  '/_private/settings/revenue-lockdowns/$id': typeof PrivateSettingsRevenueLockdownsIdRouteRoute
  '/_private/settings/revenue-lockdowns/new': typeof PrivateSettingsRevenueLockdownsNewRouteRoute
  '/_private/settings/salary-grades/$id': typeof PrivateSettingsSalaryGradesIdRouteRoute
  '/_private/settings/salary-grades/new': typeof PrivateSettingsSalaryGradesNewRouteRoute
  '/_private/settings/system-files/$id': typeof PrivateSettingsSystemFilesIdRouteRoute
  '/_private/settings/system-files/new': typeof PrivateSettingsSystemFilesNewRouteRoute
  '/_private/settings/terms-categories/$id': typeof PrivateSettingsTermsCategoriesIdRouteRoute
  '/_private/settings/terms-categories/new': typeof PrivateSettingsTermsCategoriesNewRouteRoute
  '/_private/settings/terms-conditions/$id': typeof PrivateSettingsTermsConditionsIdRouteRoute
  '/_private/settings/terms-conditions/new': typeof PrivateSettingsTermsConditionsNewRouteRoute
  '/_private/settings/terms-templates/$id': typeof PrivateSettingsTermsTemplatesIdRouteRoute
  '/_private/settings/terms-templates/new': typeof PrivateSettingsTermsTemplatesNewRouteRoute
  '/_private/settings/unit-sell-bys/$id': typeof PrivateSettingsUnitSellBysIdRouteRoute
  '/_private/settings/unit-sell-bys/new': typeof PrivateSettingsUnitSellBysNewRouteRoute
  '/_private/settings/user-roles/$id': typeof PrivateSettingsUserRolesIdRouteRoute
  '/_private/settings/user-roles/new': typeof PrivateSettingsUserRolesNewRouteRoute
  '/_private/settings/job-positions/_template': typeof PrivateSettingsJobPositionsTemplateRouteWithChildren
  '/_private/settings/registrars/_template': typeof PrivateSettingsRegistrarsTemplateRouteWithChildren
  '/_private/agreements/_template/$id/': typeof PrivateAgreementsTemplateIdIndexRouteRoute
  '/_private/companies/_template/$id/': typeof PrivateCompaniesTemplateIdIndexRouteRoute
  '/_private/competitors/_template/$id/': typeof PrivateCompetitorsTemplateIdIndexRouteRoute
  '/_private/contacts/_template/$id/': typeof PrivateContactsTemplateIdIndexRouteRoute
  '/_private/inventory/_template/$id/': typeof PrivateInventoryTemplateIdIndexRouteRoute
  '/_private/team-members/_template/$id/': typeof PrivateTeamMembersTemplateIdIndexRouteRoute
  '/_private/agreements/_template/$id/addendum': typeof PrivateAgreementsTemplateIdAddendumRouteRoute
  '/_private/agreements/_template/$id/api-integration': typeof PrivateAgreementsTemplateIdApiIntegrationRouteRoute
  '/_private/agreements/_template/$id/commission': typeof PrivateAgreementsTemplateIdCommissionRouteRoute
  '/_private/agreements/_template/$id/deliverables': typeof PrivateAgreementsTemplateIdDeliverablesRouteRoute
  '/_private/agreements/_template/$id/execution': typeof PrivateAgreementsTemplateIdExecutionRouteRoute
  '/_private/agreements/_template/$id/financial-override': typeof PrivateAgreementsTemplateIdFinancialOverrideRouteRoute
  '/_private/agreements/_template/$id/paperwork': typeof PrivateAgreementsTemplateIdPaperworkRouteRoute
  '/_private/agreements/_template/$id/subsidies': typeof PrivateAgreementsTemplateIdSubsidiesRouteRoute
  '/_private/companies/_template/$id/agreements': typeof PrivateCompaniesTemplateIdAgreementsRouteRoute
  '/_private/companies/_template/$id/api-integration': typeof PrivateCompaniesTemplateIdApiIntegrationRouteRoute
  '/_private/companies/_template/$id/contacts': typeof PrivateCompaniesTemplateIdContactsRouteRoute
  '/_private/companies/_template/$id/domains': typeof PrivateCompaniesTemplateIdDomainsRouteRoute
  '/_private/companies/_template/$id/financials': typeof PrivateCompaniesTemplateIdFinancialsRouteRoute
  '/_private/companies/_template/$id/invoice-history': typeof PrivateCompaniesTemplateIdInvoiceHistoryRouteRoute
  '/_private/companies/_template/$id/marketing-campaigns': typeof PrivateCompaniesTemplateIdMarketingCampaignsRouteRoute
  '/_private/companies/_template/$id/notes': typeof PrivateCompaniesTemplateIdNotesRouteRoute
  '/_private/companies/_template/$id/subscriptions': typeof PrivateCompaniesTemplateIdSubscriptionsRouteRoute
  '/_private/competitors/_template/$id/associated-companies': typeof PrivateCompetitorsTemplateIdAssociatedCompaniesRouteRoute
  '/_private/competitors/_template/$id/contacts': typeof PrivateCompetitorsTemplateIdContactsRouteRoute
  '/_private/competitors/_template/$id/notes': typeof PrivateCompetitorsTemplateIdNotesRouteRoute
  '/_private/contacts/_template/$id/agreements': typeof PrivateContactsTemplateIdAgreementsRouteRoute
  '/_private/contacts/_template/$id/api-integration': typeof PrivateContactsTemplateIdApiIntegrationRouteRoute
  '/_private/contacts/_template/$id/marketing-campaigns': typeof PrivateContactsTemplateIdMarketingCampaignsRouteRoute
  '/_private/contacts/_template/$id/notes': typeof PrivateContactsTemplateIdNotesRouteRoute
  '/_private/inventory/_template/$id/vendors': typeof PrivateInventoryTemplateIdVendorsRouteRoute
  '/_private/team-members/_template/$id/api-integration': typeof PrivateTeamMembersTemplateIdApiIntegrationRouteRoute
  '/_private/team-members/_template/$id/commission-periods': typeof PrivateTeamMembersTemplateIdCommissionPeriodsRouteRoute
  '/_private/team-members/_template/$id/emergency': typeof PrivateTeamMembersTemplateIdEmergencyRouteRoute
  '/_private/team-members/_template/$id/marketing': typeof PrivateTeamMembersTemplateIdMarketingRouteRoute
  '/_private/team-members/_template/$id/personal-details': typeof PrivateTeamMembersTemplateIdPersonalDetailsRouteRoute
  '/_private/team-members/_template/$id/preference': typeof PrivateTeamMembersTemplateIdPreferenceRouteRoute
  '/_private/companies/_template/$id/support/': typeof PrivateCompaniesTemplateIdSupportIndexRouteRoute
  '/_private/contacts/_template/$id/support/': typeof PrivateContactsTemplateIdSupportIndexRouteRoute
  '/_private/settings/job-positions/_template/$id/': typeof PrivateSettingsJobPositionsTemplateIdIndexRouteRoute
  '/_private/settings/registrars/_template/$id/': typeof PrivateSettingsRegistrarsTemplateIdIndexRouteRoute
  '/_private/companies/_template/$id/support/$ticket_id': typeof PrivateCompaniesTemplateIdSupportTicket_idRouteRoute
  '/_private/contacts/_template/$id/support/$ticket_id': typeof PrivateContactsTemplateIdSupportTicket_idRouteRoute
  '/_private/settings/job-positions/_template/$id/advertisement': typeof PrivateSettingsJobPositionsTemplateIdAdvertisementRouteRoute
  '/_private/settings/job-positions/_template/$id/agreement': typeof PrivateSettingsJobPositionsTemplateIdAgreementRouteRoute
  '/_private/settings/job-positions/_template/$id/hiring': typeof PrivateSettingsJobPositionsTemplateIdHiringRouteRoute
  '/_private/settings/registrars/_template/$id/domains': typeof PrivateSettingsRegistrarsTemplateIdDomainsRouteRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/test'
    | '/auth/'
    | '/account-receivables/'
    | '/agreements/'
    | '/awards/'
    | '/companies/'
    | '/competitors/'
    | '/conferences-and-events/'
    | '/connected-apps/'
    | '/contacts/'
    | '/dashboard/'
    | '/deposits/'
    | '/domains/'
    | '/financial-snapshots/'
    | '/governance/'
    | '/inventory/'
    | '/invoices/'
    | '/marketing-campaigns/'
    | '/media/'
    | '/pick-tickets/'
    | '/products-and-services/'
    | '/recruiting/'
    | '/settings/'
    | '/support/'
    | '/system-users/'
    | '/team-members/'
    | '/forgot-password/'
    | '/login/'
    | '/reset-password/'
    | '/signup/'
    | '/account-receivables/$id'
    | '/account-receivables/new'
    | '/agreements/new'
    | '/awards/$id'
    | '/awards/new'
    | '/companies/new'
    | '/competitors/new'
    | '/conferences-and-events/$id'
    | '/conferences-and-events/new'
    | '/connected-apps/$id'
    | '/connected-apps/new'
    | '/contacts/new'
    | '/deposits/$id'
    | '/deposits/new'
    | '/domains/$id'
    | '/domains/new'
    | '/financial-snapshots/$id'
    | '/financial-snapshots/new'
    | '/governance/$id'
    | '/governance/new'
    | '/inventory/new'
    | '/inventory/parent-new'
    | '/invoices/$id'
    | '/invoices/new'
    | '/marketing-campaigns/$id'
    | '/marketing-campaigns/new'
    | '/pending-deposits/$id'
    | '/pick-tickets/$id'
    | '/pick-tickets/new'
    | '/products-and-services/$id'
    | '/products-and-services/new'
    | '/recruiting/$id'
    | '/recruiting/new'
    | '/settings/revenue-allocation-lockdown-override-logs'
    | '/settings/view-logs'
    | '/support/$ticket_id'
    | '/system-users/$id'
    | '/team-members/new'
    | '/agreements'
    | '/companies'
    | '/competitors'
    | '/contacts'
    | '/inventory'
    | '/team-members'
    | '/settings/audiences/'
    | '/settings/bank-accounts/'
    | '/settings/billing-systems/'
    | '/settings/billing-terms/'
    | '/settings/brands/'
    | '/settings/business-disciplines/'
    | '/settings/categories/'
    | '/settings/commission-plans/'
    | '/settings/countries/'
    | '/settings/departments/'
    | '/settings/email-history/'
    | '/settings/email-template-defaults/'
    | '/settings/email-templates/'
    | '/settings/industries/'
    | '/settings/infrastructures/'
    | '/settings/inventory-bin-locations/'
    | '/settings/inventory-categories/'
    | '/settings/inventory-kits/'
    | '/settings/inventory-purchases/'
    | '/settings/inventory-stocks/'
    | '/settings/inventory-vendors/'
    | '/settings/inventory-volumes/'
    | '/settings/job-positions/'
    | '/settings/magazines/'
    | '/settings/manufacturers/'
    | '/settings/mileage-rates/'
    | '/settings/organization-types/'
    | '/settings/partners/'
    | '/settings/payment-methods/'
    | '/settings/preferred-locations/'
    | '/settings/preferred-relationships/'
    | '/settings/price-frequencies/'
    | '/settings/products-and-services-templates/'
    | '/settings/recruiting-hiring-criteria-categories/'
    | '/settings/recruiting-job-categories/'
    | '/settings/recruiting-statuses/'
    | '/settings/registrars/'
    | '/settings/relationship-scores/'
    | '/settings/revenue-lockdowns/'
    | '/settings/salary-grades/'
    | '/settings/system-files/'
    | '/settings/terms-categories/'
    | '/settings/terms-conditions/'
    | '/settings/terms-templates/'
    | '/settings/unit-sell-bys/'
    | '/settings/user-roles/'
    | '/inventory/parent/$id'
    | '/invoices/invoice-batch/$id'
    | '/settings/audiences/$id'
    | '/settings/audiences/new'
    | '/settings/bank-accounts/$id'
    | '/settings/bank-accounts/new'
    | '/settings/billing-systems/$id'
    | '/settings/billing-systems/new'
    | '/settings/billing-terms/$id'
    | '/settings/billing-terms/new'
    | '/settings/brands/$id'
    | '/settings/brands/new'
    | '/settings/business-disciplines/$id'
    | '/settings/business-disciplines/new'
    | '/settings/categories/$id'
    | '/settings/categories/new'
    | '/settings/commission-plans/$id'
    | '/settings/commission-plans/new'
    | '/settings/countries/$id'
    | '/settings/countries/new'
    | '/settings/departments/$id'
    | '/settings/departments/new'
    | '/settings/email-history/$id'
    | '/settings/email-templates/$id'
    | '/settings/email-templates/new'
    | '/settings/industries/$id'
    | '/settings/industries/new'
    | '/settings/infrastructures/$id'
    | '/settings/infrastructures/new'
    | '/settings/inventory-bin-locations/$id'
    | '/settings/inventory-bin-locations/new'
    | '/settings/inventory-categories/$id'
    | '/settings/inventory-categories/new'
    | '/settings/inventory-kits/$id'
    | '/settings/inventory-kits/new'
    | '/settings/inventory-purchases/$id'
    | '/settings/inventory-purchases/new'
    | '/settings/inventory-stocks/$id'
    | '/settings/inventory-stocks/new'
    | '/settings/inventory-vendors/$id'
    | '/settings/inventory-vendors/new'
    | '/settings/inventory-volumes/$id'
    | '/settings/inventory-volumes/new'
    | '/settings/job-positions/new'
    | '/settings/magazines/$id'
    | '/settings/magazines/new'
    | '/settings/manufacturers/$id'
    | '/settings/manufacturers/new'
    | '/settings/mileage-rates/$id'
    | '/settings/mileage-rates/new'
    | '/settings/organization-types/$id'
    | '/settings/organization-types/new'
    | '/settings/partners/$id'
    | '/settings/partners/new'
    | '/settings/payment-methods/$id'
    | '/settings/payment-methods/new'
    | '/settings/preferred-locations/$id'
    | '/settings/preferred-locations/new'
    | '/settings/preferred-relationships/$id'
    | '/settings/preferred-relationships/new'
    | '/settings/price-frequencies/$id'
    | '/settings/price-frequencies/new'
    | '/settings/products-and-services-templates/$id'
    | '/settings/products-and-services-templates/new'
    | '/settings/recruiting-hiring-criteria-categories/$id'
    | '/settings/recruiting-hiring-criteria-categories/new'
    | '/settings/recruiting-job-categories/$id'
    | '/settings/recruiting-job-categories/new'
    | '/settings/recruiting-statuses/$id'
    | '/settings/recruiting-statuses/new'
    | '/settings/registrars/new'
    | '/settings/relationship-scores/$id'
    | '/settings/relationship-scores/new'
    | '/settings/revenue-lockdowns/$id'
    | '/settings/revenue-lockdowns/new'
    | '/settings/salary-grades/$id'
    | '/settings/salary-grades/new'
    | '/settings/system-files/$id'
    | '/settings/system-files/new'
    | '/settings/terms-categories/$id'
    | '/settings/terms-categories/new'
    | '/settings/terms-conditions/$id'
    | '/settings/terms-conditions/new'
    | '/settings/terms-templates/$id'
    | '/settings/terms-templates/new'
    | '/settings/unit-sell-bys/$id'
    | '/settings/unit-sell-bys/new'
    | '/settings/user-roles/$id'
    | '/settings/user-roles/new'
    | '/settings/job-positions'
    | '/settings/registrars'
    | '/agreements/$id/'
    | '/companies/$id/'
    | '/competitors/$id/'
    | '/contacts/$id/'
    | '/inventory/$id/'
    | '/team-members/$id/'
    | '/agreements/$id/addendum'
    | '/agreements/$id/api-integration'
    | '/agreements/$id/commission'
    | '/agreements/$id/deliverables'
    | '/agreements/$id/execution'
    | '/agreements/$id/financial-override'
    | '/agreements/$id/paperwork'
    | '/agreements/$id/subsidies'
    | '/companies/$id/agreements'
    | '/companies/$id/api-integration'
    | '/companies/$id/contacts'
    | '/companies/$id/domains'
    | '/companies/$id/financials'
    | '/companies/$id/invoice-history'
    | '/companies/$id/marketing-campaigns'
    | '/companies/$id/notes'
    | '/companies/$id/subscriptions'
    | '/competitors/$id/associated-companies'
    | '/competitors/$id/contacts'
    | '/competitors/$id/notes'
    | '/contacts/$id/agreements'
    | '/contacts/$id/api-integration'
    | '/contacts/$id/marketing-campaigns'
    | '/contacts/$id/notes'
    | '/inventory/$id/vendors'
    | '/team-members/$id/api-integration'
    | '/team-members/$id/commission-periods'
    | '/team-members/$id/emergency'
    | '/team-members/$id/marketing'
    | '/team-members/$id/personal-details'
    | '/team-members/$id/preference'
    | '/companies/$id/support/'
    | '/contacts/$id/support/'
    | '/settings/job-positions/$id/'
    | '/settings/registrars/$id/'
    | '/companies/$id/support/$ticket_id'
    | '/contacts/$id/support/$ticket_id'
    | '/settings/job-positions/$id/advertisement'
    | '/settings/job-positions/$id/agreement'
    | '/settings/job-positions/$id/hiring'
    | '/settings/registrars/$id/domains'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/test'
    | '/auth'
    | '/account-receivables'
    | '/agreements'
    | '/awards'
    | '/companies'
    | '/competitors'
    | '/conferences-and-events'
    | '/connected-apps'
    | '/contacts'
    | '/dashboard'
    | '/deposits'
    | '/domains'
    | '/financial-snapshots'
    | '/governance'
    | '/inventory'
    | '/invoices'
    | '/marketing-campaigns'
    | '/media'
    | '/pick-tickets'
    | '/products-and-services'
    | '/recruiting'
    | '/settings'
    | '/support'
    | '/system-users'
    | '/team-members'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/account-receivables/$id'
    | '/account-receivables/new'
    | '/agreements/new'
    | '/awards/$id'
    | '/awards/new'
    | '/companies/new'
    | '/competitors/new'
    | '/conferences-and-events/$id'
    | '/conferences-and-events/new'
    | '/connected-apps/$id'
    | '/connected-apps/new'
    | '/contacts/new'
    | '/deposits/$id'
    | '/deposits/new'
    | '/domains/$id'
    | '/domains/new'
    | '/financial-snapshots/$id'
    | '/financial-snapshots/new'
    | '/governance/$id'
    | '/governance/new'
    | '/inventory/new'
    | '/inventory/parent-new'
    | '/invoices/$id'
    | '/invoices/new'
    | '/marketing-campaigns/$id'
    | '/marketing-campaigns/new'
    | '/pending-deposits/$id'
    | '/pick-tickets/$id'
    | '/pick-tickets/new'
    | '/products-and-services/$id'
    | '/products-and-services/new'
    | '/recruiting/$id'
    | '/recruiting/new'
    | '/settings/revenue-allocation-lockdown-override-logs'
    | '/settings/view-logs'
    | '/support/$ticket_id'
    | '/system-users/$id'
    | '/team-members/new'
    | '/settings/audiences'
    | '/settings/bank-accounts'
    | '/settings/billing-systems'
    | '/settings/billing-terms'
    | '/settings/brands'
    | '/settings/business-disciplines'
    | '/settings/categories'
    | '/settings/commission-plans'
    | '/settings/countries'
    | '/settings/departments'
    | '/settings/email-history'
    | '/settings/email-template-defaults'
    | '/settings/email-templates'
    | '/settings/industries'
    | '/settings/infrastructures'
    | '/settings/inventory-bin-locations'
    | '/settings/inventory-categories'
    | '/settings/inventory-kits'
    | '/settings/inventory-purchases'
    | '/settings/inventory-stocks'
    | '/settings/inventory-vendors'
    | '/settings/inventory-volumes'
    | '/settings/job-positions'
    | '/settings/magazines'
    | '/settings/manufacturers'
    | '/settings/mileage-rates'
    | '/settings/organization-types'
    | '/settings/partners'
    | '/settings/payment-methods'
    | '/settings/preferred-locations'
    | '/settings/preferred-relationships'
    | '/settings/price-frequencies'
    | '/settings/products-and-services-templates'
    | '/settings/recruiting-hiring-criteria-categories'
    | '/settings/recruiting-job-categories'
    | '/settings/recruiting-statuses'
    | '/settings/registrars'
    | '/settings/relationship-scores'
    | '/settings/revenue-lockdowns'
    | '/settings/salary-grades'
    | '/settings/system-files'
    | '/settings/terms-categories'
    | '/settings/terms-conditions'
    | '/settings/terms-templates'
    | '/settings/unit-sell-bys'
    | '/settings/user-roles'
    | '/inventory/parent/$id'
    | '/invoices/invoice-batch/$id'
    | '/settings/audiences/$id'
    | '/settings/audiences/new'
    | '/settings/bank-accounts/$id'
    | '/settings/bank-accounts/new'
    | '/settings/billing-systems/$id'
    | '/settings/billing-systems/new'
    | '/settings/billing-terms/$id'
    | '/settings/billing-terms/new'
    | '/settings/brands/$id'
    | '/settings/brands/new'
    | '/settings/business-disciplines/$id'
    | '/settings/business-disciplines/new'
    | '/settings/categories/$id'
    | '/settings/categories/new'
    | '/settings/commission-plans/$id'
    | '/settings/commission-plans/new'
    | '/settings/countries/$id'
    | '/settings/countries/new'
    | '/settings/departments/$id'
    | '/settings/departments/new'
    | '/settings/email-history/$id'
    | '/settings/email-templates/$id'
    | '/settings/email-templates/new'
    | '/settings/industries/$id'
    | '/settings/industries/new'
    | '/settings/infrastructures/$id'
    | '/settings/infrastructures/new'
    | '/settings/inventory-bin-locations/$id'
    | '/settings/inventory-bin-locations/new'
    | '/settings/inventory-categories/$id'
    | '/settings/inventory-categories/new'
    | '/settings/inventory-kits/$id'
    | '/settings/inventory-kits/new'
    | '/settings/inventory-purchases/$id'
    | '/settings/inventory-purchases/new'
    | '/settings/inventory-stocks/$id'
    | '/settings/inventory-stocks/new'
    | '/settings/inventory-vendors/$id'
    | '/settings/inventory-vendors/new'
    | '/settings/inventory-volumes/$id'
    | '/settings/inventory-volumes/new'
    | '/settings/job-positions/new'
    | '/settings/magazines/$id'
    | '/settings/magazines/new'
    | '/settings/manufacturers/$id'
    | '/settings/manufacturers/new'
    | '/settings/mileage-rates/$id'
    | '/settings/mileage-rates/new'
    | '/settings/organization-types/$id'
    | '/settings/organization-types/new'
    | '/settings/partners/$id'
    | '/settings/partners/new'
    | '/settings/payment-methods/$id'
    | '/settings/payment-methods/new'
    | '/settings/preferred-locations/$id'
    | '/settings/preferred-locations/new'
    | '/settings/preferred-relationships/$id'
    | '/settings/preferred-relationships/new'
    | '/settings/price-frequencies/$id'
    | '/settings/price-frequencies/new'
    | '/settings/products-and-services-templates/$id'
    | '/settings/products-and-services-templates/new'
    | '/settings/recruiting-hiring-criteria-categories/$id'
    | '/settings/recruiting-hiring-criteria-categories/new'
    | '/settings/recruiting-job-categories/$id'
    | '/settings/recruiting-job-categories/new'
    | '/settings/recruiting-statuses/$id'
    | '/settings/recruiting-statuses/new'
    | '/settings/registrars/new'
    | '/settings/relationship-scores/$id'
    | '/settings/relationship-scores/new'
    | '/settings/revenue-lockdowns/$id'
    | '/settings/revenue-lockdowns/new'
    | '/settings/salary-grades/$id'
    | '/settings/salary-grades/new'
    | '/settings/system-files/$id'
    | '/settings/system-files/new'
    | '/settings/terms-categories/$id'
    | '/settings/terms-categories/new'
    | '/settings/terms-conditions/$id'
    | '/settings/terms-conditions/new'
    | '/settings/terms-templates/$id'
    | '/settings/terms-templates/new'
    | '/settings/unit-sell-bys/$id'
    | '/settings/unit-sell-bys/new'
    | '/settings/user-roles/$id'
    | '/settings/user-roles/new'
    | '/agreements/$id'
    | '/companies/$id'
    | '/competitors/$id'
    | '/contacts/$id'
    | '/inventory/$id'
    | '/team-members/$id'
    | '/agreements/$id/addendum'
    | '/agreements/$id/api-integration'
    | '/agreements/$id/commission'
    | '/agreements/$id/deliverables'
    | '/agreements/$id/execution'
    | '/agreements/$id/financial-override'
    | '/agreements/$id/paperwork'
    | '/agreements/$id/subsidies'
    | '/companies/$id/agreements'
    | '/companies/$id/api-integration'
    | '/companies/$id/contacts'
    | '/companies/$id/domains'
    | '/companies/$id/financials'
    | '/companies/$id/invoice-history'
    | '/companies/$id/marketing-campaigns'
    | '/companies/$id/notes'
    | '/companies/$id/subscriptions'
    | '/competitors/$id/associated-companies'
    | '/competitors/$id/contacts'
    | '/competitors/$id/notes'
    | '/contacts/$id/agreements'
    | '/contacts/$id/api-integration'
    | '/contacts/$id/marketing-campaigns'
    | '/contacts/$id/notes'
    | '/inventory/$id/vendors'
    | '/team-members/$id/api-integration'
    | '/team-members/$id/commission-periods'
    | '/team-members/$id/emergency'
    | '/team-members/$id/marketing'
    | '/team-members/$id/personal-details'
    | '/team-members/$id/preference'
    | '/companies/$id/support'
    | '/contacts/$id/support'
    | '/settings/job-positions/$id'
    | '/settings/registrars/$id'
    | '/companies/$id/support/$ticket_id'
    | '/contacts/$id/support/$ticket_id'
    | '/settings/job-positions/$id/advertisement'
    | '/settings/job-positions/$id/agreement'
    | '/settings/job-positions/$id/hiring'
    | '/settings/registrars/$id/domains'
  id:
    | '__root__'
    | '/'
    | '/test'
    | '/_private'
    | '/_public'
    | '/auth/'
    | '/_private/account-receivables/'
    | '/_private/agreements/'
    | '/_private/awards/'
    | '/_private/companies/'
    | '/_private/competitors/'
    | '/_private/conferences-and-events/'
    | '/_private/connected-apps/'
    | '/_private/contacts/'
    | '/_private/dashboard/'
    | '/_private/deposits/'
    | '/_private/domains/'
    | '/_private/financial-snapshots/'
    | '/_private/governance/'
    | '/_private/inventory/'
    | '/_private/invoices/'
    | '/_private/marketing-campaigns/'
    | '/_private/media/'
    | '/_private/pick-tickets/'
    | '/_private/products-and-services/'
    | '/_private/recruiting/'
    | '/_private/settings/'
    | '/_private/support/'
    | '/_private/system-users/'
    | '/_private/team-members/'
    | '/_public/forgot-password/'
    | '/_public/login/'
    | '/_public/reset-password/'
    | '/_public/signup/'
    | '/_private/account-receivables/$id'
    | '/_private/account-receivables/new'
    | '/_private/agreements/new'
    | '/_private/awards/$id'
    | '/_private/awards/new'
    | '/_private/companies/new'
    | '/_private/competitors/new'
    | '/_private/conferences-and-events/$id'
    | '/_private/conferences-and-events/new'
    | '/_private/connected-apps/$id'
    | '/_private/connected-apps/new'
    | '/_private/contacts/new'
    | '/_private/deposits/$id'
    | '/_private/deposits/new'
    | '/_private/domains/$id'
    | '/_private/domains/new'
    | '/_private/financial-snapshots/$id'
    | '/_private/financial-snapshots/new'
    | '/_private/governance/$id'
    | '/_private/governance/new'
    | '/_private/inventory/new'
    | '/_private/inventory/parent-new'
    | '/_private/invoices/$id'
    | '/_private/invoices/new'
    | '/_private/marketing-campaigns/$id'
    | '/_private/marketing-campaigns/new'
    | '/_private/pending-deposits/$id'
    | '/_private/pick-tickets/$id'
    | '/_private/pick-tickets/new'
    | '/_private/products-and-services/$id'
    | '/_private/products-and-services/new'
    | '/_private/recruiting/$id'
    | '/_private/recruiting/new'
    | '/_private/settings/revenue-allocation-lockdown-override-logs'
    | '/_private/settings/view-logs'
    | '/_private/support/$ticket_id'
    | '/_private/system-users/$id'
    | '/_private/team-members/new'
    | '/_private/agreements/_template'
    | '/_private/companies/_template'
    | '/_private/competitors/_template'
    | '/_private/contacts/_template'
    | '/_private/inventory/_template'
    | '/_private/team-members/_template'
    | '/_private/settings/audiences/'
    | '/_private/settings/bank-accounts/'
    | '/_private/settings/billing-systems/'
    | '/_private/settings/billing-terms/'
    | '/_private/settings/brands/'
    | '/_private/settings/business-disciplines/'
    | '/_private/settings/categories/'
    | '/_private/settings/commission-plans/'
    | '/_private/settings/countries/'
    | '/_private/settings/departments/'
    | '/_private/settings/email-history/'
    | '/_private/settings/email-template-defaults/'
    | '/_private/settings/email-templates/'
    | '/_private/settings/industries/'
    | '/_private/settings/infrastructures/'
    | '/_private/settings/inventory-bin-locations/'
    | '/_private/settings/inventory-categories/'
    | '/_private/settings/inventory-kits/'
    | '/_private/settings/inventory-purchases/'
    | '/_private/settings/inventory-stocks/'
    | '/_private/settings/inventory-vendors/'
    | '/_private/settings/inventory-volumes/'
    | '/_private/settings/job-positions/'
    | '/_private/settings/magazines/'
    | '/_private/settings/manufacturers/'
    | '/_private/settings/mileage-rates/'
    | '/_private/settings/organization-types/'
    | '/_private/settings/partners/'
    | '/_private/settings/payment-methods/'
    | '/_private/settings/preferred-locations/'
    | '/_private/settings/preferred-relationships/'
    | '/_private/settings/price-frequencies/'
    | '/_private/settings/products-and-services-templates/'
    | '/_private/settings/recruiting-hiring-criteria-categories/'
    | '/_private/settings/recruiting-job-categories/'
    | '/_private/settings/recruiting-statuses/'
    | '/_private/settings/registrars/'
    | '/_private/settings/relationship-scores/'
    | '/_private/settings/revenue-lockdowns/'
    | '/_private/settings/salary-grades/'
    | '/_private/settings/system-files/'
    | '/_private/settings/terms-categories/'
    | '/_private/settings/terms-conditions/'
    | '/_private/settings/terms-templates/'
    | '/_private/settings/unit-sell-bys/'
    | '/_private/settings/user-roles/'
    | '/_private/inventory/parent/$id'
    | '/_private/invoices/invoice-batch/$id'
    | '/_private/settings/audiences/$id'
    | '/_private/settings/audiences/new'
    | '/_private/settings/bank-accounts/$id'
    | '/_private/settings/bank-accounts/new'
    | '/_private/settings/billing-systems/$id'
    | '/_private/settings/billing-systems/new'
    | '/_private/settings/billing-terms/$id'
    | '/_private/settings/billing-terms/new'
    | '/_private/settings/brands/$id'
    | '/_private/settings/brands/new'
    | '/_private/settings/business-disciplines/$id'
    | '/_private/settings/business-disciplines/new'
    | '/_private/settings/categories/$id'
    | '/_private/settings/categories/new'
    | '/_private/settings/commission-plans/$id'
    | '/_private/settings/commission-plans/new'
    | '/_private/settings/countries/$id'
    | '/_private/settings/countries/new'
    | '/_private/settings/departments/$id'
    | '/_private/settings/departments/new'
    | '/_private/settings/email-history/$id'
    | '/_private/settings/email-templates/$id'
    | '/_private/settings/email-templates/new'
    | '/_private/settings/industries/$id'
    | '/_private/settings/industries/new'
    | '/_private/settings/infrastructures/$id'
    | '/_private/settings/infrastructures/new'
    | '/_private/settings/inventory-bin-locations/$id'
    | '/_private/settings/inventory-bin-locations/new'
    | '/_private/settings/inventory-categories/$id'
    | '/_private/settings/inventory-categories/new'
    | '/_private/settings/inventory-kits/$id'
    | '/_private/settings/inventory-kits/new'
    | '/_private/settings/inventory-purchases/$id'
    | '/_private/settings/inventory-purchases/new'
    | '/_private/settings/inventory-stocks/$id'
    | '/_private/settings/inventory-stocks/new'
    | '/_private/settings/inventory-vendors/$id'
    | '/_private/settings/inventory-vendors/new'
    | '/_private/settings/inventory-volumes/$id'
    | '/_private/settings/inventory-volumes/new'
    | '/_private/settings/job-positions/new'
    | '/_private/settings/magazines/$id'
    | '/_private/settings/magazines/new'
    | '/_private/settings/manufacturers/$id'
    | '/_private/settings/manufacturers/new'
    | '/_private/settings/mileage-rates/$id'
    | '/_private/settings/mileage-rates/new'
    | '/_private/settings/organization-types/$id'
    | '/_private/settings/organization-types/new'
    | '/_private/settings/partners/$id'
    | '/_private/settings/partners/new'
    | '/_private/settings/payment-methods/$id'
    | '/_private/settings/payment-methods/new'
    | '/_private/settings/preferred-locations/$id'
    | '/_private/settings/preferred-locations/new'
    | '/_private/settings/preferred-relationships/$id'
    | '/_private/settings/preferred-relationships/new'
    | '/_private/settings/price-frequencies/$id'
    | '/_private/settings/price-frequencies/new'
    | '/_private/settings/products-and-services-templates/$id'
    | '/_private/settings/products-and-services-templates/new'
    | '/_private/settings/recruiting-hiring-criteria-categories/$id'
    | '/_private/settings/recruiting-hiring-criteria-categories/new'
    | '/_private/settings/recruiting-job-categories/$id'
    | '/_private/settings/recruiting-job-categories/new'
    | '/_private/settings/recruiting-statuses/$id'
    | '/_private/settings/recruiting-statuses/new'
    | '/_private/settings/registrars/new'
    | '/_private/settings/relationship-scores/$id'
    | '/_private/settings/relationship-scores/new'
    | '/_private/settings/revenue-lockdowns/$id'
    | '/_private/settings/revenue-lockdowns/new'
    | '/_private/settings/salary-grades/$id'
    | '/_private/settings/salary-grades/new'
    | '/_private/settings/system-files/$id'
    | '/_private/settings/system-files/new'
    | '/_private/settings/terms-categories/$id'
    | '/_private/settings/terms-categories/new'
    | '/_private/settings/terms-conditions/$id'
    | '/_private/settings/terms-conditions/new'
    | '/_private/settings/terms-templates/$id'
    | '/_private/settings/terms-templates/new'
    | '/_private/settings/unit-sell-bys/$id'
    | '/_private/settings/unit-sell-bys/new'
    | '/_private/settings/user-roles/$id'
    | '/_private/settings/user-roles/new'
    | '/_private/settings/job-positions/_template'
    | '/_private/settings/registrars/_template'
    | '/_private/agreements/_template/$id/'
    | '/_private/companies/_template/$id/'
    | '/_private/competitors/_template/$id/'
    | '/_private/contacts/_template/$id/'
    | '/_private/inventory/_template/$id/'
    | '/_private/team-members/_template/$id/'
    | '/_private/agreements/_template/$id/addendum'
    | '/_private/agreements/_template/$id/api-integration'
    | '/_private/agreements/_template/$id/commission'
    | '/_private/agreements/_template/$id/deliverables'
    | '/_private/agreements/_template/$id/execution'
    | '/_private/agreements/_template/$id/financial-override'
    | '/_private/agreements/_template/$id/paperwork'
    | '/_private/agreements/_template/$id/subsidies'
    | '/_private/companies/_template/$id/agreements'
    | '/_private/companies/_template/$id/api-integration'
    | '/_private/companies/_template/$id/contacts'
    | '/_private/companies/_template/$id/domains'
    | '/_private/companies/_template/$id/financials'
    | '/_private/companies/_template/$id/invoice-history'
    | '/_private/companies/_template/$id/marketing-campaigns'
    | '/_private/companies/_template/$id/notes'
    | '/_private/companies/_template/$id/subscriptions'
    | '/_private/competitors/_template/$id/associated-companies'
    | '/_private/competitors/_template/$id/contacts'
    | '/_private/competitors/_template/$id/notes'
    | '/_private/contacts/_template/$id/agreements'
    | '/_private/contacts/_template/$id/api-integration'
    | '/_private/contacts/_template/$id/marketing-campaigns'
    | '/_private/contacts/_template/$id/notes'
    | '/_private/inventory/_template/$id/vendors'
    | '/_private/team-members/_template/$id/api-integration'
    | '/_private/team-members/_template/$id/commission-periods'
    | '/_private/team-members/_template/$id/emergency'
    | '/_private/team-members/_template/$id/marketing'
    | '/_private/team-members/_template/$id/personal-details'
    | '/_private/team-members/_template/$id/preference'
    | '/_private/companies/_template/$id/support/'
    | '/_private/contacts/_template/$id/support/'
    | '/_private/settings/job-positions/_template/$id/'
    | '/_private/settings/registrars/_template/$id/'
    | '/_private/companies/_template/$id/support/$ticket_id'
    | '/_private/contacts/_template/$id/support/$ticket_id'
    | '/_private/settings/job-positions/_template/$id/advertisement'
    | '/_private/settings/job-positions/_template/$id/agreement'
    | '/_private/settings/job-positions/_template/$id/hiring'
    | '/_private/settings/registrars/_template/$id/domains'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  TestRouteRoute: typeof TestRouteRoute
  PrivateRoute: typeof PrivateRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  AuthIndexRoute: typeof AuthIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PrivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test': {
      id: '/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof TestRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/': {
      id: '/auth/'
      path: '/auth'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private/team-members/_template': {
      id: '/_private/team-members/_template'
      path: '/team-members'
      fullPath: '/team-members'
      preLoaderRoute: typeof PrivateTeamMembersTemplateRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/inventory/_template': {
      id: '/_private/inventory/_template'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof PrivateInventoryTemplateRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/contacts/_template': {
      id: '/_private/contacts/_template'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof PrivateContactsTemplateRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/competitors/_template': {
      id: '/_private/competitors/_template'
      path: '/competitors'
      fullPath: '/competitors'
      preLoaderRoute: typeof PrivateCompetitorsTemplateRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/companies/_template': {
      id: '/_private/companies/_template'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof PrivateCompaniesTemplateRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/agreements/_template': {
      id: '/_private/agreements/_template'
      path: '/agreements'
      fullPath: '/agreements'
      preLoaderRoute: typeof PrivateAgreementsTemplateRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/team-members/new': {
      id: '/_private/team-members/new'
      path: '/team-members/new'
      fullPath: '/team-members/new'
      preLoaderRoute: typeof PrivateTeamMembersNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/system-users/$id': {
      id: '/_private/system-users/$id'
      path: '/system-users/$id'
      fullPath: '/system-users/$id'
      preLoaderRoute: typeof PrivateSystemUsersIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/support/$ticket_id': {
      id: '/_private/support/$ticket_id'
      path: '/support/$ticket_id'
      fullPath: '/support/$ticket_id'
      preLoaderRoute: typeof PrivateSupportTicket_idRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/view-logs': {
      id: '/_private/settings/view-logs'
      path: '/settings/view-logs'
      fullPath: '/settings/view-logs'
      preLoaderRoute: typeof PrivateSettingsViewLogsRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/revenue-allocation-lockdown-override-logs': {
      id: '/_private/settings/revenue-allocation-lockdown-override-logs'
      path: '/settings/revenue-allocation-lockdown-override-logs'
      fullPath: '/settings/revenue-allocation-lockdown-override-logs'
      preLoaderRoute: typeof PrivateSettingsRevenueAllocationLockdownOverrideLogsRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/recruiting/new': {
      id: '/_private/recruiting/new'
      path: '/recruiting/new'
      fullPath: '/recruiting/new'
      preLoaderRoute: typeof PrivateRecruitingNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/recruiting/$id': {
      id: '/_private/recruiting/$id'
      path: '/recruiting/$id'
      fullPath: '/recruiting/$id'
      preLoaderRoute: typeof PrivateRecruitingIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/products-and-services/new': {
      id: '/_private/products-and-services/new'
      path: '/products-and-services/new'
      fullPath: '/products-and-services/new'
      preLoaderRoute: typeof PrivateProductsAndServicesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/products-and-services/$id': {
      id: '/_private/products-and-services/$id'
      path: '/products-and-services/$id'
      fullPath: '/products-and-services/$id'
      preLoaderRoute: typeof PrivateProductsAndServicesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/pick-tickets/new': {
      id: '/_private/pick-tickets/new'
      path: '/pick-tickets/new'
      fullPath: '/pick-tickets/new'
      preLoaderRoute: typeof PrivatePickTicketsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/pick-tickets/$id': {
      id: '/_private/pick-tickets/$id'
      path: '/pick-tickets/$id'
      fullPath: '/pick-tickets/$id'
      preLoaderRoute: typeof PrivatePickTicketsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/pending-deposits/$id': {
      id: '/_private/pending-deposits/$id'
      path: '/pending-deposits/$id'
      fullPath: '/pending-deposits/$id'
      preLoaderRoute: typeof PrivatePendingDepositsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/marketing-campaigns/new': {
      id: '/_private/marketing-campaigns/new'
      path: '/marketing-campaigns/new'
      fullPath: '/marketing-campaigns/new'
      preLoaderRoute: typeof PrivateMarketingCampaignsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/marketing-campaigns/$id': {
      id: '/_private/marketing-campaigns/$id'
      path: '/marketing-campaigns/$id'
      fullPath: '/marketing-campaigns/$id'
      preLoaderRoute: typeof PrivateMarketingCampaignsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/invoices/new': {
      id: '/_private/invoices/new'
      path: '/invoices/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof PrivateInvoicesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/invoices/$id': {
      id: '/_private/invoices/$id'
      path: '/invoices/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof PrivateInvoicesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/inventory/parent-new': {
      id: '/_private/inventory/parent-new'
      path: '/inventory/parent-new'
      fullPath: '/inventory/parent-new'
      preLoaderRoute: typeof PrivateInventoryParentNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/inventory/new': {
      id: '/_private/inventory/new'
      path: '/inventory/new'
      fullPath: '/inventory/new'
      preLoaderRoute: typeof PrivateInventoryNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/governance/new': {
      id: '/_private/governance/new'
      path: '/governance/new'
      fullPath: '/governance/new'
      preLoaderRoute: typeof PrivateGovernanceNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/governance/$id': {
      id: '/_private/governance/$id'
      path: '/governance/$id'
      fullPath: '/governance/$id'
      preLoaderRoute: typeof PrivateGovernanceIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/financial-snapshots/new': {
      id: '/_private/financial-snapshots/new'
      path: '/financial-snapshots/new'
      fullPath: '/financial-snapshots/new'
      preLoaderRoute: typeof PrivateFinancialSnapshotsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/financial-snapshots/$id': {
      id: '/_private/financial-snapshots/$id'
      path: '/financial-snapshots/$id'
      fullPath: '/financial-snapshots/$id'
      preLoaderRoute: typeof PrivateFinancialSnapshotsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/domains/new': {
      id: '/_private/domains/new'
      path: '/domains/new'
      fullPath: '/domains/new'
      preLoaderRoute: typeof PrivateDomainsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/domains/$id': {
      id: '/_private/domains/$id'
      path: '/domains/$id'
      fullPath: '/domains/$id'
      preLoaderRoute: typeof PrivateDomainsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/deposits/new': {
      id: '/_private/deposits/new'
      path: '/deposits/new'
      fullPath: '/deposits/new'
      preLoaderRoute: typeof PrivateDepositsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/deposits/$id': {
      id: '/_private/deposits/$id'
      path: '/deposits/$id'
      fullPath: '/deposits/$id'
      preLoaderRoute: typeof PrivateDepositsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/contacts/new': {
      id: '/_private/contacts/new'
      path: '/contacts/new'
      fullPath: '/contacts/new'
      preLoaderRoute: typeof PrivateContactsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/connected-apps/new': {
      id: '/_private/connected-apps/new'
      path: '/connected-apps/new'
      fullPath: '/connected-apps/new'
      preLoaderRoute: typeof PrivateConnectedAppsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/connected-apps/$id': {
      id: '/_private/connected-apps/$id'
      path: '/connected-apps/$id'
      fullPath: '/connected-apps/$id'
      preLoaderRoute: typeof PrivateConnectedAppsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/conferences-and-events/new': {
      id: '/_private/conferences-and-events/new'
      path: '/conferences-and-events/new'
      fullPath: '/conferences-and-events/new'
      preLoaderRoute: typeof PrivateConferencesAndEventsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/conferences-and-events/$id': {
      id: '/_private/conferences-and-events/$id'
      path: '/conferences-and-events/$id'
      fullPath: '/conferences-and-events/$id'
      preLoaderRoute: typeof PrivateConferencesAndEventsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/competitors/new': {
      id: '/_private/competitors/new'
      path: '/competitors/new'
      fullPath: '/competitors/new'
      preLoaderRoute: typeof PrivateCompetitorsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/companies/new': {
      id: '/_private/companies/new'
      path: '/companies/new'
      fullPath: '/companies/new'
      preLoaderRoute: typeof PrivateCompaniesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/awards/new': {
      id: '/_private/awards/new'
      path: '/awards/new'
      fullPath: '/awards/new'
      preLoaderRoute: typeof PrivateAwardsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/awards/$id': {
      id: '/_private/awards/$id'
      path: '/awards/$id'
      fullPath: '/awards/$id'
      preLoaderRoute: typeof PrivateAwardsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/agreements/new': {
      id: '/_private/agreements/new'
      path: '/agreements/new'
      fullPath: '/agreements/new'
      preLoaderRoute: typeof PrivateAgreementsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/account-receivables/new': {
      id: '/_private/account-receivables/new'
      path: '/account-receivables/new'
      fullPath: '/account-receivables/new'
      preLoaderRoute: typeof PrivateAccountReceivablesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/account-receivables/$id': {
      id: '/_private/account-receivables/$id'
      path: '/account-receivables/$id'
      fullPath: '/account-receivables/$id'
      preLoaderRoute: typeof PrivateAccountReceivablesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_public/signup/': {
      id: '/_public/signup/'
      path: '/signup'
      fullPath: '/signup/'
      preLoaderRoute: typeof PublicSignupIndexRouteRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/reset-password/': {
      id: '/_public/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password/'
      preLoaderRoute: typeof PublicResetPasswordIndexRouteRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login/': {
      id: '/_public/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof PublicLoginIndexRouteRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/forgot-password/': {
      id: '/_public/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password/'
      preLoaderRoute: typeof PublicForgotPasswordIndexRouteRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_private/team-members/': {
      id: '/_private/team-members/'
      path: '/team-members'
      fullPath: '/team-members/'
      preLoaderRoute: typeof PrivateTeamMembersIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/system-users/': {
      id: '/_private/system-users/'
      path: '/system-users'
      fullPath: '/system-users/'
      preLoaderRoute: typeof PrivateSystemUsersIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/support/': {
      id: '/_private/support/'
      path: '/support'
      fullPath: '/support/'
      preLoaderRoute: typeof PrivateSupportIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/': {
      id: '/_private/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof PrivateSettingsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/recruiting/': {
      id: '/_private/recruiting/'
      path: '/recruiting'
      fullPath: '/recruiting/'
      preLoaderRoute: typeof PrivateRecruitingIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/products-and-services/': {
      id: '/_private/products-and-services/'
      path: '/products-and-services'
      fullPath: '/products-and-services/'
      preLoaderRoute: typeof PrivateProductsAndServicesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/pick-tickets/': {
      id: '/_private/pick-tickets/'
      path: '/pick-tickets'
      fullPath: '/pick-tickets/'
      preLoaderRoute: typeof PrivatePickTicketsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/media/': {
      id: '/_private/media/'
      path: '/media'
      fullPath: '/media/'
      preLoaderRoute: typeof PrivateMediaIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/marketing-campaigns/': {
      id: '/_private/marketing-campaigns/'
      path: '/marketing-campaigns'
      fullPath: '/marketing-campaigns/'
      preLoaderRoute: typeof PrivateMarketingCampaignsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/invoices/': {
      id: '/_private/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof PrivateInvoicesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/inventory/': {
      id: '/_private/inventory/'
      path: '/inventory'
      fullPath: '/inventory/'
      preLoaderRoute: typeof PrivateInventoryIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/governance/': {
      id: '/_private/governance/'
      path: '/governance'
      fullPath: '/governance/'
      preLoaderRoute: typeof PrivateGovernanceIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/financial-snapshots/': {
      id: '/_private/financial-snapshots/'
      path: '/financial-snapshots'
      fullPath: '/financial-snapshots/'
      preLoaderRoute: typeof PrivateFinancialSnapshotsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/domains/': {
      id: '/_private/domains/'
      path: '/domains'
      fullPath: '/domains/'
      preLoaderRoute: typeof PrivateDomainsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/deposits/': {
      id: '/_private/deposits/'
      path: '/deposits'
      fullPath: '/deposits/'
      preLoaderRoute: typeof PrivateDepositsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/dashboard/': {
      id: '/_private/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof PrivateDashboardIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/contacts/': {
      id: '/_private/contacts/'
      path: '/contacts'
      fullPath: '/contacts/'
      preLoaderRoute: typeof PrivateContactsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/connected-apps/': {
      id: '/_private/connected-apps/'
      path: '/connected-apps'
      fullPath: '/connected-apps/'
      preLoaderRoute: typeof PrivateConnectedAppsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/conferences-and-events/': {
      id: '/_private/conferences-and-events/'
      path: '/conferences-and-events'
      fullPath: '/conferences-and-events/'
      preLoaderRoute: typeof PrivateConferencesAndEventsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/competitors/': {
      id: '/_private/competitors/'
      path: '/competitors'
      fullPath: '/competitors/'
      preLoaderRoute: typeof PrivateCompetitorsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/companies/': {
      id: '/_private/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof PrivateCompaniesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/awards/': {
      id: '/_private/awards/'
      path: '/awards'
      fullPath: '/awards/'
      preLoaderRoute: typeof PrivateAwardsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/agreements/': {
      id: '/_private/agreements/'
      path: '/agreements'
      fullPath: '/agreements/'
      preLoaderRoute: typeof PrivateAgreementsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/account-receivables/': {
      id: '/_private/account-receivables/'
      path: '/account-receivables'
      fullPath: '/account-receivables/'
      preLoaderRoute: typeof PrivateAccountReceivablesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/registrars/_template': {
      id: '/_private/settings/registrars/_template'
      path: '/settings/registrars'
      fullPath: '/settings/registrars'
      preLoaderRoute: typeof PrivateSettingsRegistrarsTemplateRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/job-positions/_template': {
      id: '/_private/settings/job-positions/_template'
      path: '/settings/job-positions'
      fullPath: '/settings/job-positions'
      preLoaderRoute: typeof PrivateSettingsJobPositionsTemplateRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/user-roles/new': {
      id: '/_private/settings/user-roles/new'
      path: '/settings/user-roles/new'
      fullPath: '/settings/user-roles/new'
      preLoaderRoute: typeof PrivateSettingsUserRolesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/user-roles/$id': {
      id: '/_private/settings/user-roles/$id'
      path: '/settings/user-roles/$id'
      fullPath: '/settings/user-roles/$id'
      preLoaderRoute: typeof PrivateSettingsUserRolesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/unit-sell-bys/new': {
      id: '/_private/settings/unit-sell-bys/new'
      path: '/settings/unit-sell-bys/new'
      fullPath: '/settings/unit-sell-bys/new'
      preLoaderRoute: typeof PrivateSettingsUnitSellBysNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/unit-sell-bys/$id': {
      id: '/_private/settings/unit-sell-bys/$id'
      path: '/settings/unit-sell-bys/$id'
      fullPath: '/settings/unit-sell-bys/$id'
      preLoaderRoute: typeof PrivateSettingsUnitSellBysIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/terms-templates/new': {
      id: '/_private/settings/terms-templates/new'
      path: '/settings/terms-templates/new'
      fullPath: '/settings/terms-templates/new'
      preLoaderRoute: typeof PrivateSettingsTermsTemplatesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/terms-templates/$id': {
      id: '/_private/settings/terms-templates/$id'
      path: '/settings/terms-templates/$id'
      fullPath: '/settings/terms-templates/$id'
      preLoaderRoute: typeof PrivateSettingsTermsTemplatesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/terms-conditions/new': {
      id: '/_private/settings/terms-conditions/new'
      path: '/settings/terms-conditions/new'
      fullPath: '/settings/terms-conditions/new'
      preLoaderRoute: typeof PrivateSettingsTermsConditionsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/terms-conditions/$id': {
      id: '/_private/settings/terms-conditions/$id'
      path: '/settings/terms-conditions/$id'
      fullPath: '/settings/terms-conditions/$id'
      preLoaderRoute: typeof PrivateSettingsTermsConditionsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/terms-categories/new': {
      id: '/_private/settings/terms-categories/new'
      path: '/settings/terms-categories/new'
      fullPath: '/settings/terms-categories/new'
      preLoaderRoute: typeof PrivateSettingsTermsCategoriesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/terms-categories/$id': {
      id: '/_private/settings/terms-categories/$id'
      path: '/settings/terms-categories/$id'
      fullPath: '/settings/terms-categories/$id'
      preLoaderRoute: typeof PrivateSettingsTermsCategoriesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/system-files/new': {
      id: '/_private/settings/system-files/new'
      path: '/settings/system-files/new'
      fullPath: '/settings/system-files/new'
      preLoaderRoute: typeof PrivateSettingsSystemFilesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/system-files/$id': {
      id: '/_private/settings/system-files/$id'
      path: '/settings/system-files/$id'
      fullPath: '/settings/system-files/$id'
      preLoaderRoute: typeof PrivateSettingsSystemFilesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/salary-grades/new': {
      id: '/_private/settings/salary-grades/new'
      path: '/settings/salary-grades/new'
      fullPath: '/settings/salary-grades/new'
      preLoaderRoute: typeof PrivateSettingsSalaryGradesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/salary-grades/$id': {
      id: '/_private/settings/salary-grades/$id'
      path: '/settings/salary-grades/$id'
      fullPath: '/settings/salary-grades/$id'
      preLoaderRoute: typeof PrivateSettingsSalaryGradesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/revenue-lockdowns/new': {
      id: '/_private/settings/revenue-lockdowns/new'
      path: '/settings/revenue-lockdowns/new'
      fullPath: '/settings/revenue-lockdowns/new'
      preLoaderRoute: typeof PrivateSettingsRevenueLockdownsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/revenue-lockdowns/$id': {
      id: '/_private/settings/revenue-lockdowns/$id'
      path: '/settings/revenue-lockdowns/$id'
      fullPath: '/settings/revenue-lockdowns/$id'
      preLoaderRoute: typeof PrivateSettingsRevenueLockdownsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/relationship-scores/new': {
      id: '/_private/settings/relationship-scores/new'
      path: '/settings/relationship-scores/new'
      fullPath: '/settings/relationship-scores/new'
      preLoaderRoute: typeof PrivateSettingsRelationshipScoresNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/relationship-scores/$id': {
      id: '/_private/settings/relationship-scores/$id'
      path: '/settings/relationship-scores/$id'
      fullPath: '/settings/relationship-scores/$id'
      preLoaderRoute: typeof PrivateSettingsRelationshipScoresIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/registrars/new': {
      id: '/_private/settings/registrars/new'
      path: '/settings/registrars/new'
      fullPath: '/settings/registrars/new'
      preLoaderRoute: typeof PrivateSettingsRegistrarsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/recruiting-statuses/new': {
      id: '/_private/settings/recruiting-statuses/new'
      path: '/settings/recruiting-statuses/new'
      fullPath: '/settings/recruiting-statuses/new'
      preLoaderRoute: typeof PrivateSettingsRecruitingStatusesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/recruiting-statuses/$id': {
      id: '/_private/settings/recruiting-statuses/$id'
      path: '/settings/recruiting-statuses/$id'
      fullPath: '/settings/recruiting-statuses/$id'
      preLoaderRoute: typeof PrivateSettingsRecruitingStatusesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/recruiting-job-categories/new': {
      id: '/_private/settings/recruiting-job-categories/new'
      path: '/settings/recruiting-job-categories/new'
      fullPath: '/settings/recruiting-job-categories/new'
      preLoaderRoute: typeof PrivateSettingsRecruitingJobCategoriesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/recruiting-job-categories/$id': {
      id: '/_private/settings/recruiting-job-categories/$id'
      path: '/settings/recruiting-job-categories/$id'
      fullPath: '/settings/recruiting-job-categories/$id'
      preLoaderRoute: typeof PrivateSettingsRecruitingJobCategoriesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/recruiting-hiring-criteria-categories/new': {
      id: '/_private/settings/recruiting-hiring-criteria-categories/new'
      path: '/settings/recruiting-hiring-criteria-categories/new'
      fullPath: '/settings/recruiting-hiring-criteria-categories/new'
      preLoaderRoute: typeof PrivateSettingsRecruitingHiringCriteriaCategoriesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/recruiting-hiring-criteria-categories/$id': {
      id: '/_private/settings/recruiting-hiring-criteria-categories/$id'
      path: '/settings/recruiting-hiring-criteria-categories/$id'
      fullPath: '/settings/recruiting-hiring-criteria-categories/$id'
      preLoaderRoute: typeof PrivateSettingsRecruitingHiringCriteriaCategoriesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/products-and-services-templates/new': {
      id: '/_private/settings/products-and-services-templates/new'
      path: '/settings/products-and-services-templates/new'
      fullPath: '/settings/products-and-services-templates/new'
      preLoaderRoute: typeof PrivateSettingsProductsAndServicesTemplatesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/products-and-services-templates/$id': {
      id: '/_private/settings/products-and-services-templates/$id'
      path: '/settings/products-and-services-templates/$id'
      fullPath: '/settings/products-and-services-templates/$id'
      preLoaderRoute: typeof PrivateSettingsProductsAndServicesTemplatesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/price-frequencies/new': {
      id: '/_private/settings/price-frequencies/new'
      path: '/settings/price-frequencies/new'
      fullPath: '/settings/price-frequencies/new'
      preLoaderRoute: typeof PrivateSettingsPriceFrequenciesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/price-frequencies/$id': {
      id: '/_private/settings/price-frequencies/$id'
      path: '/settings/price-frequencies/$id'
      fullPath: '/settings/price-frequencies/$id'
      preLoaderRoute: typeof PrivateSettingsPriceFrequenciesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/preferred-relationships/new': {
      id: '/_private/settings/preferred-relationships/new'
      path: '/settings/preferred-relationships/new'
      fullPath: '/settings/preferred-relationships/new'
      preLoaderRoute: typeof PrivateSettingsPreferredRelationshipsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/preferred-relationships/$id': {
      id: '/_private/settings/preferred-relationships/$id'
      path: '/settings/preferred-relationships/$id'
      fullPath: '/settings/preferred-relationships/$id'
      preLoaderRoute: typeof PrivateSettingsPreferredRelationshipsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/preferred-locations/new': {
      id: '/_private/settings/preferred-locations/new'
      path: '/settings/preferred-locations/new'
      fullPath: '/settings/preferred-locations/new'
      preLoaderRoute: typeof PrivateSettingsPreferredLocationsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/preferred-locations/$id': {
      id: '/_private/settings/preferred-locations/$id'
      path: '/settings/preferred-locations/$id'
      fullPath: '/settings/preferred-locations/$id'
      preLoaderRoute: typeof PrivateSettingsPreferredLocationsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/payment-methods/new': {
      id: '/_private/settings/payment-methods/new'
      path: '/settings/payment-methods/new'
      fullPath: '/settings/payment-methods/new'
      preLoaderRoute: typeof PrivateSettingsPaymentMethodsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/payment-methods/$id': {
      id: '/_private/settings/payment-methods/$id'
      path: '/settings/payment-methods/$id'
      fullPath: '/settings/payment-methods/$id'
      preLoaderRoute: typeof PrivateSettingsPaymentMethodsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/partners/new': {
      id: '/_private/settings/partners/new'
      path: '/settings/partners/new'
      fullPath: '/settings/partners/new'
      preLoaderRoute: typeof PrivateSettingsPartnersNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/partners/$id': {
      id: '/_private/settings/partners/$id'
      path: '/settings/partners/$id'
      fullPath: '/settings/partners/$id'
      preLoaderRoute: typeof PrivateSettingsPartnersIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/organization-types/new': {
      id: '/_private/settings/organization-types/new'
      path: '/settings/organization-types/new'
      fullPath: '/settings/organization-types/new'
      preLoaderRoute: typeof PrivateSettingsOrganizationTypesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/organization-types/$id': {
      id: '/_private/settings/organization-types/$id'
      path: '/settings/organization-types/$id'
      fullPath: '/settings/organization-types/$id'
      preLoaderRoute: typeof PrivateSettingsOrganizationTypesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/mileage-rates/new': {
      id: '/_private/settings/mileage-rates/new'
      path: '/settings/mileage-rates/new'
      fullPath: '/settings/mileage-rates/new'
      preLoaderRoute: typeof PrivateSettingsMileageRatesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/mileage-rates/$id': {
      id: '/_private/settings/mileage-rates/$id'
      path: '/settings/mileage-rates/$id'
      fullPath: '/settings/mileage-rates/$id'
      preLoaderRoute: typeof PrivateSettingsMileageRatesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/manufacturers/new': {
      id: '/_private/settings/manufacturers/new'
      path: '/settings/manufacturers/new'
      fullPath: '/settings/manufacturers/new'
      preLoaderRoute: typeof PrivateSettingsManufacturersNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/manufacturers/$id': {
      id: '/_private/settings/manufacturers/$id'
      path: '/settings/manufacturers/$id'
      fullPath: '/settings/manufacturers/$id'
      preLoaderRoute: typeof PrivateSettingsManufacturersIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/magazines/new': {
      id: '/_private/settings/magazines/new'
      path: '/settings/magazines/new'
      fullPath: '/settings/magazines/new'
      preLoaderRoute: typeof PrivateSettingsMagazinesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/magazines/$id': {
      id: '/_private/settings/magazines/$id'
      path: '/settings/magazines/$id'
      fullPath: '/settings/magazines/$id'
      preLoaderRoute: typeof PrivateSettingsMagazinesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/job-positions/new': {
      id: '/_private/settings/job-positions/new'
      path: '/settings/job-positions/new'
      fullPath: '/settings/job-positions/new'
      preLoaderRoute: typeof PrivateSettingsJobPositionsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-volumes/new': {
      id: '/_private/settings/inventory-volumes/new'
      path: '/settings/inventory-volumes/new'
      fullPath: '/settings/inventory-volumes/new'
      preLoaderRoute: typeof PrivateSettingsInventoryVolumesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-volumes/$id': {
      id: '/_private/settings/inventory-volumes/$id'
      path: '/settings/inventory-volumes/$id'
      fullPath: '/settings/inventory-volumes/$id'
      preLoaderRoute: typeof PrivateSettingsInventoryVolumesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-vendors/new': {
      id: '/_private/settings/inventory-vendors/new'
      path: '/settings/inventory-vendors/new'
      fullPath: '/settings/inventory-vendors/new'
      preLoaderRoute: typeof PrivateSettingsInventoryVendorsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-vendors/$id': {
      id: '/_private/settings/inventory-vendors/$id'
      path: '/settings/inventory-vendors/$id'
      fullPath: '/settings/inventory-vendors/$id'
      preLoaderRoute: typeof PrivateSettingsInventoryVendorsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-stocks/new': {
      id: '/_private/settings/inventory-stocks/new'
      path: '/settings/inventory-stocks/new'
      fullPath: '/settings/inventory-stocks/new'
      preLoaderRoute: typeof PrivateSettingsInventoryStocksNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-stocks/$id': {
      id: '/_private/settings/inventory-stocks/$id'
      path: '/settings/inventory-stocks/$id'
      fullPath: '/settings/inventory-stocks/$id'
      preLoaderRoute: typeof PrivateSettingsInventoryStocksIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-purchases/new': {
      id: '/_private/settings/inventory-purchases/new'
      path: '/settings/inventory-purchases/new'
      fullPath: '/settings/inventory-purchases/new'
      preLoaderRoute: typeof PrivateSettingsInventoryPurchasesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-purchases/$id': {
      id: '/_private/settings/inventory-purchases/$id'
      path: '/settings/inventory-purchases/$id'
      fullPath: '/settings/inventory-purchases/$id'
      preLoaderRoute: typeof PrivateSettingsInventoryPurchasesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-kits/new': {
      id: '/_private/settings/inventory-kits/new'
      path: '/settings/inventory-kits/new'
      fullPath: '/settings/inventory-kits/new'
      preLoaderRoute: typeof PrivateSettingsInventoryKitsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-kits/$id': {
      id: '/_private/settings/inventory-kits/$id'
      path: '/settings/inventory-kits/$id'
      fullPath: '/settings/inventory-kits/$id'
      preLoaderRoute: typeof PrivateSettingsInventoryKitsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-categories/new': {
      id: '/_private/settings/inventory-categories/new'
      path: '/settings/inventory-categories/new'
      fullPath: '/settings/inventory-categories/new'
      preLoaderRoute: typeof PrivateSettingsInventoryCategoriesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-categories/$id': {
      id: '/_private/settings/inventory-categories/$id'
      path: '/settings/inventory-categories/$id'
      fullPath: '/settings/inventory-categories/$id'
      preLoaderRoute: typeof PrivateSettingsInventoryCategoriesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-bin-locations/new': {
      id: '/_private/settings/inventory-bin-locations/new'
      path: '/settings/inventory-bin-locations/new'
      fullPath: '/settings/inventory-bin-locations/new'
      preLoaderRoute: typeof PrivateSettingsInventoryBinLocationsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-bin-locations/$id': {
      id: '/_private/settings/inventory-bin-locations/$id'
      path: '/settings/inventory-bin-locations/$id'
      fullPath: '/settings/inventory-bin-locations/$id'
      preLoaderRoute: typeof PrivateSettingsInventoryBinLocationsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/infrastructures/new': {
      id: '/_private/settings/infrastructures/new'
      path: '/settings/infrastructures/new'
      fullPath: '/settings/infrastructures/new'
      preLoaderRoute: typeof PrivateSettingsInfrastructuresNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/infrastructures/$id': {
      id: '/_private/settings/infrastructures/$id'
      path: '/settings/infrastructures/$id'
      fullPath: '/settings/infrastructures/$id'
      preLoaderRoute: typeof PrivateSettingsInfrastructuresIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/industries/new': {
      id: '/_private/settings/industries/new'
      path: '/settings/industries/new'
      fullPath: '/settings/industries/new'
      preLoaderRoute: typeof PrivateSettingsIndustriesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/industries/$id': {
      id: '/_private/settings/industries/$id'
      path: '/settings/industries/$id'
      fullPath: '/settings/industries/$id'
      preLoaderRoute: typeof PrivateSettingsIndustriesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/email-templates/new': {
      id: '/_private/settings/email-templates/new'
      path: '/settings/email-templates/new'
      fullPath: '/settings/email-templates/new'
      preLoaderRoute: typeof PrivateSettingsEmailTemplatesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/email-templates/$id': {
      id: '/_private/settings/email-templates/$id'
      path: '/settings/email-templates/$id'
      fullPath: '/settings/email-templates/$id'
      preLoaderRoute: typeof PrivateSettingsEmailTemplatesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/email-history/$id': {
      id: '/_private/settings/email-history/$id'
      path: '/settings/email-history/$id'
      fullPath: '/settings/email-history/$id'
      preLoaderRoute: typeof PrivateSettingsEmailHistoryIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/departments/new': {
      id: '/_private/settings/departments/new'
      path: '/settings/departments/new'
      fullPath: '/settings/departments/new'
      preLoaderRoute: typeof PrivateSettingsDepartmentsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/departments/$id': {
      id: '/_private/settings/departments/$id'
      path: '/settings/departments/$id'
      fullPath: '/settings/departments/$id'
      preLoaderRoute: typeof PrivateSettingsDepartmentsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/countries/new': {
      id: '/_private/settings/countries/new'
      path: '/settings/countries/new'
      fullPath: '/settings/countries/new'
      preLoaderRoute: typeof PrivateSettingsCountriesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/countries/$id': {
      id: '/_private/settings/countries/$id'
      path: '/settings/countries/$id'
      fullPath: '/settings/countries/$id'
      preLoaderRoute: typeof PrivateSettingsCountriesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/commission-plans/new': {
      id: '/_private/settings/commission-plans/new'
      path: '/settings/commission-plans/new'
      fullPath: '/settings/commission-plans/new'
      preLoaderRoute: typeof PrivateSettingsCommissionPlansNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/commission-plans/$id': {
      id: '/_private/settings/commission-plans/$id'
      path: '/settings/commission-plans/$id'
      fullPath: '/settings/commission-plans/$id'
      preLoaderRoute: typeof PrivateSettingsCommissionPlansIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/categories/new': {
      id: '/_private/settings/categories/new'
      path: '/settings/categories/new'
      fullPath: '/settings/categories/new'
      preLoaderRoute: typeof PrivateSettingsCategoriesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/categories/$id': {
      id: '/_private/settings/categories/$id'
      path: '/settings/categories/$id'
      fullPath: '/settings/categories/$id'
      preLoaderRoute: typeof PrivateSettingsCategoriesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/business-disciplines/new': {
      id: '/_private/settings/business-disciplines/new'
      path: '/settings/business-disciplines/new'
      fullPath: '/settings/business-disciplines/new'
      preLoaderRoute: typeof PrivateSettingsBusinessDisciplinesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/business-disciplines/$id': {
      id: '/_private/settings/business-disciplines/$id'
      path: '/settings/business-disciplines/$id'
      fullPath: '/settings/business-disciplines/$id'
      preLoaderRoute: typeof PrivateSettingsBusinessDisciplinesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/brands/new': {
      id: '/_private/settings/brands/new'
      path: '/settings/brands/new'
      fullPath: '/settings/brands/new'
      preLoaderRoute: typeof PrivateSettingsBrandsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/brands/$id': {
      id: '/_private/settings/brands/$id'
      path: '/settings/brands/$id'
      fullPath: '/settings/brands/$id'
      preLoaderRoute: typeof PrivateSettingsBrandsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/billing-terms/new': {
      id: '/_private/settings/billing-terms/new'
      path: '/settings/billing-terms/new'
      fullPath: '/settings/billing-terms/new'
      preLoaderRoute: typeof PrivateSettingsBillingTermsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/billing-terms/$id': {
      id: '/_private/settings/billing-terms/$id'
      path: '/settings/billing-terms/$id'
      fullPath: '/settings/billing-terms/$id'
      preLoaderRoute: typeof PrivateSettingsBillingTermsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/billing-systems/new': {
      id: '/_private/settings/billing-systems/new'
      path: '/settings/billing-systems/new'
      fullPath: '/settings/billing-systems/new'
      preLoaderRoute: typeof PrivateSettingsBillingSystemsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/billing-systems/$id': {
      id: '/_private/settings/billing-systems/$id'
      path: '/settings/billing-systems/$id'
      fullPath: '/settings/billing-systems/$id'
      preLoaderRoute: typeof PrivateSettingsBillingSystemsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/bank-accounts/new': {
      id: '/_private/settings/bank-accounts/new'
      path: '/settings/bank-accounts/new'
      fullPath: '/settings/bank-accounts/new'
      preLoaderRoute: typeof PrivateSettingsBankAccountsNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/bank-accounts/$id': {
      id: '/_private/settings/bank-accounts/$id'
      path: '/settings/bank-accounts/$id'
      fullPath: '/settings/bank-accounts/$id'
      preLoaderRoute: typeof PrivateSettingsBankAccountsIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/audiences/new': {
      id: '/_private/settings/audiences/new'
      path: '/settings/audiences/new'
      fullPath: '/settings/audiences/new'
      preLoaderRoute: typeof PrivateSettingsAudiencesNewRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/audiences/$id': {
      id: '/_private/settings/audiences/$id'
      path: '/settings/audiences/$id'
      fullPath: '/settings/audiences/$id'
      preLoaderRoute: typeof PrivateSettingsAudiencesIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/invoices/invoice-batch/$id': {
      id: '/_private/invoices/invoice-batch/$id'
      path: '/invoices/invoice-batch/$id'
      fullPath: '/invoices/invoice-batch/$id'
      preLoaderRoute: typeof PrivateInvoicesInvoiceBatchIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/inventory/parent/$id': {
      id: '/_private/inventory/parent/$id'
      path: '/inventory/parent/$id'
      fullPath: '/inventory/parent/$id'
      preLoaderRoute: typeof PrivateInventoryParentIdRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/user-roles/': {
      id: '/_private/settings/user-roles/'
      path: '/settings/user-roles'
      fullPath: '/settings/user-roles/'
      preLoaderRoute: typeof PrivateSettingsUserRolesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/unit-sell-bys/': {
      id: '/_private/settings/unit-sell-bys/'
      path: '/settings/unit-sell-bys'
      fullPath: '/settings/unit-sell-bys/'
      preLoaderRoute: typeof PrivateSettingsUnitSellBysIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/terms-templates/': {
      id: '/_private/settings/terms-templates/'
      path: '/settings/terms-templates'
      fullPath: '/settings/terms-templates/'
      preLoaderRoute: typeof PrivateSettingsTermsTemplatesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/terms-conditions/': {
      id: '/_private/settings/terms-conditions/'
      path: '/settings/terms-conditions'
      fullPath: '/settings/terms-conditions/'
      preLoaderRoute: typeof PrivateSettingsTermsConditionsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/terms-categories/': {
      id: '/_private/settings/terms-categories/'
      path: '/settings/terms-categories'
      fullPath: '/settings/terms-categories/'
      preLoaderRoute: typeof PrivateSettingsTermsCategoriesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/system-files/': {
      id: '/_private/settings/system-files/'
      path: '/settings/system-files'
      fullPath: '/settings/system-files/'
      preLoaderRoute: typeof PrivateSettingsSystemFilesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/salary-grades/': {
      id: '/_private/settings/salary-grades/'
      path: '/settings/salary-grades'
      fullPath: '/settings/salary-grades/'
      preLoaderRoute: typeof PrivateSettingsSalaryGradesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/revenue-lockdowns/': {
      id: '/_private/settings/revenue-lockdowns/'
      path: '/settings/revenue-lockdowns'
      fullPath: '/settings/revenue-lockdowns/'
      preLoaderRoute: typeof PrivateSettingsRevenueLockdownsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/relationship-scores/': {
      id: '/_private/settings/relationship-scores/'
      path: '/settings/relationship-scores'
      fullPath: '/settings/relationship-scores/'
      preLoaderRoute: typeof PrivateSettingsRelationshipScoresIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/registrars/': {
      id: '/_private/settings/registrars/'
      path: '/settings/registrars'
      fullPath: '/settings/registrars/'
      preLoaderRoute: typeof PrivateSettingsRegistrarsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/recruiting-statuses/': {
      id: '/_private/settings/recruiting-statuses/'
      path: '/settings/recruiting-statuses'
      fullPath: '/settings/recruiting-statuses/'
      preLoaderRoute: typeof PrivateSettingsRecruitingStatusesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/recruiting-job-categories/': {
      id: '/_private/settings/recruiting-job-categories/'
      path: '/settings/recruiting-job-categories'
      fullPath: '/settings/recruiting-job-categories/'
      preLoaderRoute: typeof PrivateSettingsRecruitingJobCategoriesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/recruiting-hiring-criteria-categories/': {
      id: '/_private/settings/recruiting-hiring-criteria-categories/'
      path: '/settings/recruiting-hiring-criteria-categories'
      fullPath: '/settings/recruiting-hiring-criteria-categories/'
      preLoaderRoute: typeof PrivateSettingsRecruitingHiringCriteriaCategoriesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/products-and-services-templates/': {
      id: '/_private/settings/products-and-services-templates/'
      path: '/settings/products-and-services-templates'
      fullPath: '/settings/products-and-services-templates/'
      preLoaderRoute: typeof PrivateSettingsProductsAndServicesTemplatesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/price-frequencies/': {
      id: '/_private/settings/price-frequencies/'
      path: '/settings/price-frequencies'
      fullPath: '/settings/price-frequencies/'
      preLoaderRoute: typeof PrivateSettingsPriceFrequenciesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/preferred-relationships/': {
      id: '/_private/settings/preferred-relationships/'
      path: '/settings/preferred-relationships'
      fullPath: '/settings/preferred-relationships/'
      preLoaderRoute: typeof PrivateSettingsPreferredRelationshipsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/preferred-locations/': {
      id: '/_private/settings/preferred-locations/'
      path: '/settings/preferred-locations'
      fullPath: '/settings/preferred-locations/'
      preLoaderRoute: typeof PrivateSettingsPreferredLocationsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/payment-methods/': {
      id: '/_private/settings/payment-methods/'
      path: '/settings/payment-methods'
      fullPath: '/settings/payment-methods/'
      preLoaderRoute: typeof PrivateSettingsPaymentMethodsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/partners/': {
      id: '/_private/settings/partners/'
      path: '/settings/partners'
      fullPath: '/settings/partners/'
      preLoaderRoute: typeof PrivateSettingsPartnersIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/organization-types/': {
      id: '/_private/settings/organization-types/'
      path: '/settings/organization-types'
      fullPath: '/settings/organization-types/'
      preLoaderRoute: typeof PrivateSettingsOrganizationTypesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/mileage-rates/': {
      id: '/_private/settings/mileage-rates/'
      path: '/settings/mileage-rates'
      fullPath: '/settings/mileage-rates/'
      preLoaderRoute: typeof PrivateSettingsMileageRatesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/manufacturers/': {
      id: '/_private/settings/manufacturers/'
      path: '/settings/manufacturers'
      fullPath: '/settings/manufacturers/'
      preLoaderRoute: typeof PrivateSettingsManufacturersIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/magazines/': {
      id: '/_private/settings/magazines/'
      path: '/settings/magazines'
      fullPath: '/settings/magazines/'
      preLoaderRoute: typeof PrivateSettingsMagazinesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/job-positions/': {
      id: '/_private/settings/job-positions/'
      path: '/settings/job-positions'
      fullPath: '/settings/job-positions/'
      preLoaderRoute: typeof PrivateSettingsJobPositionsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-volumes/': {
      id: '/_private/settings/inventory-volumes/'
      path: '/settings/inventory-volumes'
      fullPath: '/settings/inventory-volumes/'
      preLoaderRoute: typeof PrivateSettingsInventoryVolumesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-vendors/': {
      id: '/_private/settings/inventory-vendors/'
      path: '/settings/inventory-vendors'
      fullPath: '/settings/inventory-vendors/'
      preLoaderRoute: typeof PrivateSettingsInventoryVendorsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-stocks/': {
      id: '/_private/settings/inventory-stocks/'
      path: '/settings/inventory-stocks'
      fullPath: '/settings/inventory-stocks/'
      preLoaderRoute: typeof PrivateSettingsInventoryStocksIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-purchases/': {
      id: '/_private/settings/inventory-purchases/'
      path: '/settings/inventory-purchases'
      fullPath: '/settings/inventory-purchases/'
      preLoaderRoute: typeof PrivateSettingsInventoryPurchasesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-kits/': {
      id: '/_private/settings/inventory-kits/'
      path: '/settings/inventory-kits'
      fullPath: '/settings/inventory-kits/'
      preLoaderRoute: typeof PrivateSettingsInventoryKitsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-categories/': {
      id: '/_private/settings/inventory-categories/'
      path: '/settings/inventory-categories'
      fullPath: '/settings/inventory-categories/'
      preLoaderRoute: typeof PrivateSettingsInventoryCategoriesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/inventory-bin-locations/': {
      id: '/_private/settings/inventory-bin-locations/'
      path: '/settings/inventory-bin-locations'
      fullPath: '/settings/inventory-bin-locations/'
      preLoaderRoute: typeof PrivateSettingsInventoryBinLocationsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/infrastructures/': {
      id: '/_private/settings/infrastructures/'
      path: '/settings/infrastructures'
      fullPath: '/settings/infrastructures/'
      preLoaderRoute: typeof PrivateSettingsInfrastructuresIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/industries/': {
      id: '/_private/settings/industries/'
      path: '/settings/industries'
      fullPath: '/settings/industries/'
      preLoaderRoute: typeof PrivateSettingsIndustriesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/email-templates/': {
      id: '/_private/settings/email-templates/'
      path: '/settings/email-templates'
      fullPath: '/settings/email-templates/'
      preLoaderRoute: typeof PrivateSettingsEmailTemplatesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/email-template-defaults/': {
      id: '/_private/settings/email-template-defaults/'
      path: '/settings/email-template-defaults'
      fullPath: '/settings/email-template-defaults/'
      preLoaderRoute: typeof PrivateSettingsEmailTemplateDefaultsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/email-history/': {
      id: '/_private/settings/email-history/'
      path: '/settings/email-history'
      fullPath: '/settings/email-history/'
      preLoaderRoute: typeof PrivateSettingsEmailHistoryIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/departments/': {
      id: '/_private/settings/departments/'
      path: '/settings/departments'
      fullPath: '/settings/departments/'
      preLoaderRoute: typeof PrivateSettingsDepartmentsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/countries/': {
      id: '/_private/settings/countries/'
      path: '/settings/countries'
      fullPath: '/settings/countries/'
      preLoaderRoute: typeof PrivateSettingsCountriesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/commission-plans/': {
      id: '/_private/settings/commission-plans/'
      path: '/settings/commission-plans'
      fullPath: '/settings/commission-plans/'
      preLoaderRoute: typeof PrivateSettingsCommissionPlansIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/categories/': {
      id: '/_private/settings/categories/'
      path: '/settings/categories'
      fullPath: '/settings/categories/'
      preLoaderRoute: typeof PrivateSettingsCategoriesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/business-disciplines/': {
      id: '/_private/settings/business-disciplines/'
      path: '/settings/business-disciplines'
      fullPath: '/settings/business-disciplines/'
      preLoaderRoute: typeof PrivateSettingsBusinessDisciplinesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/brands/': {
      id: '/_private/settings/brands/'
      path: '/settings/brands'
      fullPath: '/settings/brands/'
      preLoaderRoute: typeof PrivateSettingsBrandsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/billing-terms/': {
      id: '/_private/settings/billing-terms/'
      path: '/settings/billing-terms'
      fullPath: '/settings/billing-terms/'
      preLoaderRoute: typeof PrivateSettingsBillingTermsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/billing-systems/': {
      id: '/_private/settings/billing-systems/'
      path: '/settings/billing-systems'
      fullPath: '/settings/billing-systems/'
      preLoaderRoute: typeof PrivateSettingsBillingSystemsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/bank-accounts/': {
      id: '/_private/settings/bank-accounts/'
      path: '/settings/bank-accounts'
      fullPath: '/settings/bank-accounts/'
      preLoaderRoute: typeof PrivateSettingsBankAccountsIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings/audiences/': {
      id: '/_private/settings/audiences/'
      path: '/settings/audiences'
      fullPath: '/settings/audiences/'
      preLoaderRoute: typeof PrivateSettingsAudiencesIndexRouteRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/team-members/_template/$id/preference': {
      id: '/_private/team-members/_template/$id/preference'
      path: '/$id/preference'
      fullPath: '/team-members/$id/preference'
      preLoaderRoute: typeof PrivateTeamMembersTemplateIdPreferenceRouteRouteImport
      parentRoute: typeof PrivateTeamMembersTemplateRoute
    }
    '/_private/team-members/_template/$id/personal-details': {
      id: '/_private/team-members/_template/$id/personal-details'
      path: '/$id/personal-details'
      fullPath: '/team-members/$id/personal-details'
      preLoaderRoute: typeof PrivateTeamMembersTemplateIdPersonalDetailsRouteRouteImport
      parentRoute: typeof PrivateTeamMembersTemplateRoute
    }
    '/_private/team-members/_template/$id/marketing': {
      id: '/_private/team-members/_template/$id/marketing'
      path: '/$id/marketing'
      fullPath: '/team-members/$id/marketing'
      preLoaderRoute: typeof PrivateTeamMembersTemplateIdMarketingRouteRouteImport
      parentRoute: typeof PrivateTeamMembersTemplateRoute
    }
    '/_private/team-members/_template/$id/emergency': {
      id: '/_private/team-members/_template/$id/emergency'
      path: '/$id/emergency'
      fullPath: '/team-members/$id/emergency'
      preLoaderRoute: typeof PrivateTeamMembersTemplateIdEmergencyRouteRouteImport
      parentRoute: typeof PrivateTeamMembersTemplateRoute
    }
    '/_private/team-members/_template/$id/commission-periods': {
      id: '/_private/team-members/_template/$id/commission-periods'
      path: '/$id/commission-periods'
      fullPath: '/team-members/$id/commission-periods'
      preLoaderRoute: typeof PrivateTeamMembersTemplateIdCommissionPeriodsRouteRouteImport
      parentRoute: typeof PrivateTeamMembersTemplateRoute
    }
    '/_private/team-members/_template/$id/api-integration': {
      id: '/_private/team-members/_template/$id/api-integration'
      path: '/$id/api-integration'
      fullPath: '/team-members/$id/api-integration'
      preLoaderRoute: typeof PrivateTeamMembersTemplateIdApiIntegrationRouteRouteImport
      parentRoute: typeof PrivateTeamMembersTemplateRoute
    }
    '/_private/inventory/_template/$id/vendors': {
      id: '/_private/inventory/_template/$id/vendors'
      path: '/$id/vendors'
      fullPath: '/inventory/$id/vendors'
      preLoaderRoute: typeof PrivateInventoryTemplateIdVendorsRouteRouteImport
      parentRoute: typeof PrivateInventoryTemplateRoute
    }
    '/_private/contacts/_template/$id/notes': {
      id: '/_private/contacts/_template/$id/notes'
      path: '/$id/notes'
      fullPath: '/contacts/$id/notes'
      preLoaderRoute: typeof PrivateContactsTemplateIdNotesRouteRouteImport
      parentRoute: typeof PrivateContactsTemplateRoute
    }
    '/_private/contacts/_template/$id/marketing-campaigns': {
      id: '/_private/contacts/_template/$id/marketing-campaigns'
      path: '/$id/marketing-campaigns'
      fullPath: '/contacts/$id/marketing-campaigns'
      preLoaderRoute: typeof PrivateContactsTemplateIdMarketingCampaignsRouteRouteImport
      parentRoute: typeof PrivateContactsTemplateRoute
    }
    '/_private/contacts/_template/$id/api-integration': {
      id: '/_private/contacts/_template/$id/api-integration'
      path: '/$id/api-integration'
      fullPath: '/contacts/$id/api-integration'
      preLoaderRoute: typeof PrivateContactsTemplateIdApiIntegrationRouteRouteImport
      parentRoute: typeof PrivateContactsTemplateRoute
    }
    '/_private/contacts/_template/$id/agreements': {
      id: '/_private/contacts/_template/$id/agreements'
      path: '/$id/agreements'
      fullPath: '/contacts/$id/agreements'
      preLoaderRoute: typeof PrivateContactsTemplateIdAgreementsRouteRouteImport
      parentRoute: typeof PrivateContactsTemplateRoute
    }
    '/_private/competitors/_template/$id/notes': {
      id: '/_private/competitors/_template/$id/notes'
      path: '/$id/notes'
      fullPath: '/competitors/$id/notes'
      preLoaderRoute: typeof PrivateCompetitorsTemplateIdNotesRouteRouteImport
      parentRoute: typeof PrivateCompetitorsTemplateRoute
    }
    '/_private/competitors/_template/$id/contacts': {
      id: '/_private/competitors/_template/$id/contacts'
      path: '/$id/contacts'
      fullPath: '/competitors/$id/contacts'
      preLoaderRoute: typeof PrivateCompetitorsTemplateIdContactsRouteRouteImport
      parentRoute: typeof PrivateCompetitorsTemplateRoute
    }
    '/_private/competitors/_template/$id/associated-companies': {
      id: '/_private/competitors/_template/$id/associated-companies'
      path: '/$id/associated-companies'
      fullPath: '/competitors/$id/associated-companies'
      preLoaderRoute: typeof PrivateCompetitorsTemplateIdAssociatedCompaniesRouteRouteImport
      parentRoute: typeof PrivateCompetitorsTemplateRoute
    }
    '/_private/companies/_template/$id/subscriptions': {
      id: '/_private/companies/_template/$id/subscriptions'
      path: '/$id/subscriptions'
      fullPath: '/companies/$id/subscriptions'
      preLoaderRoute: typeof PrivateCompaniesTemplateIdSubscriptionsRouteRouteImport
      parentRoute: typeof PrivateCompaniesTemplateRoute
    }
    '/_private/companies/_template/$id/notes': {
      id: '/_private/companies/_template/$id/notes'
      path: '/$id/notes'
      fullPath: '/companies/$id/notes'
      preLoaderRoute: typeof PrivateCompaniesTemplateIdNotesRouteRouteImport
      parentRoute: typeof PrivateCompaniesTemplateRoute
    }
    '/_private/companies/_template/$id/marketing-campaigns': {
      id: '/_private/companies/_template/$id/marketing-campaigns'
      path: '/$id/marketing-campaigns'
      fullPath: '/companies/$id/marketing-campaigns'
      preLoaderRoute: typeof PrivateCompaniesTemplateIdMarketingCampaignsRouteRouteImport
      parentRoute: typeof PrivateCompaniesTemplateRoute
    }
    '/_private/companies/_template/$id/invoice-history': {
      id: '/_private/companies/_template/$id/invoice-history'
      path: '/$id/invoice-history'
      fullPath: '/companies/$id/invoice-history'
      preLoaderRoute: typeof PrivateCompaniesTemplateIdInvoiceHistoryRouteRouteImport
      parentRoute: typeof PrivateCompaniesTemplateRoute
    }
    '/_private/companies/_template/$id/financials': {
      id: '/_private/companies/_template/$id/financials'
      path: '/$id/financials'
      fullPath: '/companies/$id/financials'
      preLoaderRoute: typeof PrivateCompaniesTemplateIdFinancialsRouteRouteImport
      parentRoute: typeof PrivateCompaniesTemplateRoute
    }
    '/_private/companies/_template/$id/domains': {
      id: '/_private/companies/_template/$id/domains'
      path: '/$id/domains'
      fullPath: '/companies/$id/domains'
      preLoaderRoute: typeof PrivateCompaniesTemplateIdDomainsRouteRouteImport
      parentRoute: typeof PrivateCompaniesTemplateRoute
    }
    '/_private/companies/_template/$id/contacts': {
      id: '/_private/companies/_template/$id/contacts'
      path: '/$id/contacts'
      fullPath: '/companies/$id/contacts'
      preLoaderRoute: typeof PrivateCompaniesTemplateIdContactsRouteRouteImport
      parentRoute: typeof PrivateCompaniesTemplateRoute
    }
    '/_private/companies/_template/$id/api-integration': {
      id: '/_private/companies/_template/$id/api-integration'
      path: '/$id/api-integration'
      fullPath: '/companies/$id/api-integration'
      preLoaderRoute: typeof PrivateCompaniesTemplateIdApiIntegrationRouteRouteImport
      parentRoute: typeof PrivateCompaniesTemplateRoute
    }
    '/_private/companies/_template/$id/agreements': {
      id: '/_private/companies/_template/$id/agreements'
      path: '/$id/agreements'
      fullPath: '/companies/$id/agreements'
      preLoaderRoute: typeof PrivateCompaniesTemplateIdAgreementsRouteRouteImport
      parentRoute: typeof PrivateCompaniesTemplateRoute
    }
    '/_private/agreements/_template/$id/subsidies': {
      id: '/_private/agreements/_template/$id/subsidies'
      path: '/$id/subsidies'
      fullPath: '/agreements/$id/subsidies'
      preLoaderRoute: typeof PrivateAgreementsTemplateIdSubsidiesRouteRouteImport
      parentRoute: typeof PrivateAgreementsTemplateRoute
    }
    '/_private/agreements/_template/$id/paperwork': {
      id: '/_private/agreements/_template/$id/paperwork'
      path: '/$id/paperwork'
      fullPath: '/agreements/$id/paperwork'
      preLoaderRoute: typeof PrivateAgreementsTemplateIdPaperworkRouteRouteImport
      parentRoute: typeof PrivateAgreementsTemplateRoute
    }
    '/_private/agreements/_template/$id/financial-override': {
      id: '/_private/agreements/_template/$id/financial-override'
      path: '/$id/financial-override'
      fullPath: '/agreements/$id/financial-override'
      preLoaderRoute: typeof PrivateAgreementsTemplateIdFinancialOverrideRouteRouteImport
      parentRoute: typeof PrivateAgreementsTemplateRoute
    }
    '/_private/agreements/_template/$id/execution': {
      id: '/_private/agreements/_template/$id/execution'
      path: '/$id/execution'
      fullPath: '/agreements/$id/execution'
      preLoaderRoute: typeof PrivateAgreementsTemplateIdExecutionRouteRouteImport
      parentRoute: typeof PrivateAgreementsTemplateRoute
    }
    '/_private/agreements/_template/$id/deliverables': {
      id: '/_private/agreements/_template/$id/deliverables'
      path: '/$id/deliverables'
      fullPath: '/agreements/$id/deliverables'
      preLoaderRoute: typeof PrivateAgreementsTemplateIdDeliverablesRouteRouteImport
      parentRoute: typeof PrivateAgreementsTemplateRoute
    }
    '/_private/agreements/_template/$id/commission': {
      id: '/_private/agreements/_template/$id/commission'
      path: '/$id/commission'
      fullPath: '/agreements/$id/commission'
      preLoaderRoute: typeof PrivateAgreementsTemplateIdCommissionRouteRouteImport
      parentRoute: typeof PrivateAgreementsTemplateRoute
    }
    '/_private/agreements/_template/$id/api-integration': {
      id: '/_private/agreements/_template/$id/api-integration'
      path: '/$id/api-integration'
      fullPath: '/agreements/$id/api-integration'
      preLoaderRoute: typeof PrivateAgreementsTemplateIdApiIntegrationRouteRouteImport
      parentRoute: typeof PrivateAgreementsTemplateRoute
    }
    '/_private/agreements/_template/$id/addendum': {
      id: '/_private/agreements/_template/$id/addendum'
      path: '/$id/addendum'
      fullPath: '/agreements/$id/addendum'
      preLoaderRoute: typeof PrivateAgreementsTemplateIdAddendumRouteRouteImport
      parentRoute: typeof PrivateAgreementsTemplateRoute
    }
    '/_private/team-members/_template/$id/': {
      id: '/_private/team-members/_template/$id/'
      path: '/$id'
      fullPath: '/team-members/$id/'
      preLoaderRoute: typeof PrivateTeamMembersTemplateIdIndexRouteRouteImport
      parentRoute: typeof PrivateTeamMembersTemplateRoute
    }
    '/_private/inventory/_template/$id/': {
      id: '/_private/inventory/_template/$id/'
      path: '/$id'
      fullPath: '/inventory/$id/'
      preLoaderRoute: typeof PrivateInventoryTemplateIdIndexRouteRouteImport
      parentRoute: typeof PrivateInventoryTemplateRoute
    }
    '/_private/contacts/_template/$id/': {
      id: '/_private/contacts/_template/$id/'
      path: '/$id'
      fullPath: '/contacts/$id/'
      preLoaderRoute: typeof PrivateContactsTemplateIdIndexRouteRouteImport
      parentRoute: typeof PrivateContactsTemplateRoute
    }
    '/_private/competitors/_template/$id/': {
      id: '/_private/competitors/_template/$id/'
      path: '/$id'
      fullPath: '/competitors/$id/'
      preLoaderRoute: typeof PrivateCompetitorsTemplateIdIndexRouteRouteImport
      parentRoute: typeof PrivateCompetitorsTemplateRoute
    }
    '/_private/companies/_template/$id/': {
      id: '/_private/companies/_template/$id/'
      path: '/$id'
      fullPath: '/companies/$id/'
      preLoaderRoute: typeof PrivateCompaniesTemplateIdIndexRouteRouteImport
      parentRoute: typeof PrivateCompaniesTemplateRoute
    }
    '/_private/agreements/_template/$id/': {
      id: '/_private/agreements/_template/$id/'
      path: '/$id'
      fullPath: '/agreements/$id/'
      preLoaderRoute: typeof PrivateAgreementsTemplateIdIndexRouteRouteImport
      parentRoute: typeof PrivateAgreementsTemplateRoute
    }
    '/_private/settings/registrars/_template/$id/domains': {
      id: '/_private/settings/registrars/_template/$id/domains'
      path: '/$id/domains'
      fullPath: '/settings/registrars/$id/domains'
      preLoaderRoute: typeof PrivateSettingsRegistrarsTemplateIdDomainsRouteRouteImport
      parentRoute: typeof PrivateSettingsRegistrarsTemplateRoute
    }
    '/_private/settings/job-positions/_template/$id/hiring': {
      id: '/_private/settings/job-positions/_template/$id/hiring'
      path: '/$id/hiring'
      fullPath: '/settings/job-positions/$id/hiring'
      preLoaderRoute: typeof PrivateSettingsJobPositionsTemplateIdHiringRouteRouteImport
      parentRoute: typeof PrivateSettingsJobPositionsTemplateRoute
    }
    '/_private/settings/job-positions/_template/$id/agreement': {
      id: '/_private/settings/job-positions/_template/$id/agreement'
      path: '/$id/agreement'
      fullPath: '/settings/job-positions/$id/agreement'
      preLoaderRoute: typeof PrivateSettingsJobPositionsTemplateIdAgreementRouteRouteImport
      parentRoute: typeof PrivateSettingsJobPositionsTemplateRoute
    }
    '/_private/settings/job-positions/_template/$id/advertisement': {
      id: '/_private/settings/job-positions/_template/$id/advertisement'
      path: '/$id/advertisement'
      fullPath: '/settings/job-positions/$id/advertisement'
      preLoaderRoute: typeof PrivateSettingsJobPositionsTemplateIdAdvertisementRouteRouteImport
      parentRoute: typeof PrivateSettingsJobPositionsTemplateRoute
    }
    '/_private/contacts/_template/$id/support/$ticket_id': {
      id: '/_private/contacts/_template/$id/support/$ticket_id'
      path: '/$id/support/$ticket_id'
      fullPath: '/contacts/$id/support/$ticket_id'
      preLoaderRoute: typeof PrivateContactsTemplateIdSupportTicket_idRouteRouteImport
      parentRoute: typeof PrivateContactsTemplateRoute
    }
    '/_private/companies/_template/$id/support/$ticket_id': {
      id: '/_private/companies/_template/$id/support/$ticket_id'
      path: '/$id/support/$ticket_id'
      fullPath: '/companies/$id/support/$ticket_id'
      preLoaderRoute: typeof PrivateCompaniesTemplateIdSupportTicket_idRouteRouteImport
      parentRoute: typeof PrivateCompaniesTemplateRoute
    }
    '/_private/settings/registrars/_template/$id/': {
      id: '/_private/settings/registrars/_template/$id/'
      path: '/$id'
      fullPath: '/settings/registrars/$id/'
      preLoaderRoute: typeof PrivateSettingsRegistrarsTemplateIdIndexRouteRouteImport
      parentRoute: typeof PrivateSettingsRegistrarsTemplateRoute
    }
    '/_private/settings/job-positions/_template/$id/': {
      id: '/_private/settings/job-positions/_template/$id/'
      path: '/$id'
      fullPath: '/settings/job-positions/$id/'
      preLoaderRoute: typeof PrivateSettingsJobPositionsTemplateIdIndexRouteRouteImport
      parentRoute: typeof PrivateSettingsJobPositionsTemplateRoute
    }
    '/_private/contacts/_template/$id/support/': {
      id: '/_private/contacts/_template/$id/support/'
      path: '/$id/support'
      fullPath: '/contacts/$id/support/'
      preLoaderRoute: typeof PrivateContactsTemplateIdSupportIndexRouteRouteImport
      parentRoute: typeof PrivateContactsTemplateRoute
    }
    '/_private/companies/_template/$id/support/': {
      id: '/_private/companies/_template/$id/support/'
      path: '/$id/support'
      fullPath: '/companies/$id/support/'
      preLoaderRoute: typeof PrivateCompaniesTemplateIdSupportIndexRouteRouteImport
      parentRoute: typeof PrivateCompaniesTemplateRoute
    }
  }
}

interface PrivateAgreementsTemplateRouteChildren {
  PrivateAgreementsTemplateIdIndexRouteRoute: typeof PrivateAgreementsTemplateIdIndexRouteRoute
  PrivateAgreementsTemplateIdAddendumRouteRoute: typeof PrivateAgreementsTemplateIdAddendumRouteRoute
  PrivateAgreementsTemplateIdApiIntegrationRouteRoute: typeof PrivateAgreementsTemplateIdApiIntegrationRouteRoute
  PrivateAgreementsTemplateIdCommissionRouteRoute: typeof PrivateAgreementsTemplateIdCommissionRouteRoute
  PrivateAgreementsTemplateIdDeliverablesRouteRoute: typeof PrivateAgreementsTemplateIdDeliverablesRouteRoute
  PrivateAgreementsTemplateIdExecutionRouteRoute: typeof PrivateAgreementsTemplateIdExecutionRouteRoute
  PrivateAgreementsTemplateIdFinancialOverrideRouteRoute: typeof PrivateAgreementsTemplateIdFinancialOverrideRouteRoute
  PrivateAgreementsTemplateIdPaperworkRouteRoute: typeof PrivateAgreementsTemplateIdPaperworkRouteRoute
  PrivateAgreementsTemplateIdSubsidiesRouteRoute: typeof PrivateAgreementsTemplateIdSubsidiesRouteRoute
}

const PrivateAgreementsTemplateRouteChildren: PrivateAgreementsTemplateRouteChildren =
  {
    PrivateAgreementsTemplateIdIndexRouteRoute:
      PrivateAgreementsTemplateIdIndexRouteRoute,
    PrivateAgreementsTemplateIdAddendumRouteRoute:
      PrivateAgreementsTemplateIdAddendumRouteRoute,
    PrivateAgreementsTemplateIdApiIntegrationRouteRoute:
      PrivateAgreementsTemplateIdApiIntegrationRouteRoute,
    PrivateAgreementsTemplateIdCommissionRouteRoute:
      PrivateAgreementsTemplateIdCommissionRouteRoute,
    PrivateAgreementsTemplateIdDeliverablesRouteRoute:
      PrivateAgreementsTemplateIdDeliverablesRouteRoute,
    PrivateAgreementsTemplateIdExecutionRouteRoute:
      PrivateAgreementsTemplateIdExecutionRouteRoute,
    PrivateAgreementsTemplateIdFinancialOverrideRouteRoute:
      PrivateAgreementsTemplateIdFinancialOverrideRouteRoute,
    PrivateAgreementsTemplateIdPaperworkRouteRoute:
      PrivateAgreementsTemplateIdPaperworkRouteRoute,
    PrivateAgreementsTemplateIdSubsidiesRouteRoute:
      PrivateAgreementsTemplateIdSubsidiesRouteRoute,
  }

const PrivateAgreementsTemplateRouteWithChildren =
  PrivateAgreementsTemplateRoute._addFileChildren(
    PrivateAgreementsTemplateRouteChildren,
  )

interface PrivateCompaniesTemplateRouteChildren {
  PrivateCompaniesTemplateIdIndexRouteRoute: typeof PrivateCompaniesTemplateIdIndexRouteRoute
  PrivateCompaniesTemplateIdAgreementsRouteRoute: typeof PrivateCompaniesTemplateIdAgreementsRouteRoute
  PrivateCompaniesTemplateIdApiIntegrationRouteRoute: typeof PrivateCompaniesTemplateIdApiIntegrationRouteRoute
  PrivateCompaniesTemplateIdContactsRouteRoute: typeof PrivateCompaniesTemplateIdContactsRouteRoute
  PrivateCompaniesTemplateIdDomainsRouteRoute: typeof PrivateCompaniesTemplateIdDomainsRouteRoute
  PrivateCompaniesTemplateIdFinancialsRouteRoute: typeof PrivateCompaniesTemplateIdFinancialsRouteRoute
  PrivateCompaniesTemplateIdInvoiceHistoryRouteRoute: typeof PrivateCompaniesTemplateIdInvoiceHistoryRouteRoute
  PrivateCompaniesTemplateIdMarketingCampaignsRouteRoute: typeof PrivateCompaniesTemplateIdMarketingCampaignsRouteRoute
  PrivateCompaniesTemplateIdNotesRouteRoute: typeof PrivateCompaniesTemplateIdNotesRouteRoute
  PrivateCompaniesTemplateIdSubscriptionsRouteRoute: typeof PrivateCompaniesTemplateIdSubscriptionsRouteRoute
  PrivateCompaniesTemplateIdSupportIndexRouteRoute: typeof PrivateCompaniesTemplateIdSupportIndexRouteRoute
  PrivateCompaniesTemplateIdSupportTicket_idRouteRoute: typeof PrivateCompaniesTemplateIdSupportTicket_idRouteRoute
}

const PrivateCompaniesTemplateRouteChildren: PrivateCompaniesTemplateRouteChildren =
  {
    PrivateCompaniesTemplateIdIndexRouteRoute:
      PrivateCompaniesTemplateIdIndexRouteRoute,
    PrivateCompaniesTemplateIdAgreementsRouteRoute:
      PrivateCompaniesTemplateIdAgreementsRouteRoute,
    PrivateCompaniesTemplateIdApiIntegrationRouteRoute:
      PrivateCompaniesTemplateIdApiIntegrationRouteRoute,
    PrivateCompaniesTemplateIdContactsRouteRoute:
      PrivateCompaniesTemplateIdContactsRouteRoute,
    PrivateCompaniesTemplateIdDomainsRouteRoute:
      PrivateCompaniesTemplateIdDomainsRouteRoute,
    PrivateCompaniesTemplateIdFinancialsRouteRoute:
      PrivateCompaniesTemplateIdFinancialsRouteRoute,
    PrivateCompaniesTemplateIdInvoiceHistoryRouteRoute:
      PrivateCompaniesTemplateIdInvoiceHistoryRouteRoute,
    PrivateCompaniesTemplateIdMarketingCampaignsRouteRoute:
      PrivateCompaniesTemplateIdMarketingCampaignsRouteRoute,
    PrivateCompaniesTemplateIdNotesRouteRoute:
      PrivateCompaniesTemplateIdNotesRouteRoute,
    PrivateCompaniesTemplateIdSubscriptionsRouteRoute:
      PrivateCompaniesTemplateIdSubscriptionsRouteRoute,
    PrivateCompaniesTemplateIdSupportIndexRouteRoute:
      PrivateCompaniesTemplateIdSupportIndexRouteRoute,
    PrivateCompaniesTemplateIdSupportTicket_idRouteRoute:
      PrivateCompaniesTemplateIdSupportTicket_idRouteRoute,
  }

const PrivateCompaniesTemplateRouteWithChildren =
  PrivateCompaniesTemplateRoute._addFileChildren(
    PrivateCompaniesTemplateRouteChildren,
  )

interface PrivateCompetitorsTemplateRouteChildren {
  PrivateCompetitorsTemplateIdIndexRouteRoute: typeof PrivateCompetitorsTemplateIdIndexRouteRoute
  PrivateCompetitorsTemplateIdAssociatedCompaniesRouteRoute: typeof PrivateCompetitorsTemplateIdAssociatedCompaniesRouteRoute
  PrivateCompetitorsTemplateIdContactsRouteRoute: typeof PrivateCompetitorsTemplateIdContactsRouteRoute
  PrivateCompetitorsTemplateIdNotesRouteRoute: typeof PrivateCompetitorsTemplateIdNotesRouteRoute
}

const PrivateCompetitorsTemplateRouteChildren: PrivateCompetitorsTemplateRouteChildren =
  {
    PrivateCompetitorsTemplateIdIndexRouteRoute:
      PrivateCompetitorsTemplateIdIndexRouteRoute,
    PrivateCompetitorsTemplateIdAssociatedCompaniesRouteRoute:
      PrivateCompetitorsTemplateIdAssociatedCompaniesRouteRoute,
    PrivateCompetitorsTemplateIdContactsRouteRoute:
      PrivateCompetitorsTemplateIdContactsRouteRoute,
    PrivateCompetitorsTemplateIdNotesRouteRoute:
      PrivateCompetitorsTemplateIdNotesRouteRoute,
  }

const PrivateCompetitorsTemplateRouteWithChildren =
  PrivateCompetitorsTemplateRoute._addFileChildren(
    PrivateCompetitorsTemplateRouteChildren,
  )

interface PrivateContactsTemplateRouteChildren {
  PrivateContactsTemplateIdIndexRouteRoute: typeof PrivateContactsTemplateIdIndexRouteRoute
  PrivateContactsTemplateIdAgreementsRouteRoute: typeof PrivateContactsTemplateIdAgreementsRouteRoute
  PrivateContactsTemplateIdApiIntegrationRouteRoute: typeof PrivateContactsTemplateIdApiIntegrationRouteRoute
  PrivateContactsTemplateIdMarketingCampaignsRouteRoute: typeof PrivateContactsTemplateIdMarketingCampaignsRouteRoute
  PrivateContactsTemplateIdNotesRouteRoute: typeof PrivateContactsTemplateIdNotesRouteRoute
  PrivateContactsTemplateIdSupportIndexRouteRoute: typeof PrivateContactsTemplateIdSupportIndexRouteRoute
  PrivateContactsTemplateIdSupportTicket_idRouteRoute: typeof PrivateContactsTemplateIdSupportTicket_idRouteRoute
}

const PrivateContactsTemplateRouteChildren: PrivateContactsTemplateRouteChildren =
  {
    PrivateContactsTemplateIdIndexRouteRoute:
      PrivateContactsTemplateIdIndexRouteRoute,
    PrivateContactsTemplateIdAgreementsRouteRoute:
      PrivateContactsTemplateIdAgreementsRouteRoute,
    PrivateContactsTemplateIdApiIntegrationRouteRoute:
      PrivateContactsTemplateIdApiIntegrationRouteRoute,
    PrivateContactsTemplateIdMarketingCampaignsRouteRoute:
      PrivateContactsTemplateIdMarketingCampaignsRouteRoute,
    PrivateContactsTemplateIdNotesRouteRoute:
      PrivateContactsTemplateIdNotesRouteRoute,
    PrivateContactsTemplateIdSupportIndexRouteRoute:
      PrivateContactsTemplateIdSupportIndexRouteRoute,
    PrivateContactsTemplateIdSupportTicket_idRouteRoute:
      PrivateContactsTemplateIdSupportTicket_idRouteRoute,
  }

const PrivateContactsTemplateRouteWithChildren =
  PrivateContactsTemplateRoute._addFileChildren(
    PrivateContactsTemplateRouteChildren,
  )

interface PrivateInventoryTemplateRouteChildren {
  PrivateInventoryTemplateIdIndexRouteRoute: typeof PrivateInventoryTemplateIdIndexRouteRoute
  PrivateInventoryTemplateIdVendorsRouteRoute: typeof PrivateInventoryTemplateIdVendorsRouteRoute
}

const PrivateInventoryTemplateRouteChildren: PrivateInventoryTemplateRouteChildren =
  {
    PrivateInventoryTemplateIdIndexRouteRoute:
      PrivateInventoryTemplateIdIndexRouteRoute,
    PrivateInventoryTemplateIdVendorsRouteRoute:
      PrivateInventoryTemplateIdVendorsRouteRoute,
  }

const PrivateInventoryTemplateRouteWithChildren =
  PrivateInventoryTemplateRoute._addFileChildren(
    PrivateInventoryTemplateRouteChildren,
  )

interface PrivateTeamMembersTemplateRouteChildren {
  PrivateTeamMembersTemplateIdIndexRouteRoute: typeof PrivateTeamMembersTemplateIdIndexRouteRoute
  PrivateTeamMembersTemplateIdApiIntegrationRouteRoute: typeof PrivateTeamMembersTemplateIdApiIntegrationRouteRoute
  PrivateTeamMembersTemplateIdCommissionPeriodsRouteRoute: typeof PrivateTeamMembersTemplateIdCommissionPeriodsRouteRoute
  PrivateTeamMembersTemplateIdEmergencyRouteRoute: typeof PrivateTeamMembersTemplateIdEmergencyRouteRoute
  PrivateTeamMembersTemplateIdMarketingRouteRoute: typeof PrivateTeamMembersTemplateIdMarketingRouteRoute
  PrivateTeamMembersTemplateIdPersonalDetailsRouteRoute: typeof PrivateTeamMembersTemplateIdPersonalDetailsRouteRoute
  PrivateTeamMembersTemplateIdPreferenceRouteRoute: typeof PrivateTeamMembersTemplateIdPreferenceRouteRoute
}

const PrivateTeamMembersTemplateRouteChildren: PrivateTeamMembersTemplateRouteChildren =
  {
    PrivateTeamMembersTemplateIdIndexRouteRoute:
      PrivateTeamMembersTemplateIdIndexRouteRoute,
    PrivateTeamMembersTemplateIdApiIntegrationRouteRoute:
      PrivateTeamMembersTemplateIdApiIntegrationRouteRoute,
    PrivateTeamMembersTemplateIdCommissionPeriodsRouteRoute:
      PrivateTeamMembersTemplateIdCommissionPeriodsRouteRoute,
    PrivateTeamMembersTemplateIdEmergencyRouteRoute:
      PrivateTeamMembersTemplateIdEmergencyRouteRoute,
    PrivateTeamMembersTemplateIdMarketingRouteRoute:
      PrivateTeamMembersTemplateIdMarketingRouteRoute,
    PrivateTeamMembersTemplateIdPersonalDetailsRouteRoute:
      PrivateTeamMembersTemplateIdPersonalDetailsRouteRoute,
    PrivateTeamMembersTemplateIdPreferenceRouteRoute:
      PrivateTeamMembersTemplateIdPreferenceRouteRoute,
  }

const PrivateTeamMembersTemplateRouteWithChildren =
  PrivateTeamMembersTemplateRoute._addFileChildren(
    PrivateTeamMembersTemplateRouteChildren,
  )

interface PrivateSettingsJobPositionsTemplateRouteChildren {
  PrivateSettingsJobPositionsTemplateIdIndexRouteRoute: typeof PrivateSettingsJobPositionsTemplateIdIndexRouteRoute
  PrivateSettingsJobPositionsTemplateIdAdvertisementRouteRoute: typeof PrivateSettingsJobPositionsTemplateIdAdvertisementRouteRoute
  PrivateSettingsJobPositionsTemplateIdAgreementRouteRoute: typeof PrivateSettingsJobPositionsTemplateIdAgreementRouteRoute
  PrivateSettingsJobPositionsTemplateIdHiringRouteRoute: typeof PrivateSettingsJobPositionsTemplateIdHiringRouteRoute
}

const PrivateSettingsJobPositionsTemplateRouteChildren: PrivateSettingsJobPositionsTemplateRouteChildren =
  {
    PrivateSettingsJobPositionsTemplateIdIndexRouteRoute:
      PrivateSettingsJobPositionsTemplateIdIndexRouteRoute,
    PrivateSettingsJobPositionsTemplateIdAdvertisementRouteRoute:
      PrivateSettingsJobPositionsTemplateIdAdvertisementRouteRoute,
    PrivateSettingsJobPositionsTemplateIdAgreementRouteRoute:
      PrivateSettingsJobPositionsTemplateIdAgreementRouteRoute,
    PrivateSettingsJobPositionsTemplateIdHiringRouteRoute:
      PrivateSettingsJobPositionsTemplateIdHiringRouteRoute,
  }

const PrivateSettingsJobPositionsTemplateRouteWithChildren =
  PrivateSettingsJobPositionsTemplateRoute._addFileChildren(
    PrivateSettingsJobPositionsTemplateRouteChildren,
  )

interface PrivateSettingsRegistrarsTemplateRouteChildren {
  PrivateSettingsRegistrarsTemplateIdIndexRouteRoute: typeof PrivateSettingsRegistrarsTemplateIdIndexRouteRoute
  PrivateSettingsRegistrarsTemplateIdDomainsRouteRoute: typeof PrivateSettingsRegistrarsTemplateIdDomainsRouteRoute
}

const PrivateSettingsRegistrarsTemplateRouteChildren: PrivateSettingsRegistrarsTemplateRouteChildren =
  {
    PrivateSettingsRegistrarsTemplateIdIndexRouteRoute:
      PrivateSettingsRegistrarsTemplateIdIndexRouteRoute,
    PrivateSettingsRegistrarsTemplateIdDomainsRouteRoute:
      PrivateSettingsRegistrarsTemplateIdDomainsRouteRoute,
  }

const PrivateSettingsRegistrarsTemplateRouteWithChildren =
  PrivateSettingsRegistrarsTemplateRoute._addFileChildren(
    PrivateSettingsRegistrarsTemplateRouteChildren,
  )

interface PrivateRouteChildren {
  PrivateAccountReceivablesIndexRouteRoute: typeof PrivateAccountReceivablesIndexRouteRoute
  PrivateAgreementsIndexRouteRoute: typeof PrivateAgreementsIndexRouteRoute
  PrivateAwardsIndexRouteRoute: typeof PrivateAwardsIndexRouteRoute
  PrivateCompaniesIndexRouteRoute: typeof PrivateCompaniesIndexRouteRoute
  PrivateCompetitorsIndexRouteRoute: typeof PrivateCompetitorsIndexRouteRoute
  PrivateConferencesAndEventsIndexRouteRoute: typeof PrivateConferencesAndEventsIndexRouteRoute
  PrivateConnectedAppsIndexRouteRoute: typeof PrivateConnectedAppsIndexRouteRoute
  PrivateContactsIndexRouteRoute: typeof PrivateContactsIndexRouteRoute
  PrivateDashboardIndexRouteRoute: typeof PrivateDashboardIndexRouteRoute
  PrivateDepositsIndexRouteRoute: typeof PrivateDepositsIndexRouteRoute
  PrivateDomainsIndexRouteRoute: typeof PrivateDomainsIndexRouteRoute
  PrivateFinancialSnapshotsIndexRouteRoute: typeof PrivateFinancialSnapshotsIndexRouteRoute
  PrivateGovernanceIndexRouteRoute: typeof PrivateGovernanceIndexRouteRoute
  PrivateInventoryIndexRouteRoute: typeof PrivateInventoryIndexRouteRoute
  PrivateInvoicesIndexRouteRoute: typeof PrivateInvoicesIndexRouteRoute
  PrivateMarketingCampaignsIndexRouteRoute: typeof PrivateMarketingCampaignsIndexRouteRoute
  PrivateMediaIndexRouteRoute: typeof PrivateMediaIndexRouteRoute
  PrivatePickTicketsIndexRouteRoute: typeof PrivatePickTicketsIndexRouteRoute
  PrivateProductsAndServicesIndexRouteRoute: typeof PrivateProductsAndServicesIndexRouteRoute
  PrivateRecruitingIndexRouteRoute: typeof PrivateRecruitingIndexRouteRoute
  PrivateSettingsIndexRouteRoute: typeof PrivateSettingsIndexRouteRoute
  PrivateSupportIndexRouteRoute: typeof PrivateSupportIndexRouteRoute
  PrivateSystemUsersIndexRouteRoute: typeof PrivateSystemUsersIndexRouteRoute
  PrivateTeamMembersIndexRouteRoute: typeof PrivateTeamMembersIndexRouteRoute
  PrivateAccountReceivablesIdRouteRoute: typeof PrivateAccountReceivablesIdRouteRoute
  PrivateAccountReceivablesNewRouteRoute: typeof PrivateAccountReceivablesNewRouteRoute
  PrivateAgreementsNewRouteRoute: typeof PrivateAgreementsNewRouteRoute
  PrivateAwardsIdRouteRoute: typeof PrivateAwardsIdRouteRoute
  PrivateAwardsNewRouteRoute: typeof PrivateAwardsNewRouteRoute
  PrivateCompaniesNewRouteRoute: typeof PrivateCompaniesNewRouteRoute
  PrivateCompetitorsNewRouteRoute: typeof PrivateCompetitorsNewRouteRoute
  PrivateConferencesAndEventsIdRouteRoute: typeof PrivateConferencesAndEventsIdRouteRoute
  PrivateConferencesAndEventsNewRouteRoute: typeof PrivateConferencesAndEventsNewRouteRoute
  PrivateConnectedAppsIdRouteRoute: typeof PrivateConnectedAppsIdRouteRoute
  PrivateConnectedAppsNewRouteRoute: typeof PrivateConnectedAppsNewRouteRoute
  PrivateContactsNewRouteRoute: typeof PrivateContactsNewRouteRoute
  PrivateDepositsIdRouteRoute: typeof PrivateDepositsIdRouteRoute
  PrivateDepositsNewRouteRoute: typeof PrivateDepositsNewRouteRoute
  PrivateDomainsIdRouteRoute: typeof PrivateDomainsIdRouteRoute
  PrivateDomainsNewRouteRoute: typeof PrivateDomainsNewRouteRoute
  PrivateFinancialSnapshotsIdRouteRoute: typeof PrivateFinancialSnapshotsIdRouteRoute
  PrivateFinancialSnapshotsNewRouteRoute: typeof PrivateFinancialSnapshotsNewRouteRoute
  PrivateGovernanceIdRouteRoute: typeof PrivateGovernanceIdRouteRoute
  PrivateGovernanceNewRouteRoute: typeof PrivateGovernanceNewRouteRoute
  PrivateInventoryNewRouteRoute: typeof PrivateInventoryNewRouteRoute
  PrivateInventoryParentNewRouteRoute: typeof PrivateInventoryParentNewRouteRoute
  PrivateInvoicesIdRouteRoute: typeof PrivateInvoicesIdRouteRoute
  PrivateInvoicesNewRouteRoute: typeof PrivateInvoicesNewRouteRoute
  PrivateMarketingCampaignsIdRouteRoute: typeof PrivateMarketingCampaignsIdRouteRoute
  PrivateMarketingCampaignsNewRouteRoute: typeof PrivateMarketingCampaignsNewRouteRoute
  PrivatePendingDepositsIdRouteRoute: typeof PrivatePendingDepositsIdRouteRoute
  PrivatePickTicketsIdRouteRoute: typeof PrivatePickTicketsIdRouteRoute
  PrivatePickTicketsNewRouteRoute: typeof PrivatePickTicketsNewRouteRoute
  PrivateProductsAndServicesIdRouteRoute: typeof PrivateProductsAndServicesIdRouteRoute
  PrivateProductsAndServicesNewRouteRoute: typeof PrivateProductsAndServicesNewRouteRoute
  PrivateRecruitingIdRouteRoute: typeof PrivateRecruitingIdRouteRoute
  PrivateRecruitingNewRouteRoute: typeof PrivateRecruitingNewRouteRoute
  PrivateSettingsRevenueAllocationLockdownOverrideLogsRouteRoute: typeof PrivateSettingsRevenueAllocationLockdownOverrideLogsRouteRoute
  PrivateSettingsViewLogsRouteRoute: typeof PrivateSettingsViewLogsRouteRoute
  PrivateSupportTicket_idRouteRoute: typeof PrivateSupportTicket_idRouteRoute
  PrivateSystemUsersIdRouteRoute: typeof PrivateSystemUsersIdRouteRoute
  PrivateTeamMembersNewRouteRoute: typeof PrivateTeamMembersNewRouteRoute
  PrivateAgreementsTemplateRoute: typeof PrivateAgreementsTemplateRouteWithChildren
  PrivateCompaniesTemplateRoute: typeof PrivateCompaniesTemplateRouteWithChildren
  PrivateCompetitorsTemplateRoute: typeof PrivateCompetitorsTemplateRouteWithChildren
  PrivateContactsTemplateRoute: typeof PrivateContactsTemplateRouteWithChildren
  PrivateInventoryTemplateRoute: typeof PrivateInventoryTemplateRouteWithChildren
  PrivateTeamMembersTemplateRoute: typeof PrivateTeamMembersTemplateRouteWithChildren
  PrivateSettingsAudiencesIndexRouteRoute: typeof PrivateSettingsAudiencesIndexRouteRoute
  PrivateSettingsBankAccountsIndexRouteRoute: typeof PrivateSettingsBankAccountsIndexRouteRoute
  PrivateSettingsBillingSystemsIndexRouteRoute: typeof PrivateSettingsBillingSystemsIndexRouteRoute
  PrivateSettingsBillingTermsIndexRouteRoute: typeof PrivateSettingsBillingTermsIndexRouteRoute
  PrivateSettingsBrandsIndexRouteRoute: typeof PrivateSettingsBrandsIndexRouteRoute
  PrivateSettingsBusinessDisciplinesIndexRouteRoute: typeof PrivateSettingsBusinessDisciplinesIndexRouteRoute
  PrivateSettingsCategoriesIndexRouteRoute: typeof PrivateSettingsCategoriesIndexRouteRoute
  PrivateSettingsCommissionPlansIndexRouteRoute: typeof PrivateSettingsCommissionPlansIndexRouteRoute
  PrivateSettingsCountriesIndexRouteRoute: typeof PrivateSettingsCountriesIndexRouteRoute
  PrivateSettingsDepartmentsIndexRouteRoute: typeof PrivateSettingsDepartmentsIndexRouteRoute
  PrivateSettingsEmailHistoryIndexRouteRoute: typeof PrivateSettingsEmailHistoryIndexRouteRoute
  PrivateSettingsEmailTemplateDefaultsIndexRouteRoute: typeof PrivateSettingsEmailTemplateDefaultsIndexRouteRoute
  PrivateSettingsEmailTemplatesIndexRouteRoute: typeof PrivateSettingsEmailTemplatesIndexRouteRoute
  PrivateSettingsIndustriesIndexRouteRoute: typeof PrivateSettingsIndustriesIndexRouteRoute
  PrivateSettingsInfrastructuresIndexRouteRoute: typeof PrivateSettingsInfrastructuresIndexRouteRoute
  PrivateSettingsInventoryBinLocationsIndexRouteRoute: typeof PrivateSettingsInventoryBinLocationsIndexRouteRoute
  PrivateSettingsInventoryCategoriesIndexRouteRoute: typeof PrivateSettingsInventoryCategoriesIndexRouteRoute
  PrivateSettingsInventoryKitsIndexRouteRoute: typeof PrivateSettingsInventoryKitsIndexRouteRoute
  PrivateSettingsInventoryPurchasesIndexRouteRoute: typeof PrivateSettingsInventoryPurchasesIndexRouteRoute
  PrivateSettingsInventoryStocksIndexRouteRoute: typeof PrivateSettingsInventoryStocksIndexRouteRoute
  PrivateSettingsInventoryVendorsIndexRouteRoute: typeof PrivateSettingsInventoryVendorsIndexRouteRoute
  PrivateSettingsInventoryVolumesIndexRouteRoute: typeof PrivateSettingsInventoryVolumesIndexRouteRoute
  PrivateSettingsJobPositionsIndexRouteRoute: typeof PrivateSettingsJobPositionsIndexRouteRoute
  PrivateSettingsMagazinesIndexRouteRoute: typeof PrivateSettingsMagazinesIndexRouteRoute
  PrivateSettingsManufacturersIndexRouteRoute: typeof PrivateSettingsManufacturersIndexRouteRoute
  PrivateSettingsMileageRatesIndexRouteRoute: typeof PrivateSettingsMileageRatesIndexRouteRoute
  PrivateSettingsOrganizationTypesIndexRouteRoute: typeof PrivateSettingsOrganizationTypesIndexRouteRoute
  PrivateSettingsPartnersIndexRouteRoute: typeof PrivateSettingsPartnersIndexRouteRoute
  PrivateSettingsPaymentMethodsIndexRouteRoute: typeof PrivateSettingsPaymentMethodsIndexRouteRoute
  PrivateSettingsPreferredLocationsIndexRouteRoute: typeof PrivateSettingsPreferredLocationsIndexRouteRoute
  PrivateSettingsPreferredRelationshipsIndexRouteRoute: typeof PrivateSettingsPreferredRelationshipsIndexRouteRoute
  PrivateSettingsPriceFrequenciesIndexRouteRoute: typeof PrivateSettingsPriceFrequenciesIndexRouteRoute
  PrivateSettingsProductsAndServicesTemplatesIndexRouteRoute: typeof PrivateSettingsProductsAndServicesTemplatesIndexRouteRoute
  PrivateSettingsRecruitingHiringCriteriaCategoriesIndexRouteRoute: typeof PrivateSettingsRecruitingHiringCriteriaCategoriesIndexRouteRoute
  PrivateSettingsRecruitingJobCategoriesIndexRouteRoute: typeof PrivateSettingsRecruitingJobCategoriesIndexRouteRoute
  PrivateSettingsRecruitingStatusesIndexRouteRoute: typeof PrivateSettingsRecruitingStatusesIndexRouteRoute
  PrivateSettingsRegistrarsIndexRouteRoute: typeof PrivateSettingsRegistrarsIndexRouteRoute
  PrivateSettingsRelationshipScoresIndexRouteRoute: typeof PrivateSettingsRelationshipScoresIndexRouteRoute
  PrivateSettingsRevenueLockdownsIndexRouteRoute: typeof PrivateSettingsRevenueLockdownsIndexRouteRoute
  PrivateSettingsSalaryGradesIndexRouteRoute: typeof PrivateSettingsSalaryGradesIndexRouteRoute
  PrivateSettingsSystemFilesIndexRouteRoute: typeof PrivateSettingsSystemFilesIndexRouteRoute
  PrivateSettingsTermsCategoriesIndexRouteRoute: typeof PrivateSettingsTermsCategoriesIndexRouteRoute
  PrivateSettingsTermsConditionsIndexRouteRoute: typeof PrivateSettingsTermsConditionsIndexRouteRoute
  PrivateSettingsTermsTemplatesIndexRouteRoute: typeof PrivateSettingsTermsTemplatesIndexRouteRoute
  PrivateSettingsUnitSellBysIndexRouteRoute: typeof PrivateSettingsUnitSellBysIndexRouteRoute
  PrivateSettingsUserRolesIndexRouteRoute: typeof PrivateSettingsUserRolesIndexRouteRoute
  PrivateInventoryParentIdRouteRoute: typeof PrivateInventoryParentIdRouteRoute
  PrivateInvoicesInvoiceBatchIdRouteRoute: typeof PrivateInvoicesInvoiceBatchIdRouteRoute
  PrivateSettingsAudiencesIdRouteRoute: typeof PrivateSettingsAudiencesIdRouteRoute
  PrivateSettingsAudiencesNewRouteRoute: typeof PrivateSettingsAudiencesNewRouteRoute
  PrivateSettingsBankAccountsIdRouteRoute: typeof PrivateSettingsBankAccountsIdRouteRoute
  PrivateSettingsBankAccountsNewRouteRoute: typeof PrivateSettingsBankAccountsNewRouteRoute
  PrivateSettingsBillingSystemsIdRouteRoute: typeof PrivateSettingsBillingSystemsIdRouteRoute
  PrivateSettingsBillingSystemsNewRouteRoute: typeof PrivateSettingsBillingSystemsNewRouteRoute
  PrivateSettingsBillingTermsIdRouteRoute: typeof PrivateSettingsBillingTermsIdRouteRoute
  PrivateSettingsBillingTermsNewRouteRoute: typeof PrivateSettingsBillingTermsNewRouteRoute
  PrivateSettingsBrandsIdRouteRoute: typeof PrivateSettingsBrandsIdRouteRoute
  PrivateSettingsBrandsNewRouteRoute: typeof PrivateSettingsBrandsNewRouteRoute
  PrivateSettingsBusinessDisciplinesIdRouteRoute: typeof PrivateSettingsBusinessDisciplinesIdRouteRoute
  PrivateSettingsBusinessDisciplinesNewRouteRoute: typeof PrivateSettingsBusinessDisciplinesNewRouteRoute
  PrivateSettingsCategoriesIdRouteRoute: typeof PrivateSettingsCategoriesIdRouteRoute
  PrivateSettingsCategoriesNewRouteRoute: typeof PrivateSettingsCategoriesNewRouteRoute
  PrivateSettingsCommissionPlansIdRouteRoute: typeof PrivateSettingsCommissionPlansIdRouteRoute
  PrivateSettingsCommissionPlansNewRouteRoute: typeof PrivateSettingsCommissionPlansNewRouteRoute
  PrivateSettingsCountriesIdRouteRoute: typeof PrivateSettingsCountriesIdRouteRoute
  PrivateSettingsCountriesNewRouteRoute: typeof PrivateSettingsCountriesNewRouteRoute
  PrivateSettingsDepartmentsIdRouteRoute: typeof PrivateSettingsDepartmentsIdRouteRoute
  PrivateSettingsDepartmentsNewRouteRoute: typeof PrivateSettingsDepartmentsNewRouteRoute
  PrivateSettingsEmailHistoryIdRouteRoute: typeof PrivateSettingsEmailHistoryIdRouteRoute
  PrivateSettingsEmailTemplatesIdRouteRoute: typeof PrivateSettingsEmailTemplatesIdRouteRoute
  PrivateSettingsEmailTemplatesNewRouteRoute: typeof PrivateSettingsEmailTemplatesNewRouteRoute
  PrivateSettingsIndustriesIdRouteRoute: typeof PrivateSettingsIndustriesIdRouteRoute
  PrivateSettingsIndustriesNewRouteRoute: typeof PrivateSettingsIndustriesNewRouteRoute
  PrivateSettingsInfrastructuresIdRouteRoute: typeof PrivateSettingsInfrastructuresIdRouteRoute
  PrivateSettingsInfrastructuresNewRouteRoute: typeof PrivateSettingsInfrastructuresNewRouteRoute
  PrivateSettingsInventoryBinLocationsIdRouteRoute: typeof PrivateSettingsInventoryBinLocationsIdRouteRoute
  PrivateSettingsInventoryBinLocationsNewRouteRoute: typeof PrivateSettingsInventoryBinLocationsNewRouteRoute
  PrivateSettingsInventoryCategoriesIdRouteRoute: typeof PrivateSettingsInventoryCategoriesIdRouteRoute
  PrivateSettingsInventoryCategoriesNewRouteRoute: typeof PrivateSettingsInventoryCategoriesNewRouteRoute
  PrivateSettingsInventoryKitsIdRouteRoute: typeof PrivateSettingsInventoryKitsIdRouteRoute
  PrivateSettingsInventoryKitsNewRouteRoute: typeof PrivateSettingsInventoryKitsNewRouteRoute
  PrivateSettingsInventoryPurchasesIdRouteRoute: typeof PrivateSettingsInventoryPurchasesIdRouteRoute
  PrivateSettingsInventoryPurchasesNewRouteRoute: typeof PrivateSettingsInventoryPurchasesNewRouteRoute
  PrivateSettingsInventoryStocksIdRouteRoute: typeof PrivateSettingsInventoryStocksIdRouteRoute
  PrivateSettingsInventoryStocksNewRouteRoute: typeof PrivateSettingsInventoryStocksNewRouteRoute
  PrivateSettingsInventoryVendorsIdRouteRoute: typeof PrivateSettingsInventoryVendorsIdRouteRoute
  PrivateSettingsInventoryVendorsNewRouteRoute: typeof PrivateSettingsInventoryVendorsNewRouteRoute
  PrivateSettingsInventoryVolumesIdRouteRoute: typeof PrivateSettingsInventoryVolumesIdRouteRoute
  PrivateSettingsInventoryVolumesNewRouteRoute: typeof PrivateSettingsInventoryVolumesNewRouteRoute
  PrivateSettingsJobPositionsNewRouteRoute: typeof PrivateSettingsJobPositionsNewRouteRoute
  PrivateSettingsMagazinesIdRouteRoute: typeof PrivateSettingsMagazinesIdRouteRoute
  PrivateSettingsMagazinesNewRouteRoute: typeof PrivateSettingsMagazinesNewRouteRoute
  PrivateSettingsManufacturersIdRouteRoute: typeof PrivateSettingsManufacturersIdRouteRoute
  PrivateSettingsManufacturersNewRouteRoute: typeof PrivateSettingsManufacturersNewRouteRoute
  PrivateSettingsMileageRatesIdRouteRoute: typeof PrivateSettingsMileageRatesIdRouteRoute
  PrivateSettingsMileageRatesNewRouteRoute: typeof PrivateSettingsMileageRatesNewRouteRoute
  PrivateSettingsOrganizationTypesIdRouteRoute: typeof PrivateSettingsOrganizationTypesIdRouteRoute
  PrivateSettingsOrganizationTypesNewRouteRoute: typeof PrivateSettingsOrganizationTypesNewRouteRoute
  PrivateSettingsPartnersIdRouteRoute: typeof PrivateSettingsPartnersIdRouteRoute
  PrivateSettingsPartnersNewRouteRoute: typeof PrivateSettingsPartnersNewRouteRoute
  PrivateSettingsPaymentMethodsIdRouteRoute: typeof PrivateSettingsPaymentMethodsIdRouteRoute
  PrivateSettingsPaymentMethodsNewRouteRoute: typeof PrivateSettingsPaymentMethodsNewRouteRoute
  PrivateSettingsPreferredLocationsIdRouteRoute: typeof PrivateSettingsPreferredLocationsIdRouteRoute
  PrivateSettingsPreferredLocationsNewRouteRoute: typeof PrivateSettingsPreferredLocationsNewRouteRoute
  PrivateSettingsPreferredRelationshipsIdRouteRoute: typeof PrivateSettingsPreferredRelationshipsIdRouteRoute
  PrivateSettingsPreferredRelationshipsNewRouteRoute: typeof PrivateSettingsPreferredRelationshipsNewRouteRoute
  PrivateSettingsPriceFrequenciesIdRouteRoute: typeof PrivateSettingsPriceFrequenciesIdRouteRoute
  PrivateSettingsPriceFrequenciesNewRouteRoute: typeof PrivateSettingsPriceFrequenciesNewRouteRoute
  PrivateSettingsProductsAndServicesTemplatesIdRouteRoute: typeof PrivateSettingsProductsAndServicesTemplatesIdRouteRoute
  PrivateSettingsProductsAndServicesTemplatesNewRouteRoute: typeof PrivateSettingsProductsAndServicesTemplatesNewRouteRoute
  PrivateSettingsRecruitingHiringCriteriaCategoriesIdRouteRoute: typeof PrivateSettingsRecruitingHiringCriteriaCategoriesIdRouteRoute
  PrivateSettingsRecruitingHiringCriteriaCategoriesNewRouteRoute: typeof PrivateSettingsRecruitingHiringCriteriaCategoriesNewRouteRoute
  PrivateSettingsRecruitingJobCategoriesIdRouteRoute: typeof PrivateSettingsRecruitingJobCategoriesIdRouteRoute
  PrivateSettingsRecruitingJobCategoriesNewRouteRoute: typeof PrivateSettingsRecruitingJobCategoriesNewRouteRoute
  PrivateSettingsRecruitingStatusesIdRouteRoute: typeof PrivateSettingsRecruitingStatusesIdRouteRoute
  PrivateSettingsRecruitingStatusesNewRouteRoute: typeof PrivateSettingsRecruitingStatusesNewRouteRoute
  PrivateSettingsRegistrarsNewRouteRoute: typeof PrivateSettingsRegistrarsNewRouteRoute
  PrivateSettingsRelationshipScoresIdRouteRoute: typeof PrivateSettingsRelationshipScoresIdRouteRoute
  PrivateSettingsRelationshipScoresNewRouteRoute: typeof PrivateSettingsRelationshipScoresNewRouteRoute
  PrivateSettingsRevenueLockdownsIdRouteRoute: typeof PrivateSettingsRevenueLockdownsIdRouteRoute
  PrivateSettingsRevenueLockdownsNewRouteRoute: typeof PrivateSettingsRevenueLockdownsNewRouteRoute
  PrivateSettingsSalaryGradesIdRouteRoute: typeof PrivateSettingsSalaryGradesIdRouteRoute
  PrivateSettingsSalaryGradesNewRouteRoute: typeof PrivateSettingsSalaryGradesNewRouteRoute
  PrivateSettingsSystemFilesIdRouteRoute: typeof PrivateSettingsSystemFilesIdRouteRoute
  PrivateSettingsSystemFilesNewRouteRoute: typeof PrivateSettingsSystemFilesNewRouteRoute
  PrivateSettingsTermsCategoriesIdRouteRoute: typeof PrivateSettingsTermsCategoriesIdRouteRoute
  PrivateSettingsTermsCategoriesNewRouteRoute: typeof PrivateSettingsTermsCategoriesNewRouteRoute
  PrivateSettingsTermsConditionsIdRouteRoute: typeof PrivateSettingsTermsConditionsIdRouteRoute
  PrivateSettingsTermsConditionsNewRouteRoute: typeof PrivateSettingsTermsConditionsNewRouteRoute
  PrivateSettingsTermsTemplatesIdRouteRoute: typeof PrivateSettingsTermsTemplatesIdRouteRoute
  PrivateSettingsTermsTemplatesNewRouteRoute: typeof PrivateSettingsTermsTemplatesNewRouteRoute
  PrivateSettingsUnitSellBysIdRouteRoute: typeof PrivateSettingsUnitSellBysIdRouteRoute
  PrivateSettingsUnitSellBysNewRouteRoute: typeof PrivateSettingsUnitSellBysNewRouteRoute
  PrivateSettingsUserRolesIdRouteRoute: typeof PrivateSettingsUserRolesIdRouteRoute
  PrivateSettingsUserRolesNewRouteRoute: typeof PrivateSettingsUserRolesNewRouteRoute
  PrivateSettingsJobPositionsTemplateRoute: typeof PrivateSettingsJobPositionsTemplateRouteWithChildren
  PrivateSettingsRegistrarsTemplateRoute: typeof PrivateSettingsRegistrarsTemplateRouteWithChildren
}

const PrivateRouteChildren: PrivateRouteChildren = {
  PrivateAccountReceivablesIndexRouteRoute:
    PrivateAccountReceivablesIndexRouteRoute,
  PrivateAgreementsIndexRouteRoute: PrivateAgreementsIndexRouteRoute,
  PrivateAwardsIndexRouteRoute: PrivateAwardsIndexRouteRoute,
  PrivateCompaniesIndexRouteRoute: PrivateCompaniesIndexRouteRoute,
  PrivateCompetitorsIndexRouteRoute: PrivateCompetitorsIndexRouteRoute,
  PrivateConferencesAndEventsIndexRouteRoute:
    PrivateConferencesAndEventsIndexRouteRoute,
  PrivateConnectedAppsIndexRouteRoute: PrivateConnectedAppsIndexRouteRoute,
  PrivateContactsIndexRouteRoute: PrivateContactsIndexRouteRoute,
  PrivateDashboardIndexRouteRoute: PrivateDashboardIndexRouteRoute,
  PrivateDepositsIndexRouteRoute: PrivateDepositsIndexRouteRoute,
  PrivateDomainsIndexRouteRoute: PrivateDomainsIndexRouteRoute,
  PrivateFinancialSnapshotsIndexRouteRoute:
    PrivateFinancialSnapshotsIndexRouteRoute,
  PrivateGovernanceIndexRouteRoute: PrivateGovernanceIndexRouteRoute,
  PrivateInventoryIndexRouteRoute: PrivateInventoryIndexRouteRoute,
  PrivateInvoicesIndexRouteRoute: PrivateInvoicesIndexRouteRoute,
  PrivateMarketingCampaignsIndexRouteRoute:
    PrivateMarketingCampaignsIndexRouteRoute,
  PrivateMediaIndexRouteRoute: PrivateMediaIndexRouteRoute,
  PrivatePickTicketsIndexRouteRoute: PrivatePickTicketsIndexRouteRoute,
  PrivateProductsAndServicesIndexRouteRoute:
    PrivateProductsAndServicesIndexRouteRoute,
  PrivateRecruitingIndexRouteRoute: PrivateRecruitingIndexRouteRoute,
  PrivateSettingsIndexRouteRoute: PrivateSettingsIndexRouteRoute,
  PrivateSupportIndexRouteRoute: PrivateSupportIndexRouteRoute,
  PrivateSystemUsersIndexRouteRoute: PrivateSystemUsersIndexRouteRoute,
  PrivateTeamMembersIndexRouteRoute: PrivateTeamMembersIndexRouteRoute,
  PrivateAccountReceivablesIdRouteRoute: PrivateAccountReceivablesIdRouteRoute,
  PrivateAccountReceivablesNewRouteRoute:
    PrivateAccountReceivablesNewRouteRoute,
  PrivateAgreementsNewRouteRoute: PrivateAgreementsNewRouteRoute,
  PrivateAwardsIdRouteRoute: PrivateAwardsIdRouteRoute,
  PrivateAwardsNewRouteRoute: PrivateAwardsNewRouteRoute,
  PrivateCompaniesNewRouteRoute: PrivateCompaniesNewRouteRoute,
  PrivateCompetitorsNewRouteRoute: PrivateCompetitorsNewRouteRoute,
  PrivateConferencesAndEventsIdRouteRoute:
    PrivateConferencesAndEventsIdRouteRoute,
  PrivateConferencesAndEventsNewRouteRoute:
    PrivateConferencesAndEventsNewRouteRoute,
  PrivateConnectedAppsIdRouteRoute: PrivateConnectedAppsIdRouteRoute,
  PrivateConnectedAppsNewRouteRoute: PrivateConnectedAppsNewRouteRoute,
  PrivateContactsNewRouteRoute: PrivateContactsNewRouteRoute,
  PrivateDepositsIdRouteRoute: PrivateDepositsIdRouteRoute,
  PrivateDepositsNewRouteRoute: PrivateDepositsNewRouteRoute,
  PrivateDomainsIdRouteRoute: PrivateDomainsIdRouteRoute,
  PrivateDomainsNewRouteRoute: PrivateDomainsNewRouteRoute,
  PrivateFinancialSnapshotsIdRouteRoute: PrivateFinancialSnapshotsIdRouteRoute,
  PrivateFinancialSnapshotsNewRouteRoute:
    PrivateFinancialSnapshotsNewRouteRoute,
  PrivateGovernanceIdRouteRoute: PrivateGovernanceIdRouteRoute,
  PrivateGovernanceNewRouteRoute: PrivateGovernanceNewRouteRoute,
  PrivateInventoryNewRouteRoute: PrivateInventoryNewRouteRoute,
  PrivateInventoryParentNewRouteRoute: PrivateInventoryParentNewRouteRoute,
  PrivateInvoicesIdRouteRoute: PrivateInvoicesIdRouteRoute,
  PrivateInvoicesNewRouteRoute: PrivateInvoicesNewRouteRoute,
  PrivateMarketingCampaignsIdRouteRoute: PrivateMarketingCampaignsIdRouteRoute,
  PrivateMarketingCampaignsNewRouteRoute:
    PrivateMarketingCampaignsNewRouteRoute,
  PrivatePendingDepositsIdRouteRoute: PrivatePendingDepositsIdRouteRoute,
  PrivatePickTicketsIdRouteRoute: PrivatePickTicketsIdRouteRoute,
  PrivatePickTicketsNewRouteRoute: PrivatePickTicketsNewRouteRoute,
  PrivateProductsAndServicesIdRouteRoute:
    PrivateProductsAndServicesIdRouteRoute,
  PrivateProductsAndServicesNewRouteRoute:
    PrivateProductsAndServicesNewRouteRoute,
  PrivateRecruitingIdRouteRoute: PrivateRecruitingIdRouteRoute,
  PrivateRecruitingNewRouteRoute: PrivateRecruitingNewRouteRoute,
  PrivateSettingsRevenueAllocationLockdownOverrideLogsRouteRoute:
    PrivateSettingsRevenueAllocationLockdownOverrideLogsRouteRoute,
  PrivateSettingsViewLogsRouteRoute: PrivateSettingsViewLogsRouteRoute,
  PrivateSupportTicket_idRouteRoute: PrivateSupportTicket_idRouteRoute,
  PrivateSystemUsersIdRouteRoute: PrivateSystemUsersIdRouteRoute,
  PrivateTeamMembersNewRouteRoute: PrivateTeamMembersNewRouteRoute,
  PrivateAgreementsTemplateRoute: PrivateAgreementsTemplateRouteWithChildren,
  PrivateCompaniesTemplateRoute: PrivateCompaniesTemplateRouteWithChildren,
  PrivateCompetitorsTemplateRoute: PrivateCompetitorsTemplateRouteWithChildren,
  PrivateContactsTemplateRoute: PrivateContactsTemplateRouteWithChildren,
  PrivateInventoryTemplateRoute: PrivateInventoryTemplateRouteWithChildren,
  PrivateTeamMembersTemplateRoute: PrivateTeamMembersTemplateRouteWithChildren,
  PrivateSettingsAudiencesIndexRouteRoute:
    PrivateSettingsAudiencesIndexRouteRoute,
  PrivateSettingsBankAccountsIndexRouteRoute:
    PrivateSettingsBankAccountsIndexRouteRoute,
  PrivateSettingsBillingSystemsIndexRouteRoute:
    PrivateSettingsBillingSystemsIndexRouteRoute,
  PrivateSettingsBillingTermsIndexRouteRoute:
    PrivateSettingsBillingTermsIndexRouteRoute,
  PrivateSettingsBrandsIndexRouteRoute: PrivateSettingsBrandsIndexRouteRoute,
  PrivateSettingsBusinessDisciplinesIndexRouteRoute:
    PrivateSettingsBusinessDisciplinesIndexRouteRoute,
  PrivateSettingsCategoriesIndexRouteRoute:
    PrivateSettingsCategoriesIndexRouteRoute,
  PrivateSettingsCommissionPlansIndexRouteRoute:
    PrivateSettingsCommissionPlansIndexRouteRoute,
  PrivateSettingsCountriesIndexRouteRoute:
    PrivateSettingsCountriesIndexRouteRoute,
  PrivateSettingsDepartmentsIndexRouteRoute:
    PrivateSettingsDepartmentsIndexRouteRoute,
  PrivateSettingsEmailHistoryIndexRouteRoute:
    PrivateSettingsEmailHistoryIndexRouteRoute,
  PrivateSettingsEmailTemplateDefaultsIndexRouteRoute:
    PrivateSettingsEmailTemplateDefaultsIndexRouteRoute,
  PrivateSettingsEmailTemplatesIndexRouteRoute:
    PrivateSettingsEmailTemplatesIndexRouteRoute,
  PrivateSettingsIndustriesIndexRouteRoute:
    PrivateSettingsIndustriesIndexRouteRoute,
  PrivateSettingsInfrastructuresIndexRouteRoute:
    PrivateSettingsInfrastructuresIndexRouteRoute,
  PrivateSettingsInventoryBinLocationsIndexRouteRoute:
    PrivateSettingsInventoryBinLocationsIndexRouteRoute,
  PrivateSettingsInventoryCategoriesIndexRouteRoute:
    PrivateSettingsInventoryCategoriesIndexRouteRoute,
  PrivateSettingsInventoryKitsIndexRouteRoute:
    PrivateSettingsInventoryKitsIndexRouteRoute,
  PrivateSettingsInventoryPurchasesIndexRouteRoute:
    PrivateSettingsInventoryPurchasesIndexRouteRoute,
  PrivateSettingsInventoryStocksIndexRouteRoute:
    PrivateSettingsInventoryStocksIndexRouteRoute,
  PrivateSettingsInventoryVendorsIndexRouteRoute:
    PrivateSettingsInventoryVendorsIndexRouteRoute,
  PrivateSettingsInventoryVolumesIndexRouteRoute:
    PrivateSettingsInventoryVolumesIndexRouteRoute,
  PrivateSettingsJobPositionsIndexRouteRoute:
    PrivateSettingsJobPositionsIndexRouteRoute,
  PrivateSettingsMagazinesIndexRouteRoute:
    PrivateSettingsMagazinesIndexRouteRoute,
  PrivateSettingsManufacturersIndexRouteRoute:
    PrivateSettingsManufacturersIndexRouteRoute,
  PrivateSettingsMileageRatesIndexRouteRoute:
    PrivateSettingsMileageRatesIndexRouteRoute,
  PrivateSettingsOrganizationTypesIndexRouteRoute:
    PrivateSettingsOrganizationTypesIndexRouteRoute,
  PrivateSettingsPartnersIndexRouteRoute:
    PrivateSettingsPartnersIndexRouteRoute,
  PrivateSettingsPaymentMethodsIndexRouteRoute:
    PrivateSettingsPaymentMethodsIndexRouteRoute,
  PrivateSettingsPreferredLocationsIndexRouteRoute:
    PrivateSettingsPreferredLocationsIndexRouteRoute,
  PrivateSettingsPreferredRelationshipsIndexRouteRoute:
    PrivateSettingsPreferredRelationshipsIndexRouteRoute,
  PrivateSettingsPriceFrequenciesIndexRouteRoute:
    PrivateSettingsPriceFrequenciesIndexRouteRoute,
  PrivateSettingsProductsAndServicesTemplatesIndexRouteRoute:
    PrivateSettingsProductsAndServicesTemplatesIndexRouteRoute,
  PrivateSettingsRecruitingHiringCriteriaCategoriesIndexRouteRoute:
    PrivateSettingsRecruitingHiringCriteriaCategoriesIndexRouteRoute,
  PrivateSettingsRecruitingJobCategoriesIndexRouteRoute:
    PrivateSettingsRecruitingJobCategoriesIndexRouteRoute,
  PrivateSettingsRecruitingStatusesIndexRouteRoute:
    PrivateSettingsRecruitingStatusesIndexRouteRoute,
  PrivateSettingsRegistrarsIndexRouteRoute:
    PrivateSettingsRegistrarsIndexRouteRoute,
  PrivateSettingsRelationshipScoresIndexRouteRoute:
    PrivateSettingsRelationshipScoresIndexRouteRoute,
  PrivateSettingsRevenueLockdownsIndexRouteRoute:
    PrivateSettingsRevenueLockdownsIndexRouteRoute,
  PrivateSettingsSalaryGradesIndexRouteRoute:
    PrivateSettingsSalaryGradesIndexRouteRoute,
  PrivateSettingsSystemFilesIndexRouteRoute:
    PrivateSettingsSystemFilesIndexRouteRoute,
  PrivateSettingsTermsCategoriesIndexRouteRoute:
    PrivateSettingsTermsCategoriesIndexRouteRoute,
  PrivateSettingsTermsConditionsIndexRouteRoute:
    PrivateSettingsTermsConditionsIndexRouteRoute,
  PrivateSettingsTermsTemplatesIndexRouteRoute:
    PrivateSettingsTermsTemplatesIndexRouteRoute,
  PrivateSettingsUnitSellBysIndexRouteRoute:
    PrivateSettingsUnitSellBysIndexRouteRoute,
  PrivateSettingsUserRolesIndexRouteRoute:
    PrivateSettingsUserRolesIndexRouteRoute,
  PrivateInventoryParentIdRouteRoute: PrivateInventoryParentIdRouteRoute,
  PrivateInvoicesInvoiceBatchIdRouteRoute:
    PrivateInvoicesInvoiceBatchIdRouteRoute,
  PrivateSettingsAudiencesIdRouteRoute: PrivateSettingsAudiencesIdRouteRoute,
  PrivateSettingsAudiencesNewRouteRoute: PrivateSettingsAudiencesNewRouteRoute,
  PrivateSettingsBankAccountsIdRouteRoute:
    PrivateSettingsBankAccountsIdRouteRoute,
  PrivateSettingsBankAccountsNewRouteRoute:
    PrivateSettingsBankAccountsNewRouteRoute,
  PrivateSettingsBillingSystemsIdRouteRoute:
    PrivateSettingsBillingSystemsIdRouteRoute,
  PrivateSettingsBillingSystemsNewRouteRoute:
    PrivateSettingsBillingSystemsNewRouteRoute,
  PrivateSettingsBillingTermsIdRouteRoute:
    PrivateSettingsBillingTermsIdRouteRoute,
  PrivateSettingsBillingTermsNewRouteRoute:
    PrivateSettingsBillingTermsNewRouteRoute,
  PrivateSettingsBrandsIdRouteRoute: PrivateSettingsBrandsIdRouteRoute,
  PrivateSettingsBrandsNewRouteRoute: PrivateSettingsBrandsNewRouteRoute,
  PrivateSettingsBusinessDisciplinesIdRouteRoute:
    PrivateSettingsBusinessDisciplinesIdRouteRoute,
  PrivateSettingsBusinessDisciplinesNewRouteRoute:
    PrivateSettingsBusinessDisciplinesNewRouteRoute,
  PrivateSettingsCategoriesIdRouteRoute: PrivateSettingsCategoriesIdRouteRoute,
  PrivateSettingsCategoriesNewRouteRoute:
    PrivateSettingsCategoriesNewRouteRoute,
  PrivateSettingsCommissionPlansIdRouteRoute:
    PrivateSettingsCommissionPlansIdRouteRoute,
  PrivateSettingsCommissionPlansNewRouteRoute:
    PrivateSettingsCommissionPlansNewRouteRoute,
  PrivateSettingsCountriesIdRouteRoute: PrivateSettingsCountriesIdRouteRoute,
  PrivateSettingsCountriesNewRouteRoute: PrivateSettingsCountriesNewRouteRoute,
  PrivateSettingsDepartmentsIdRouteRoute:
    PrivateSettingsDepartmentsIdRouteRoute,
  PrivateSettingsDepartmentsNewRouteRoute:
    PrivateSettingsDepartmentsNewRouteRoute,
  PrivateSettingsEmailHistoryIdRouteRoute:
    PrivateSettingsEmailHistoryIdRouteRoute,
  PrivateSettingsEmailTemplatesIdRouteRoute:
    PrivateSettingsEmailTemplatesIdRouteRoute,
  PrivateSettingsEmailTemplatesNewRouteRoute:
    PrivateSettingsEmailTemplatesNewRouteRoute,
  PrivateSettingsIndustriesIdRouteRoute: PrivateSettingsIndustriesIdRouteRoute,
  PrivateSettingsIndustriesNewRouteRoute:
    PrivateSettingsIndustriesNewRouteRoute,
  PrivateSettingsInfrastructuresIdRouteRoute:
    PrivateSettingsInfrastructuresIdRouteRoute,
  PrivateSettingsInfrastructuresNewRouteRoute:
    PrivateSettingsInfrastructuresNewRouteRoute,
  PrivateSettingsInventoryBinLocationsIdRouteRoute:
    PrivateSettingsInventoryBinLocationsIdRouteRoute,
  PrivateSettingsInventoryBinLocationsNewRouteRoute:
    PrivateSettingsInventoryBinLocationsNewRouteRoute,
  PrivateSettingsInventoryCategoriesIdRouteRoute:
    PrivateSettingsInventoryCategoriesIdRouteRoute,
  PrivateSettingsInventoryCategoriesNewRouteRoute:
    PrivateSettingsInventoryCategoriesNewRouteRoute,
  PrivateSettingsInventoryKitsIdRouteRoute:
    PrivateSettingsInventoryKitsIdRouteRoute,
  PrivateSettingsInventoryKitsNewRouteRoute:
    PrivateSettingsInventoryKitsNewRouteRoute,
  PrivateSettingsInventoryPurchasesIdRouteRoute:
    PrivateSettingsInventoryPurchasesIdRouteRoute,
  PrivateSettingsInventoryPurchasesNewRouteRoute:
    PrivateSettingsInventoryPurchasesNewRouteRoute,
  PrivateSettingsInventoryStocksIdRouteRoute:
    PrivateSettingsInventoryStocksIdRouteRoute,
  PrivateSettingsInventoryStocksNewRouteRoute:
    PrivateSettingsInventoryStocksNewRouteRoute,
  PrivateSettingsInventoryVendorsIdRouteRoute:
    PrivateSettingsInventoryVendorsIdRouteRoute,
  PrivateSettingsInventoryVendorsNewRouteRoute:
    PrivateSettingsInventoryVendorsNewRouteRoute,
  PrivateSettingsInventoryVolumesIdRouteRoute:
    PrivateSettingsInventoryVolumesIdRouteRoute,
  PrivateSettingsInventoryVolumesNewRouteRoute:
    PrivateSettingsInventoryVolumesNewRouteRoute,
  PrivateSettingsJobPositionsNewRouteRoute:
    PrivateSettingsJobPositionsNewRouteRoute,
  PrivateSettingsMagazinesIdRouteRoute: PrivateSettingsMagazinesIdRouteRoute,
  PrivateSettingsMagazinesNewRouteRoute: PrivateSettingsMagazinesNewRouteRoute,
  PrivateSettingsManufacturersIdRouteRoute:
    PrivateSettingsManufacturersIdRouteRoute,
  PrivateSettingsManufacturersNewRouteRoute:
    PrivateSettingsManufacturersNewRouteRoute,
  PrivateSettingsMileageRatesIdRouteRoute:
    PrivateSettingsMileageRatesIdRouteRoute,
  PrivateSettingsMileageRatesNewRouteRoute:
    PrivateSettingsMileageRatesNewRouteRoute,
  PrivateSettingsOrganizationTypesIdRouteRoute:
    PrivateSettingsOrganizationTypesIdRouteRoute,
  PrivateSettingsOrganizationTypesNewRouteRoute:
    PrivateSettingsOrganizationTypesNewRouteRoute,
  PrivateSettingsPartnersIdRouteRoute: PrivateSettingsPartnersIdRouteRoute,
  PrivateSettingsPartnersNewRouteRoute: PrivateSettingsPartnersNewRouteRoute,
  PrivateSettingsPaymentMethodsIdRouteRoute:
    PrivateSettingsPaymentMethodsIdRouteRoute,
  PrivateSettingsPaymentMethodsNewRouteRoute:
    PrivateSettingsPaymentMethodsNewRouteRoute,
  PrivateSettingsPreferredLocationsIdRouteRoute:
    PrivateSettingsPreferredLocationsIdRouteRoute,
  PrivateSettingsPreferredLocationsNewRouteRoute:
    PrivateSettingsPreferredLocationsNewRouteRoute,
  PrivateSettingsPreferredRelationshipsIdRouteRoute:
    PrivateSettingsPreferredRelationshipsIdRouteRoute,
  PrivateSettingsPreferredRelationshipsNewRouteRoute:
    PrivateSettingsPreferredRelationshipsNewRouteRoute,
  PrivateSettingsPriceFrequenciesIdRouteRoute:
    PrivateSettingsPriceFrequenciesIdRouteRoute,
  PrivateSettingsPriceFrequenciesNewRouteRoute:
    PrivateSettingsPriceFrequenciesNewRouteRoute,
  PrivateSettingsProductsAndServicesTemplatesIdRouteRoute:
    PrivateSettingsProductsAndServicesTemplatesIdRouteRoute,
  PrivateSettingsProductsAndServicesTemplatesNewRouteRoute:
    PrivateSettingsProductsAndServicesTemplatesNewRouteRoute,
  PrivateSettingsRecruitingHiringCriteriaCategoriesIdRouteRoute:
    PrivateSettingsRecruitingHiringCriteriaCategoriesIdRouteRoute,
  PrivateSettingsRecruitingHiringCriteriaCategoriesNewRouteRoute:
    PrivateSettingsRecruitingHiringCriteriaCategoriesNewRouteRoute,
  PrivateSettingsRecruitingJobCategoriesIdRouteRoute:
    PrivateSettingsRecruitingJobCategoriesIdRouteRoute,
  PrivateSettingsRecruitingJobCategoriesNewRouteRoute:
    PrivateSettingsRecruitingJobCategoriesNewRouteRoute,
  PrivateSettingsRecruitingStatusesIdRouteRoute:
    PrivateSettingsRecruitingStatusesIdRouteRoute,
  PrivateSettingsRecruitingStatusesNewRouteRoute:
    PrivateSettingsRecruitingStatusesNewRouteRoute,
  PrivateSettingsRegistrarsNewRouteRoute:
    PrivateSettingsRegistrarsNewRouteRoute,
  PrivateSettingsRelationshipScoresIdRouteRoute:
    PrivateSettingsRelationshipScoresIdRouteRoute,
  PrivateSettingsRelationshipScoresNewRouteRoute:
    PrivateSettingsRelationshipScoresNewRouteRoute,
  PrivateSettingsRevenueLockdownsIdRouteRoute:
    PrivateSettingsRevenueLockdownsIdRouteRoute,
  PrivateSettingsRevenueLockdownsNewRouteRoute:
    PrivateSettingsRevenueLockdownsNewRouteRoute,
  PrivateSettingsSalaryGradesIdRouteRoute:
    PrivateSettingsSalaryGradesIdRouteRoute,
  PrivateSettingsSalaryGradesNewRouteRoute:
    PrivateSettingsSalaryGradesNewRouteRoute,
  PrivateSettingsSystemFilesIdRouteRoute:
    PrivateSettingsSystemFilesIdRouteRoute,
  PrivateSettingsSystemFilesNewRouteRoute:
    PrivateSettingsSystemFilesNewRouteRoute,
  PrivateSettingsTermsCategoriesIdRouteRoute:
    PrivateSettingsTermsCategoriesIdRouteRoute,
  PrivateSettingsTermsCategoriesNewRouteRoute:
    PrivateSettingsTermsCategoriesNewRouteRoute,
  PrivateSettingsTermsConditionsIdRouteRoute:
    PrivateSettingsTermsConditionsIdRouteRoute,
  PrivateSettingsTermsConditionsNewRouteRoute:
    PrivateSettingsTermsConditionsNewRouteRoute,
  PrivateSettingsTermsTemplatesIdRouteRoute:
    PrivateSettingsTermsTemplatesIdRouteRoute,
  PrivateSettingsTermsTemplatesNewRouteRoute:
    PrivateSettingsTermsTemplatesNewRouteRoute,
  PrivateSettingsUnitSellBysIdRouteRoute:
    PrivateSettingsUnitSellBysIdRouteRoute,
  PrivateSettingsUnitSellBysNewRouteRoute:
    PrivateSettingsUnitSellBysNewRouteRoute,
  PrivateSettingsUserRolesIdRouteRoute: PrivateSettingsUserRolesIdRouteRoute,
  PrivateSettingsUserRolesNewRouteRoute: PrivateSettingsUserRolesNewRouteRoute,
  PrivateSettingsJobPositionsTemplateRoute:
    PrivateSettingsJobPositionsTemplateRouteWithChildren,
  PrivateSettingsRegistrarsTemplateRoute:
    PrivateSettingsRegistrarsTemplateRouteWithChildren,
}

const PrivateRouteWithChildren =
  PrivateRoute._addFileChildren(PrivateRouteChildren)

interface PublicRouteChildren {
  PublicForgotPasswordIndexRouteRoute: typeof PublicForgotPasswordIndexRouteRoute
  PublicLoginIndexRouteRoute: typeof PublicLoginIndexRouteRoute
  PublicResetPasswordIndexRouteRoute: typeof PublicResetPasswordIndexRouteRoute
  PublicSignupIndexRouteRoute: typeof PublicSignupIndexRouteRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicForgotPasswordIndexRouteRoute: PublicForgotPasswordIndexRouteRoute,
  PublicLoginIndexRouteRoute: PublicLoginIndexRouteRoute,
  PublicResetPasswordIndexRouteRoute: PublicResetPasswordIndexRouteRoute,
  PublicSignupIndexRouteRoute: PublicSignupIndexRouteRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TestRouteRoute: TestRouteRoute,
  PrivateRoute: PrivateRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  AuthIndexRoute: AuthIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
